/**
 * VIETSTEM-API
 * VIETSTEM-API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as querystring from "querystring";
import * as url from "url";
import { UrlApi } from "../../components/common/function/constant";
// import * as isomorphicFetch from 'isomorphic-fetch';
var isomorphicFetch = require("isomorphic-fetch");
var assign = require("core-js/library/fn/object/assign");
// const BASE_PATH = "https://apivietstem.vfastsoft.com/api".replace(/\/+$/, "");
var BASE_PATH = UrlApi.replace(/\/+$/, "");
var BaseAPI = /** @class */ (function () {
    function BaseAPI(fetch, basePath) {
        if (fetch === void 0) { fetch = isomorphicFetch; }
        if (basePath === void 0) { basePath = BASE_PATH; }
        this.basePath = basePath;
        this.fetch = fetch;
    }
    return BaseAPI;
}());
export { BaseAPI };
/**
 * AccountApi - fetch parameter creator
 */
export var AccountApiFetchParamCreator = {
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    accountChangePassword: function (params, options) {
        // verify required parameter "oldPassword" is set
        if (params["oldPassword"] == null) {
            throw new Error("Missing required parameter oldPassword when calling accountChangePassword");
        }
        // verify required parameter "newPassword" is set
        if (params["newPassword"] == null) {
            throw new Error("Missing required parameter newPassword when calling accountChangePassword");
        }
        var baseUrl = "/Accounts/change-password";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            oldPassword: params["oldPassword"],
            newPassword: params["newPassword"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    accountConfirm: function (params, options) {
        // verify required parameter "uid" is set
        if (params["uid"] == null) {
            throw new Error("Missing required parameter uid when calling accountConfirm");
        }
        // verify required parameter "token" is set
        if (params["token"] == null) {
            throw new Error("Missing required parameter token when calling accountConfirm");
        }
        var baseUrl = "/Accounts/confirm";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            uid: params["uid"],
            token: params["token"],
            redirect: params["redirect"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    accountCount: function (params, options) {
        var baseUrl = "/Accounts/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    accountCreate: function (params, options) {
        var baseUrl = "/Accounts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountCreateChangeStreamGetAccountsChangeStream: function (params, options) {
        var baseUrl = "/Accounts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountCreateChangeStreamPostAccountsChangeStream: function (params, options) {
        var baseUrl = "/Accounts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    accountDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountDeleteById");
        }
        var baseUrl = "/Accounts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountExistsGetAccountsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountExistsGetAccountsidExists");
        }
        var baseUrl = "/Accounts/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountExistsHeadAccountsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountExistsHeadAccountsid");
        }
        var baseUrl = "/Accounts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountFind: function (params, options) {
        var baseUrl = "/Accounts";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    accountFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountFindById");
        }
        var baseUrl = "/Accounts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountFindOne: function (params, options) {
        var baseUrl = "/Accounts/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    accountLogin: function (params, options) {
        // verify required parameter "credentials" is set
        if (params["credentials"] == null) {
            throw new Error("Missing required parameter credentials when calling accountLogin");
        }
        var baseUrl = "/Accounts/login";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            include: params["include"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["credentials"]) {
            fetchOptions.body = JSON.stringify(params["credentials"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Logout a user with access token.
     */
    accountLogout: function (options) {
        var baseUrl = "/Accounts/logout";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountPatchOrCreate: function (params, options) {
        var baseUrl = "/Accounts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts accessTokens of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts contestGuides of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts contests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountContests");
        }
        var baseUrl = "/Accounts/{id}/contests/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts exams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountExams");
        }
        var baseUrl = "/Accounts/{id}/exams/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts help of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountHelp");
        }
        var baseUrl = "/Accounts/{id}/help/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts keys of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountKeys");
        }
        var baseUrl = "/Accounts/{id}/keys/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts notifications of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts question of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountQuestion");
        }
        var baseUrl = "/Accounts/{id}/question/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts questionType of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts roles of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts rounds of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts submitExams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts tests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCountTests");
        }
        var baseUrl = "/Accounts/{id}/tests/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in contests of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateContests");
        }
        var baseUrl = "/Accounts/{id}/contests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in exams of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateExams");
        }
        var baseUrl = "/Accounts/{id}/exams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in help of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateHelp");
        }
        var baseUrl = "/Accounts/{id}/help".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in keys of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateKeys");
        }
        var baseUrl = "/Accounts/{id}/keys".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in notifications of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in question of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateQuestion");
        }
        var baseUrl = "/Accounts/{id}/question".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in questionType of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in roles of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateRoles");
        }
        var baseUrl = "/Accounts/{id}/roles".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in tests of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeCreateTests");
        }
        var baseUrl = "/Accounts/{id}/tests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id Account id
     */
    accountPrototypeDeleteAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Account id
     */
    accountPrototypeDeleteContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all contests of this model.
     * @param id Account id
     */
    accountPrototypeDeleteContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteContests");
        }
        var baseUrl = "/Accounts/{id}/contests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all exams of this model.
     * @param id Account id
     */
    accountPrototypeDeleteExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteExams");
        }
        var baseUrl = "/Accounts/{id}/exams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all help of this model.
     * @param id Account id
     */
    accountPrototypeDeleteHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteHelp");
        }
        var baseUrl = "/Accounts/{id}/help".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all keys of this model.
     * @param id Account id
     */
    accountPrototypeDeleteKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteKeys");
        }
        var baseUrl = "/Accounts/{id}/keys".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all notifications of this model.
     * @param id Account id
     */
    accountPrototypeDeleteNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all question of this model.
     * @param id Account id
     */
    accountPrototypeDeleteQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteQuestion");
        }
        var baseUrl = "/Accounts/{id}/question".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all questionType of this model.
     * @param id Account id
     */
    accountPrototypeDeleteQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all roles of this model.
     * @param id Account id
     */
    accountPrototypeDeleteRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteRoles");
        }
        var baseUrl = "/Accounts/{id}/roles".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Account id
     */
    accountPrototypeDeleteRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Account id
     */
    accountPrototypeDeleteSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all tests of this model.
     * @param id Account id
     */
    accountPrototypeDeleteTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDeleteTests");
        }
        var baseUrl = "/Accounts/{id}/tests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    accountPrototypeDestroyByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    accountPrototypeDestroyByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeDestroyByIdContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdContests");
        }
        var baseUrl = "/Accounts/{id}/contests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    accountPrototypeDestroyByIdExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdExams");
        }
        var baseUrl = "/Accounts/{id}/exams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    accountPrototypeDestroyByIdHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdHelp");
        }
        var baseUrl = "/Accounts/{id}/help/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    accountPrototypeDestroyByIdKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdKeys");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdKeys");
        }
        var baseUrl = "/Accounts/{id}/keys/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    accountPrototypeDestroyByIdNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdNotifications");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    accountPrototypeDestroyByIdQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdQuestion");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdQuestion");
        }
        var baseUrl = "/Accounts/{id}/question/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    accountPrototypeDestroyByIdQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdQuestionType");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeDestroyByIdRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeDestroyByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    accountPrototypeDestroyByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    accountPrototypeDestroyByIdTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeDestroyByIdTests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeDestroyByIdTests");
        }
        var baseUrl = "/Accounts/{id}/tests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeExistsContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeExistsContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeExistsContests");
        }
        var baseUrl = "/Accounts/{id}/contests/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeExistsRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeExistsRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeExistsRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeExistsRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeExistsRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeExistsRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    accountPrototypeFindByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    accountPrototypeFindByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeFindByIdContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdContests");
        }
        var baseUrl = "/Accounts/{id}/contests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    accountPrototypeFindByIdExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdExams");
        }
        var baseUrl = "/Accounts/{id}/exams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    accountPrototypeFindByIdHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdHelp");
        }
        var baseUrl = "/Accounts/{id}/help/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    accountPrototypeFindByIdKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdKeys");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdKeys");
        }
        var baseUrl = "/Accounts/{id}/keys/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    accountPrototypeFindByIdNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdNotifications");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    accountPrototypeFindByIdQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdQuestion");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdQuestion");
        }
        var baseUrl = "/Accounts/{id}/question/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    accountPrototypeFindByIdQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdQuestionType");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeFindByIdRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeFindByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    accountPrototypeFindByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    accountPrototypeFindByIdTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeFindByIdTests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeFindByIdTests");
        }
        var baseUrl = "/Accounts/{id}/tests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries accessTokens of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetCity: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetCity");
        }
        var baseUrl = "/Accounts/{id}/city".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries contestGuides of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries contests of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetContests");
        }
        var baseUrl = "/Accounts/{id}/contests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetDistrict: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetDistrict");
        }
        var baseUrl = "/Accounts/{id}/district".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries exams of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetExams");
        }
        var baseUrl = "/Accounts/{id}/exams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries help of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetHelp");
        }
        var baseUrl = "/Accounts/{id}/help".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries keys of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetKeys");
        }
        var baseUrl = "/Accounts/{id}/keys".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries notifications of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries question of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetQuestion");
        }
        var baseUrl = "/Accounts/{id}/question".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries questionType of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries roles of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetRoles");
        }
        var baseUrl = "/Accounts/{id}/roles".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries rounds of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation school.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetSchool");
        }
        var baseUrl = "/Accounts/{id}/school".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries submitExams of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries tests of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeGetTests");
        }
        var baseUrl = "/Accounts/{id}/tests".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    accountPrototypeLinkContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeLinkContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeLinkContests");
        }
        var baseUrl = "/Accounts/{id}/contests/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    accountPrototypeLinkRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeLinkRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeLinkRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    accountPrototypeLinkRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeLinkRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeLinkRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Account id
     * @param data An object of model property name/value pairs
     */
    accountPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypePatchAttributes");
        }
        var baseUrl = "/Accounts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeUnlinkContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUnlinkContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUnlinkContests");
        }
        var baseUrl = "/Accounts/{id}/contests/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeUnlinkRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUnlinkRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUnlinkRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeUnlinkRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUnlinkRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUnlinkRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    accountPrototypeUpdateByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdAccessTokens");
        }
        var baseUrl = "/Accounts/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    accountPrototypeUpdateByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdContestGuides");
        }
        var baseUrl = "/Accounts/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    accountPrototypeUpdateByIdContests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdContests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdContests");
        }
        var baseUrl = "/Accounts/{id}/contests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     * @param data
     */
    accountPrototypeUpdateByIdExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdExams");
        }
        var baseUrl = "/Accounts/{id}/exams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     * @param data
     */
    accountPrototypeUpdateByIdHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdHelp");
        }
        var baseUrl = "/Accounts/{id}/help/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     * @param data
     */
    accountPrototypeUpdateByIdKeys: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdKeys");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdKeys");
        }
        var baseUrl = "/Accounts/{id}/keys/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     * @param data
     */
    accountPrototypeUpdateByIdNotifications: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdNotifications");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdNotifications");
        }
        var baseUrl = "/Accounts/{id}/notifications/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     * @param data
     */
    accountPrototypeUpdateByIdQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdQuestion");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdQuestion");
        }
        var baseUrl = "/Accounts/{id}/question/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     * @param data
     */
    accountPrototypeUpdateByIdQuestionType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdQuestionType");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdQuestionType");
        }
        var baseUrl = "/Accounts/{id}/questionType/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    accountPrototypeUpdateByIdRoles: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdRoles");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdRoles");
        }
        var baseUrl = "/Accounts/{id}/roles/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    accountPrototypeUpdateByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdRounds");
        }
        var baseUrl = "/Accounts/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     * @param data
     */
    accountPrototypeUpdateByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdSubmitExams");
        }
        var baseUrl = "/Accounts/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     * @param data
     */
    accountPrototypeUpdateByIdTests: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeUpdateByIdTests");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling accountPrototypeUpdateByIdTests");
        }
        var baseUrl = "/Accounts/{id}/tests/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id Account id
     */
    accountPrototypeVerify: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountPrototypeVerify");
        }
        var baseUrl = "/Accounts/{id}/verify".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountReplaceByIdPostAccountsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountReplaceByIdPostAccountsidReplace");
        }
        var baseUrl = "/Accounts/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountReplaceByIdPutAccountsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountReplaceByIdPutAccountsid");
        }
        var baseUrl = "/Accounts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountReplaceOrCreatePostAccountsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Accounts/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountReplaceOrCreatePutAccounts: function (params, options) {
        var baseUrl = "/Accounts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    accountResetPassword: function (params, options) {
        // verify required parameter "options" is set
        if (params["options"] == null) {
            throw new Error("Missing required parameter options when calling accountResetPassword");
        }
        var baseUrl = "/Accounts/reset";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["options"]) {
            fetchOptions.body = JSON.stringify(params["options"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Send email !
     * @param to
     * @param subject
     * @param text
     * @param html {html: text}
     */
    accountSendMail: function (params, options) {
        var baseUrl = "/Accounts/sendMail";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            to: params["to"],
            subject: params["subject"],
            text: params["text"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["html"]) {
            fetchOptions.body = JSON.stringify(params["html"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    accountSetPassword: function (params, options) {
        // verify required parameter "newPassword" is set
        if (params["newPassword"] == null) {
            throw new Error("Missing required parameter newPassword when calling accountSetPassword");
        }
        var baseUrl = "/Accounts/reset-password";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            newPassword: params["newPassword"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountUpdateAll: function (params, options) {
        var baseUrl = "/Accounts/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountUpsertWithWhere: function (params, options) {
        var baseUrl = "/Accounts/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * AccountApi - functional programming interface
 */
export var AccountApiFp = {
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    accountChangePassword: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountChangePassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    accountConfirm: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountConfirm(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    accountCount: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    accountCreate: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountCreateChangeStreamGetAccountsChangeStream: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountCreateChangeStreamGetAccountsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountCreateChangeStreamPostAccountsChangeStream: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountCreateChangeStreamPostAccountsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    accountDeleteById: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountExistsGetAccountsidExists: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountExistsGetAccountsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountExistsHeadAccountsid: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountExistsHeadAccountsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountFind: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    accountFindById: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountFindOne: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    accountLogin: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountLogin(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Logout a user with access token.
     */
    accountLogout: function (options) {
        var fetchArgs = AccountApiFetchParamCreator.accountLogout(options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountPatchOrCreate: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts accessTokens of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts contestGuides of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts contests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts exams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts help of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts keys of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts notifications of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts question of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts questionType of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts roles of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts rounds of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts submitExams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts tests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    accountPrototypeCountTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCountTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in contests of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in exams of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in help of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in keys of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in notifications of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in question of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in questionType of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in roles of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in tests of this model.
     * @param id Account id
     * @param data
     */
    accountPrototypeCreateTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeCreateTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id Account id
     */
    accountPrototypeDeleteAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Account id
     */
    accountPrototypeDeleteContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all contests of this model.
     * @param id Account id
     */
    accountPrototypeDeleteContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all exams of this model.
     * @param id Account id
     */
    accountPrototypeDeleteExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all help of this model.
     * @param id Account id
     */
    accountPrototypeDeleteHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all keys of this model.
     * @param id Account id
     */
    accountPrototypeDeleteKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all notifications of this model.
     * @param id Account id
     */
    accountPrototypeDeleteNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all question of this model.
     * @param id Account id
     */
    accountPrototypeDeleteQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all questionType of this model.
     * @param id Account id
     */
    accountPrototypeDeleteQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all roles of this model.
     * @param id Account id
     */
    accountPrototypeDeleteRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Account id
     */
    accountPrototypeDeleteRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Account id
     */
    accountPrototypeDeleteSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all tests of this model.
     * @param id Account id
     */
    accountPrototypeDeleteTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDeleteTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    accountPrototypeDestroyByIdAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    accountPrototypeDestroyByIdContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeDestroyByIdContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    accountPrototypeDestroyByIdExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    accountPrototypeDestroyByIdHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    accountPrototypeDestroyByIdKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    accountPrototypeDestroyByIdNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    accountPrototypeDestroyByIdQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    accountPrototypeDestroyByIdQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeDestroyByIdRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeDestroyByIdRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    accountPrototypeDestroyByIdSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    accountPrototypeDestroyByIdTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeDestroyByIdTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeExistsContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeExistsContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeExistsRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeExistsRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeExistsRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeExistsRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    accountPrototypeFindByIdAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    accountPrototypeFindByIdContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeFindByIdContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    accountPrototypeFindByIdExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    accountPrototypeFindByIdHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    accountPrototypeFindByIdKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    accountPrototypeFindByIdNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    accountPrototypeFindByIdQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    accountPrototypeFindByIdQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeFindByIdRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeFindByIdRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    accountPrototypeFindByIdSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    accountPrototypeFindByIdTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeFindByIdTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries accessTokens of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetCity: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetCity(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries contestGuides of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries contests of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetDistrict: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetDistrict(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries exams of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries help of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries keys of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries notifications of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries question of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries questionType of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries roles of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries rounds of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation school.
     * @param id Account id
     * @param refresh
     */
    accountPrototypeGetSchool: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries submitExams of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries tests of Account.
     * @param id Account id
     * @param filter
     */
    accountPrototypeGetTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeGetTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    accountPrototypeLinkContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeLinkContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    accountPrototypeLinkRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeLinkRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    accountPrototypeLinkRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeLinkRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Account id
     * @param data An object of model property name/value pairs
     */
    accountPrototypePatchAttributes: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    accountPrototypeUnlinkContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUnlinkContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    accountPrototypeUnlinkRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUnlinkRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    accountPrototypeUnlinkRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUnlinkRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    accountPrototypeUpdateByIdAccessTokens: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    accountPrototypeUpdateByIdContestGuides: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    accountPrototypeUpdateByIdContests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     * @param data
     */
    accountPrototypeUpdateByIdExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     * @param data
     */
    accountPrototypeUpdateByIdHelp: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     * @param data
     */
    accountPrototypeUpdateByIdKeys: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     * @param data
     */
    accountPrototypeUpdateByIdNotifications: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     * @param data
     */
    accountPrototypeUpdateByIdQuestion: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     * @param data
     */
    accountPrototypeUpdateByIdQuestionType: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdQuestionType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    accountPrototypeUpdateByIdRoles: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdRoles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    accountPrototypeUpdateByIdRounds: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     * @param data
     */
    accountPrototypeUpdateByIdSubmitExams: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     * @param data
     */
    accountPrototypeUpdateByIdTests: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeUpdateByIdTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id Account id
     */
    accountPrototypeVerify: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountPrototypeVerify(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountReplaceByIdPostAccountsidReplace: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountReplaceByIdPostAccountsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountReplaceByIdPutAccountsid: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountReplaceByIdPutAccountsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountReplaceOrCreatePostAccountsReplaceOrCreate: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountReplaceOrCreatePostAccountsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountReplaceOrCreatePutAccounts: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountReplaceOrCreatePutAccounts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    accountResetPassword: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountResetPassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Send email !
     * @param to
     * @param subject
     * @param text
     * @param html {html: text}
     */
    accountSendMail: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountSendMail(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    accountSetPassword: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountSetPassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountUpdateAll: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountUpsertWithWhere: function (params, options) {
        var fetchArgs = AccountApiFetchParamCreator.accountUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * AccountApi - object-oriented interface
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    AccountApi.prototype.accountChangePassword = function (params, options) {
        return AccountApiFp.accountChangePassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    AccountApi.prototype.accountConfirm = function (params, options) {
        return AccountApiFp.accountConfirm(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountCount = function (params, options) {
        return AccountApiFp.accountCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    AccountApi.prototype.accountCreate = function (params, options) {
        return AccountApiFp.accountCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    AccountApi.prototype.accountCreateChangeStreamGetAccountsChangeStream = function (params, options) {
        return AccountApiFp.accountCreateChangeStreamGetAccountsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    AccountApi.prototype.accountCreateChangeStreamPostAccountsChangeStream = function (params, options) {
        return AccountApiFp.accountCreateChangeStreamPostAccountsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    AccountApi.prototype.accountDeleteById = function (params, options) {
        return AccountApiFp.accountDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    AccountApi.prototype.accountExistsGetAccountsidExists = function (params, options) {
        return AccountApiFp.accountExistsGetAccountsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    AccountApi.prototype.accountExistsHeadAccountsid = function (params, options) {
        return AccountApiFp.accountExistsHeadAccountsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    AccountApi.prototype.accountFind = function (params, options) {
        return AccountApiFp.accountFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    AccountApi.prototype.accountFindById = function (params, options) {
        return AccountApiFp.accountFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    AccountApi.prototype.accountFindOne = function (params, options) {
        return AccountApiFp.accountFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    AccountApi.prototype.accountLogin = function (params, options) {
        return AccountApiFp.accountLogin(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Logout a user with access token.
     */
    AccountApi.prototype.accountLogout = function (options) {
        return AccountApiFp.accountLogout(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountApi.prototype.accountPatchOrCreate = function (params, options) {
        return AccountApiFp.accountPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts accessTokens of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeCountAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts contestGuides of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeCountContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts contests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountContests = function (params, options) {
        return AccountApiFp.accountPrototypeCountContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts exams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountExams = function (params, options) {
        return AccountApiFp.accountPrototypeCountExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts help of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountHelp = function (params, options) {
        return AccountApiFp.accountPrototypeCountHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts keys of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountKeys = function (params, options) {
        return AccountApiFp.accountPrototypeCountKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts notifications of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeCountNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts question of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeCountQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts questionType of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeCountQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts roles of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountRoles = function (params, options) {
        return AccountApiFp.accountPrototypeCountRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts rounds of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountRounds = function (params, options) {
        return AccountApiFp.accountPrototypeCountRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts submitExams of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeCountSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts tests of Account.
     * @param id Account id
     * @param where Criteria to match model instances
     */
    AccountApi.prototype.accountPrototypeCountTests = function (params, options) {
        return AccountApiFp.accountPrototypeCountTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeCreateAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeCreateContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in contests of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateContests = function (params, options) {
        return AccountApiFp.accountPrototypeCreateContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in exams of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateExams = function (params, options) {
        return AccountApiFp.accountPrototypeCreateExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in help of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateHelp = function (params, options) {
        return AccountApiFp.accountPrototypeCreateHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in keys of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateKeys = function (params, options) {
        return AccountApiFp.accountPrototypeCreateKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in notifications of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeCreateNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in question of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeCreateQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in questionType of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeCreateQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in roles of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateRoles = function (params, options) {
        return AccountApiFp.accountPrototypeCreateRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateRounds = function (params, options) {
        return AccountApiFp.accountPrototypeCreateRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeCreateSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in tests of this model.
     * @param id Account id
     * @param data
     */
    AccountApi.prototype.accountPrototypeCreateTests = function (params, options) {
        return AccountApiFp.accountPrototypeCreateTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all contests of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteContests = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all exams of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteExams = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all help of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteHelp = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all keys of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteKeys = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all notifications of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all question of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all questionType of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all roles of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteRoles = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteRounds = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all tests of this model.
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeDeleteTests = function (params, options) {
        return AccountApiFp.accountPrototypeDeleteTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    AccountApi.prototype.accountPrototypeDestroyByIdAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    AccountApi.prototype.accountPrototypeDestroyByIdContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    AccountApi.prototype.accountPrototypeDestroyByIdContests = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    AccountApi.prototype.accountPrototypeDestroyByIdExams = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    AccountApi.prototype.accountPrototypeDestroyByIdHelp = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    AccountApi.prototype.accountPrototypeDestroyByIdKeys = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    AccountApi.prototype.accountPrototypeDestroyByIdNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    AccountApi.prototype.accountPrototypeDestroyByIdQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    AccountApi.prototype.accountPrototypeDestroyByIdQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    AccountApi.prototype.accountPrototypeDestroyByIdRoles = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    AccountApi.prototype.accountPrototypeDestroyByIdRounds = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    AccountApi.prototype.accountPrototypeDestroyByIdSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    AccountApi.prototype.accountPrototypeDestroyByIdTests = function (params, options) {
        return AccountApiFp.accountPrototypeDestroyByIdTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    AccountApi.prototype.accountPrototypeExistsContests = function (params, options) {
        return AccountApiFp.accountPrototypeExistsContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    AccountApi.prototype.accountPrototypeExistsRoles = function (params, options) {
        return AccountApiFp.accountPrototypeExistsRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    AccountApi.prototype.accountPrototypeExistsRounds = function (params, options) {
        return AccountApiFp.accountPrototypeExistsRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     */
    AccountApi.prototype.accountPrototypeFindByIdAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     */
    AccountApi.prototype.accountPrototypeFindByIdContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    AccountApi.prototype.accountPrototypeFindByIdContests = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     */
    AccountApi.prototype.accountPrototypeFindByIdExams = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     */
    AccountApi.prototype.accountPrototypeFindByIdHelp = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     */
    AccountApi.prototype.accountPrototypeFindByIdKeys = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     */
    AccountApi.prototype.accountPrototypeFindByIdNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     */
    AccountApi.prototype.accountPrototypeFindByIdQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     */
    AccountApi.prototype.accountPrototypeFindByIdQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    AccountApi.prototype.accountPrototypeFindByIdRoles = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    AccountApi.prototype.accountPrototypeFindByIdRounds = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     */
    AccountApi.prototype.accountPrototypeFindByIdSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     */
    AccountApi.prototype.accountPrototypeFindByIdTests = function (params, options) {
        return AccountApiFp.accountPrototypeFindByIdTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries accessTokens of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeGetAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Account id
     * @param refresh
     */
    AccountApi.prototype.accountPrototypeGetCity = function (params, options) {
        return AccountApiFp.accountPrototypeGetCity(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries contestGuides of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeGetContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries contests of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetContests = function (params, options) {
        return AccountApiFp.accountPrototypeGetContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id Account id
     * @param refresh
     */
    AccountApi.prototype.accountPrototypeGetDistrict = function (params, options) {
        return AccountApiFp.accountPrototypeGetDistrict(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries exams of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetExams = function (params, options) {
        return AccountApiFp.accountPrototypeGetExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries help of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetHelp = function (params, options) {
        return AccountApiFp.accountPrototypeGetHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries keys of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetKeys = function (params, options) {
        return AccountApiFp.accountPrototypeGetKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries notifications of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeGetNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries question of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeGetQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries questionType of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeGetQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries roles of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetRoles = function (params, options) {
        return AccountApiFp.accountPrototypeGetRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries rounds of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetRounds = function (params, options) {
        return AccountApiFp.accountPrototypeGetRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation school.
     * @param id Account id
     * @param refresh
     */
    AccountApi.prototype.accountPrototypeGetSchool = function (params, options) {
        return AccountApiFp.accountPrototypeGetSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries submitExams of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeGetSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries tests of Account.
     * @param id Account id
     * @param filter
     */
    AccountApi.prototype.accountPrototypeGetTests = function (params, options) {
        return AccountApiFp.accountPrototypeGetTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    AccountApi.prototype.accountPrototypeLinkContests = function (params, options) {
        return AccountApiFp.accountPrototypeLinkContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    AccountApi.prototype.accountPrototypeLinkRoles = function (params, options) {
        return AccountApiFp.accountPrototypeLinkRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    AccountApi.prototype.accountPrototypeLinkRounds = function (params, options) {
        return AccountApiFp.accountPrototypeLinkRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Account id
     * @param data An object of model property name/value pairs
     */
    AccountApi.prototype.accountPrototypePatchAttributes = function (params, options) {
        return AccountApiFp.accountPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the contests relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for contests
     */
    AccountApi.prototype.accountPrototypeUnlinkContests = function (params, options) {
        return AccountApiFp.accountPrototypeUnlinkContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the roles relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for roles
     */
    AccountApi.prototype.accountPrototypeUnlinkRoles = function (params, options) {
        return AccountApiFp.accountPrototypeUnlinkRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the rounds relation to an item by id.
     * @param id Account id
     * @param fk Foreign key for rounds
     */
    AccountApi.prototype.accountPrototypeUnlinkRounds = function (params, options) {
        return AccountApiFp.accountPrototypeUnlinkRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id Account id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdAccessTokens = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Account id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdContestGuides = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for contests.
     * @param id Account id
     * @param fk Foreign key for contests
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdContests = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for exams.
     * @param id Account id
     * @param fk Foreign key for exams
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdExams = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for help.
     * @param id Account id
     * @param fk Foreign key for help
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdHelp = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for keys.
     * @param id Account id
     * @param fk Foreign key for keys
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdKeys = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for notifications.
     * @param id Account id
     * @param fk Foreign key for notifications
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdNotifications = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for question.
     * @param id Account id
     * @param fk Foreign key for question
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdQuestion = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for questionType.
     * @param id Account id
     * @param fk Foreign key for questionType
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdQuestionType = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdQuestionType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for roles.
     * @param id Account id
     * @param fk Foreign key for roles
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdRoles = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdRoles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Account id
     * @param fk Foreign key for rounds
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdRounds = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Account id
     * @param fk Foreign key for submitExams
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdSubmitExams = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for tests.
     * @param id Account id
     * @param fk Foreign key for tests
     * @param data
     */
    AccountApi.prototype.accountPrototypeUpdateByIdTests = function (params, options) {
        return AccountApiFp.accountPrototypeUpdateByIdTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id Account id
     */
    AccountApi.prototype.accountPrototypeVerify = function (params, options) {
        return AccountApiFp.accountPrototypeVerify(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    AccountApi.prototype.accountReplaceByIdPostAccountsidReplace = function (params, options) {
        return AccountApiFp.accountReplaceByIdPostAccountsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    AccountApi.prototype.accountReplaceByIdPutAccountsid = function (params, options) {
        return AccountApiFp.accountReplaceByIdPutAccountsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountApi.prototype.accountReplaceOrCreatePostAccountsReplaceOrCreate = function (params, options) {
        return AccountApiFp.accountReplaceOrCreatePostAccountsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountApi.prototype.accountReplaceOrCreatePutAccounts = function (params, options) {
        return AccountApiFp.accountReplaceOrCreatePutAccounts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    AccountApi.prototype.accountResetPassword = function (params, options) {
        return AccountApiFp.accountResetPassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Send email !
     * @param to
     * @param subject
     * @param text
     * @param html {html: text}
     */
    AccountApi.prototype.accountSendMail = function (params, options) {
        return AccountApiFp.accountSendMail(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    AccountApi.prototype.accountSetPassword = function (params, options) {
        return AccountApiFp.accountSetPassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    AccountApi.prototype.accountUpdateAll = function (params, options) {
        return AccountApiFp.accountUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    AccountApi.prototype.accountUpsertWithWhere = function (params, options) {
        return AccountApiFp.accountUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return AccountApi;
}(BaseAPI));
export { AccountApi };
/**
 * AccountApi - factory interface
 */
export var AccountApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Change a user's password.
         * @param oldPassword
         * @param newPassword
         */
        accountChangePassword: function (params, options) {
            return AccountApiFp.accountChangePassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Confirm a user registration with identity verification token.
         * @param uid
         * @param token
         * @param redirect
         */
        accountConfirm: function (params, options) {
            return AccountApiFp.accountConfirm(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        accountCount: function (params, options) {
            return AccountApiFp.accountCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        accountCreate: function (params, options) {
            return AccountApiFp.accountCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        accountCreateChangeStreamGetAccountsChangeStream: function (params, options) {
            return AccountApiFp.accountCreateChangeStreamGetAccountsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        accountCreateChangeStreamPostAccountsChangeStream: function (params, options) {
            return AccountApiFp.accountCreateChangeStreamPostAccountsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        accountDeleteById: function (params, options) {
            return AccountApiFp.accountDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        accountExistsGetAccountsidExists: function (params, options) {
            return AccountApiFp.accountExistsGetAccountsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        accountExistsHeadAccountsid: function (params, options) {
            return AccountApiFp.accountExistsHeadAccountsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        accountFind: function (params, options) {
            return AccountApiFp.accountFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        accountFindById: function (params, options) {
            return AccountApiFp.accountFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        accountFindOne: function (params, options) {
            return AccountApiFp.accountFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Login a user with username/email and password.
         * @param credentials
         * @param include Related objects to include in the response. See the description of return value for more details.
         */
        accountLogin: function (params, options) {
            return AccountApiFp.accountLogin(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Logout a user with access token.
         */
        accountLogout: function (options) {
            return AccountApiFp.accountLogout(options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountPatchOrCreate: function (params, options) {
            return AccountApiFp.accountPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts accessTokens of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeCountAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts contestGuides of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeCountContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts contests of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountContests: function (params, options) {
            return AccountApiFp.accountPrototypeCountContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts exams of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountExams: function (params, options) {
            return AccountApiFp.accountPrototypeCountExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts help of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountHelp: function (params, options) {
            return AccountApiFp.accountPrototypeCountHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts keys of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountKeys: function (params, options) {
            return AccountApiFp.accountPrototypeCountKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts notifications of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeCountNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts question of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeCountQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts questionType of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeCountQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts roles of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountRoles: function (params, options) {
            return AccountApiFp.accountPrototypeCountRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts rounds of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountRounds: function (params, options) {
            return AccountApiFp.accountPrototypeCountRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts submitExams of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeCountSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts tests of Account.
         * @param id Account id
         * @param where Criteria to match model instances
         */
        accountPrototypeCountTests: function (params, options) {
            return AccountApiFp.accountPrototypeCountTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in accessTokens of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeCreateAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in contestGuides of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeCreateContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in contests of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateContests: function (params, options) {
            return AccountApiFp.accountPrototypeCreateContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in exams of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateExams: function (params, options) {
            return AccountApiFp.accountPrototypeCreateExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in help of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateHelp: function (params, options) {
            return AccountApiFp.accountPrototypeCreateHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in keys of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateKeys: function (params, options) {
            return AccountApiFp.accountPrototypeCreateKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in notifications of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeCreateNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in question of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeCreateQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in questionType of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeCreateQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in roles of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateRoles: function (params, options) {
            return AccountApiFp.accountPrototypeCreateRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in rounds of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateRounds: function (params, options) {
            return AccountApiFp.accountPrototypeCreateRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in submitExams of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeCreateSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in tests of this model.
         * @param id Account id
         * @param data
         */
        accountPrototypeCreateTests: function (params, options) {
            return AccountApiFp.accountPrototypeCreateTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all accessTokens of this model.
         * @param id Account id
         */
        accountPrototypeDeleteAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all contestGuides of this model.
         * @param id Account id
         */
        accountPrototypeDeleteContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all contests of this model.
         * @param id Account id
         */
        accountPrototypeDeleteContests: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all exams of this model.
         * @param id Account id
         */
        accountPrototypeDeleteExams: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all help of this model.
         * @param id Account id
         */
        accountPrototypeDeleteHelp: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all keys of this model.
         * @param id Account id
         */
        accountPrototypeDeleteKeys: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all notifications of this model.
         * @param id Account id
         */
        accountPrototypeDeleteNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all question of this model.
         * @param id Account id
         */
        accountPrototypeDeleteQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all questionType of this model.
         * @param id Account id
         */
        accountPrototypeDeleteQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all roles of this model.
         * @param id Account id
         */
        accountPrototypeDeleteRoles: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all rounds of this model.
         * @param id Account id
         */
        accountPrototypeDeleteRounds: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all submitExams of this model.
         * @param id Account id
         */
        accountPrototypeDeleteSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all tests of this model.
         * @param id Account id
         */
        accountPrototypeDeleteTests: function (params, options) {
            return AccountApiFp.accountPrototypeDeleteTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for accessTokens.
         * @param id Account id
         * @param fk Foreign key for accessTokens
         */
        accountPrototypeDestroyByIdAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for contestGuides.
         * @param id Account id
         * @param fk Foreign key for contestGuides
         */
        accountPrototypeDestroyByIdContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for contests.
         * @param id Account id
         * @param fk Foreign key for contests
         */
        accountPrototypeDestroyByIdContests: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for exams.
         * @param id Account id
         * @param fk Foreign key for exams
         */
        accountPrototypeDestroyByIdExams: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for help.
         * @param id Account id
         * @param fk Foreign key for help
         */
        accountPrototypeDestroyByIdHelp: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for keys.
         * @param id Account id
         * @param fk Foreign key for keys
         */
        accountPrototypeDestroyByIdKeys: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for notifications.
         * @param id Account id
         * @param fk Foreign key for notifications
         */
        accountPrototypeDestroyByIdNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for question.
         * @param id Account id
         * @param fk Foreign key for question
         */
        accountPrototypeDestroyByIdQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for questionType.
         * @param id Account id
         * @param fk Foreign key for questionType
         */
        accountPrototypeDestroyByIdQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for roles.
         * @param id Account id
         * @param fk Foreign key for roles
         */
        accountPrototypeDestroyByIdRoles: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for rounds.
         * @param id Account id
         * @param fk Foreign key for rounds
         */
        accountPrototypeDestroyByIdRounds: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for submitExams.
         * @param id Account id
         * @param fk Foreign key for submitExams
         */
        accountPrototypeDestroyByIdSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for tests.
         * @param id Account id
         * @param fk Foreign key for tests
         */
        accountPrototypeDestroyByIdTests: function (params, options) {
            return AccountApiFp.accountPrototypeDestroyByIdTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of contests relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for contests
         */
        accountPrototypeExistsContests: function (params, options) {
            return AccountApiFp.accountPrototypeExistsContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of roles relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for roles
         */
        accountPrototypeExistsRoles: function (params, options) {
            return AccountApiFp.accountPrototypeExistsRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of rounds relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for rounds
         */
        accountPrototypeExistsRounds: function (params, options) {
            return AccountApiFp.accountPrototypeExistsRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for accessTokens.
         * @param id Account id
         * @param fk Foreign key for accessTokens
         */
        accountPrototypeFindByIdAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for contestGuides.
         * @param id Account id
         * @param fk Foreign key for contestGuides
         */
        accountPrototypeFindByIdContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for contests.
         * @param id Account id
         * @param fk Foreign key for contests
         */
        accountPrototypeFindByIdContests: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for exams.
         * @param id Account id
         * @param fk Foreign key for exams
         */
        accountPrototypeFindByIdExams: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for help.
         * @param id Account id
         * @param fk Foreign key for help
         */
        accountPrototypeFindByIdHelp: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for keys.
         * @param id Account id
         * @param fk Foreign key for keys
         */
        accountPrototypeFindByIdKeys: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for notifications.
         * @param id Account id
         * @param fk Foreign key for notifications
         */
        accountPrototypeFindByIdNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for question.
         * @param id Account id
         * @param fk Foreign key for question
         */
        accountPrototypeFindByIdQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for questionType.
         * @param id Account id
         * @param fk Foreign key for questionType
         */
        accountPrototypeFindByIdQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for roles.
         * @param id Account id
         * @param fk Foreign key for roles
         */
        accountPrototypeFindByIdRoles: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for rounds.
         * @param id Account id
         * @param fk Foreign key for rounds
         */
        accountPrototypeFindByIdRounds: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for submitExams.
         * @param id Account id
         * @param fk Foreign key for submitExams
         */
        accountPrototypeFindByIdSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for tests.
         * @param id Account id
         * @param fk Foreign key for tests
         */
        accountPrototypeFindByIdTests: function (params, options) {
            return AccountApiFp.accountPrototypeFindByIdTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries accessTokens of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeGetAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation city.
         * @param id Account id
         * @param refresh
         */
        accountPrototypeGetCity: function (params, options) {
            return AccountApiFp.accountPrototypeGetCity(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries contestGuides of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeGetContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries contests of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetContests: function (params, options) {
            return AccountApiFp.accountPrototypeGetContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation district.
         * @param id Account id
         * @param refresh
         */
        accountPrototypeGetDistrict: function (params, options) {
            return AccountApiFp.accountPrototypeGetDistrict(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries exams of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetExams: function (params, options) {
            return AccountApiFp.accountPrototypeGetExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries help of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetHelp: function (params, options) {
            return AccountApiFp.accountPrototypeGetHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries keys of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetKeys: function (params, options) {
            return AccountApiFp.accountPrototypeGetKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries notifications of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeGetNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries question of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeGetQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries questionType of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeGetQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries roles of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetRoles: function (params, options) {
            return AccountApiFp.accountPrototypeGetRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries rounds of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetRounds: function (params, options) {
            return AccountApiFp.accountPrototypeGetRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation school.
         * @param id Account id
         * @param refresh
         */
        accountPrototypeGetSchool: function (params, options) {
            return AccountApiFp.accountPrototypeGetSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries submitExams of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeGetSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries tests of Account.
         * @param id Account id
         * @param filter
         */
        accountPrototypeGetTests: function (params, options) {
            return AccountApiFp.accountPrototypeGetTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for contests.
         * @param id Account id
         * @param fk Foreign key for contests
         * @param data
         */
        accountPrototypeLinkContests: function (params, options) {
            return AccountApiFp.accountPrototypeLinkContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for roles.
         * @param id Account id
         * @param fk Foreign key for roles
         * @param data
         */
        accountPrototypeLinkRoles: function (params, options) {
            return AccountApiFp.accountPrototypeLinkRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for rounds.
         * @param id Account id
         * @param fk Foreign key for rounds
         * @param data
         */
        accountPrototypeLinkRounds: function (params, options) {
            return AccountApiFp.accountPrototypeLinkRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Account id
         * @param data An object of model property name/value pairs
         */
        accountPrototypePatchAttributes: function (params, options) {
            return AccountApiFp.accountPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the contests relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for contests
         */
        accountPrototypeUnlinkContests: function (params, options) {
            return AccountApiFp.accountPrototypeUnlinkContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the roles relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for roles
         */
        accountPrototypeUnlinkRoles: function (params, options) {
            return AccountApiFp.accountPrototypeUnlinkRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the rounds relation to an item by id.
         * @param id Account id
         * @param fk Foreign key for rounds
         */
        accountPrototypeUnlinkRounds: function (params, options) {
            return AccountApiFp.accountPrototypeUnlinkRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for accessTokens.
         * @param id Account id
         * @param fk Foreign key for accessTokens
         * @param data
         */
        accountPrototypeUpdateByIdAccessTokens: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for contestGuides.
         * @param id Account id
         * @param fk Foreign key for contestGuides
         * @param data
         */
        accountPrototypeUpdateByIdContestGuides: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for contests.
         * @param id Account id
         * @param fk Foreign key for contests
         * @param data
         */
        accountPrototypeUpdateByIdContests: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for exams.
         * @param id Account id
         * @param fk Foreign key for exams
         * @param data
         */
        accountPrototypeUpdateByIdExams: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for help.
         * @param id Account id
         * @param fk Foreign key for help
         * @param data
         */
        accountPrototypeUpdateByIdHelp: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for keys.
         * @param id Account id
         * @param fk Foreign key for keys
         * @param data
         */
        accountPrototypeUpdateByIdKeys: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for notifications.
         * @param id Account id
         * @param fk Foreign key for notifications
         * @param data
         */
        accountPrototypeUpdateByIdNotifications: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for question.
         * @param id Account id
         * @param fk Foreign key for question
         * @param data
         */
        accountPrototypeUpdateByIdQuestion: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for questionType.
         * @param id Account id
         * @param fk Foreign key for questionType
         * @param data
         */
        accountPrototypeUpdateByIdQuestionType: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdQuestionType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for roles.
         * @param id Account id
         * @param fk Foreign key for roles
         * @param data
         */
        accountPrototypeUpdateByIdRoles: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdRoles(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for rounds.
         * @param id Account id
         * @param fk Foreign key for rounds
         * @param data
         */
        accountPrototypeUpdateByIdRounds: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for submitExams.
         * @param id Account id
         * @param fk Foreign key for submitExams
         * @param data
         */
        accountPrototypeUpdateByIdSubmitExams: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for tests.
         * @param id Account id
         * @param fk Foreign key for tests
         * @param data
         */
        accountPrototypeUpdateByIdTests: function (params, options) {
            return AccountApiFp.accountPrototypeUpdateByIdTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Trigger user's identity verification with configured verifyOptions
         * @param id Account id
         */
        accountPrototypeVerify: function (params, options) {
            return AccountApiFp.accountPrototypeVerify(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        accountReplaceByIdPostAccountsidReplace: function (params, options) {
            return AccountApiFp.accountReplaceByIdPostAccountsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        accountReplaceByIdPutAccountsid: function (params, options) {
            return AccountApiFp.accountReplaceByIdPutAccountsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountReplaceOrCreatePostAccountsReplaceOrCreate: function (params, options) {
            return AccountApiFp.accountReplaceOrCreatePostAccountsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountReplaceOrCreatePutAccounts: function (params, options) {
            return AccountApiFp.accountReplaceOrCreatePutAccounts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reset password for a user with email.
         * @param options
         */
        accountResetPassword: function (params, options) {
            return AccountApiFp.accountResetPassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send email !
         * @param to
         * @param subject
         * @param text
         * @param html {html: text}
         */
        accountSendMail: function (params, options) {
            return AccountApiFp.accountSendMail(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reset user's password via a password-reset token.
         * @param newPassword
         */
        accountSetPassword: function (params, options) {
            return AccountApiFp.accountSetPassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        accountUpdateAll: function (params, options) {
            return AccountApiFp.accountUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        accountUpsertWithWhere: function (params, options) {
            return AccountApiFp.accountUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * AccountTokenApi - fetch parameter creator
 */
export var AccountTokenApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    accountTokenCount: function (params, options) {
        var baseUrl = "/AccountTokens/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    accountTokenCreate: function (params, options) {
        var baseUrl = "/AccountTokens";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountTokenCreateChangeStreamGetAccountTokensChangeStream: function (params, options) {
        var baseUrl = "/AccountTokens/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountTokenCreateChangeStreamPostAccountTokensChangeStream: function (params, options) {
        var baseUrl = "/AccountTokens/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    accountTokenDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenDeleteById");
        }
        var baseUrl = "/AccountTokens/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountTokenExistsGetAccountTokensidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenExistsGetAccountTokensidExists");
        }
        var baseUrl = "/AccountTokens/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountTokenExistsHeadAccountTokensid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenExistsHeadAccountTokensid");
        }
        var baseUrl = "/AccountTokens/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountTokenFind: function (params, options) {
        var baseUrl = "/AccountTokens";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    accountTokenFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenFindById");
        }
        var baseUrl = "/AccountTokens/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountTokenFindOne: function (params, options) {
        var baseUrl = "/AccountTokens/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenPatchOrCreate: function (params, options) {
        var baseUrl = "/AccountTokens";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation user.
     * @param id AccountToken id
     * @param refresh
     */
    accountTokenPrototypeGetUser: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenPrototypeGetUser");
        }
        var baseUrl = "/AccountTokens/{id}/user".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id AccountToken id
     * @param data An object of model property name/value pairs
     */
    accountTokenPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenPrototypePatchAttributes");
        }
        var baseUrl = "/AccountTokens/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountTokenReplaceByIdPostAccountTokensidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenReplaceByIdPostAccountTokensidReplace");
        }
        var baseUrl = "/AccountTokens/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountTokenReplaceByIdPutAccountTokensid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling accountTokenReplaceByIdPutAccountTokensid");
        }
        var baseUrl = "/AccountTokens/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate: function (params, options) {
        var baseUrl = "/AccountTokens/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenReplaceOrCreatePutAccountTokens: function (params, options) {
        var baseUrl = "/AccountTokens";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountTokenUpdateAll: function (params, options) {
        var baseUrl = "/AccountTokens/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountTokenUpsertWithWhere: function (params, options) {
        var baseUrl = "/AccountTokens/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * AccountTokenApi - functional programming interface
 */
export var AccountTokenApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    accountTokenCount: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    accountTokenCreate: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountTokenCreateChangeStreamGetAccountTokensChangeStream: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenCreateChangeStreamGetAccountTokensChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    accountTokenCreateChangeStreamPostAccountTokensChangeStream: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenCreateChangeStreamPostAccountTokensChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    accountTokenDeleteById: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountTokenExistsGetAccountTokensidExists: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenExistsGetAccountTokensidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    accountTokenExistsHeadAccountTokensid: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenExistsHeadAccountTokensid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountTokenFind: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    accountTokenFindById: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    accountTokenFindOne: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenPatchOrCreate: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation user.
     * @param id AccountToken id
     * @param refresh
     */
    accountTokenPrototypeGetUser: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenPrototypeGetUser(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id AccountToken id
     * @param data An object of model property name/value pairs
     */
    accountTokenPrototypePatchAttributes: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountTokenReplaceByIdPostAccountTokensidReplace: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenReplaceByIdPostAccountTokensidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    accountTokenReplaceByIdPutAccountTokensid: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenReplaceByIdPutAccountTokensid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    accountTokenReplaceOrCreatePutAccountTokens: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenReplaceOrCreatePutAccountTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountTokenUpdateAll: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    accountTokenUpsertWithWhere: function (params, options) {
        var fetchArgs = AccountTokenApiFetchParamCreator.accountTokenUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * AccountTokenApi - object-oriented interface
 */
var AccountTokenApi = /** @class */ (function (_super) {
    __extends(AccountTokenApi, _super);
    function AccountTokenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    AccountTokenApi.prototype.accountTokenCount = function (params, options) {
        return AccountTokenApiFp.accountTokenCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenCreate = function (params, options) {
        return AccountTokenApiFp.accountTokenCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    AccountTokenApi.prototype.accountTokenCreateChangeStreamGetAccountTokensChangeStream = function (params, options) {
        return AccountTokenApiFp.accountTokenCreateChangeStreamGetAccountTokensChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    AccountTokenApi.prototype.accountTokenCreateChangeStreamPostAccountTokensChangeStream = function (params, options) {
        return AccountTokenApiFp.accountTokenCreateChangeStreamPostAccountTokensChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    AccountTokenApi.prototype.accountTokenDeleteById = function (params, options) {
        return AccountTokenApiFp.accountTokenDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    AccountTokenApi.prototype.accountTokenExistsGetAccountTokensidExists = function (params, options) {
        return AccountTokenApiFp.accountTokenExistsGetAccountTokensidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    AccountTokenApi.prototype.accountTokenExistsHeadAccountTokensid = function (params, options) {
        return AccountTokenApiFp.accountTokenExistsHeadAccountTokensid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    AccountTokenApi.prototype.accountTokenFind = function (params, options) {
        return AccountTokenApiFp.accountTokenFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    AccountTokenApi.prototype.accountTokenFindById = function (params, options) {
        return AccountTokenApiFp.accountTokenFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    AccountTokenApi.prototype.accountTokenFindOne = function (params, options) {
        return AccountTokenApiFp.accountTokenFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenPatchOrCreate = function (params, options) {
        return AccountTokenApiFp.accountTokenPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation user.
     * @param id AccountToken id
     * @param refresh
     */
    AccountTokenApi.prototype.accountTokenPrototypeGetUser = function (params, options) {
        return AccountTokenApiFp.accountTokenPrototypeGetUser(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id AccountToken id
     * @param data An object of model property name/value pairs
     */
    AccountTokenApi.prototype.accountTokenPrototypePatchAttributes = function (params, options) {
        return AccountTokenApiFp.accountTokenPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenReplaceByIdPostAccountTokensidReplace = function (params, options) {
        return AccountTokenApiFp.accountTokenReplaceByIdPostAccountTokensidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenReplaceByIdPutAccountTokensid = function (params, options) {
        return AccountTokenApiFp.accountTokenReplaceByIdPutAccountTokensid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate = function (params, options) {
        return AccountTokenApiFp.accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    AccountTokenApi.prototype.accountTokenReplaceOrCreatePutAccountTokens = function (params, options) {
        return AccountTokenApiFp.accountTokenReplaceOrCreatePutAccountTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    AccountTokenApi.prototype.accountTokenUpdateAll = function (params, options) {
        return AccountTokenApiFp.accountTokenUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    AccountTokenApi.prototype.accountTokenUpsertWithWhere = function (params, options) {
        return AccountTokenApiFp.accountTokenUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return AccountTokenApi;
}(BaseAPI));
export { AccountTokenApi };
/**
 * AccountTokenApi - factory interface
 */
export var AccountTokenApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        accountTokenCount: function (params, options) {
            return AccountTokenApiFp.accountTokenCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        accountTokenCreate: function (params, options) {
            return AccountTokenApiFp.accountTokenCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        accountTokenCreateChangeStreamGetAccountTokensChangeStream: function (params, options) {
            return AccountTokenApiFp.accountTokenCreateChangeStreamGetAccountTokensChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        accountTokenCreateChangeStreamPostAccountTokensChangeStream: function (params, options) {
            return AccountTokenApiFp.accountTokenCreateChangeStreamPostAccountTokensChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        accountTokenDeleteById: function (params, options) {
            return AccountTokenApiFp.accountTokenDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        accountTokenExistsGetAccountTokensidExists: function (params, options) {
            return AccountTokenApiFp.accountTokenExistsGetAccountTokensidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        accountTokenExistsHeadAccountTokensid: function (params, options) {
            return AccountTokenApiFp.accountTokenExistsHeadAccountTokensid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        accountTokenFind: function (params, options) {
            return AccountTokenApiFp.accountTokenFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        accountTokenFindById: function (params, options) {
            return AccountTokenApiFp.accountTokenFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        accountTokenFindOne: function (params, options) {
            return AccountTokenApiFp.accountTokenFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountTokenPatchOrCreate: function (params, options) {
            return AccountTokenApiFp.accountTokenPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation user.
         * @param id AccountToken id
         * @param refresh
         */
        accountTokenPrototypeGetUser: function (params, options) {
            return AccountTokenApiFp.accountTokenPrototypeGetUser(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id AccountToken id
         * @param data An object of model property name/value pairs
         */
        accountTokenPrototypePatchAttributes: function (params, options) {
            return AccountTokenApiFp.accountTokenPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        accountTokenReplaceByIdPostAccountTokensidReplace: function (params, options) {
            return AccountTokenApiFp.accountTokenReplaceByIdPostAccountTokensidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        accountTokenReplaceByIdPutAccountTokensid: function (params, options) {
            return AccountTokenApiFp.accountTokenReplaceByIdPutAccountTokensid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate: function (params, options) {
            return AccountTokenApiFp.accountTokenReplaceOrCreatePostAccountTokensReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        accountTokenReplaceOrCreatePutAccountTokens: function (params, options) {
            return AccountTokenApiFp.accountTokenReplaceOrCreatePutAccountTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        accountTokenUpdateAll: function (params, options) {
            return AccountTokenApiFp.accountTokenUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        accountTokenUpsertWithWhere: function (params, options) {
            return AccountTokenApiFp.accountTokenUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * CityApi - fetch parameter creator
 */
export var CityApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    cityCount: function (params, options) {
        var baseUrl = "/Cities/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    cityCreate: function (params, options) {
        var baseUrl = "/Cities";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    cityCreateChangeStreamGetCitiesChangeStream: function (params, options) {
        var baseUrl = "/Cities/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    cityCreateChangeStreamPostCitiesChangeStream: function (params, options) {
        var baseUrl = "/Cities/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    cityDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityDeleteById");
        }
        var baseUrl = "/Cities/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    cityExistsGetCitiesidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityExistsGetCitiesidExists");
        }
        var baseUrl = "/Cities/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    cityExistsHeadCitiesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityExistsHeadCitiesid");
        }
        var baseUrl = "/Cities/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    cityFind: function (params, options) {
        var baseUrl = "/Cities";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    cityFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityFindById");
        }
        var baseUrl = "/Cities/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    cityFindOne: function (params, options) {
        var baseUrl = "/Cities/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityPatchOrCreate: function (params, options) {
        var baseUrl = "/Cities";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts districts of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    cityPrototypeCountDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeCountDistricts");
        }
        var baseUrl = "/Cities/{id}/districts/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts schools of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    cityPrototypeCountSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeCountSchools");
        }
        var baseUrl = "/Cities/{id}/schools/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in districts of this model.
     * @param id City id
     * @param data
     */
    cityPrototypeCreateDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeCreateDistricts");
        }
        var baseUrl = "/Cities/{id}/districts".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in schools of this model.
     * @param id City id
     * @param data
     */
    cityPrototypeCreateSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeCreateSchools");
        }
        var baseUrl = "/Cities/{id}/schools".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all districts of this model.
     * @param id City id
     */
    cityPrototypeDeleteDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeDeleteDistricts");
        }
        var baseUrl = "/Cities/{id}/districts".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all schools of this model.
     * @param id City id
     */
    cityPrototypeDeleteSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeDeleteSchools");
        }
        var baseUrl = "/Cities/{id}/schools".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    cityPrototypeDestroyByIdDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeDestroyByIdDistricts");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeDestroyByIdDistricts");
        }
        var baseUrl = "/Cities/{id}/districts/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    cityPrototypeDestroyByIdSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeDestroyByIdSchools");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeDestroyByIdSchools");
        }
        var baseUrl = "/Cities/{id}/schools/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    cityPrototypeFindByIdDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeFindByIdDistricts");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeFindByIdDistricts");
        }
        var baseUrl = "/Cities/{id}/districts/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    cityPrototypeFindByIdSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeFindByIdSchools");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeFindByIdSchools");
        }
        var baseUrl = "/Cities/{id}/schools/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries districts of City.
     * @param id City id
     * @param filter
     */
    cityPrototypeGetDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeGetDistricts");
        }
        var baseUrl = "/Cities/{id}/districts".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries schools of City.
     * @param id City id
     * @param filter
     */
    cityPrototypeGetSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeGetSchools");
        }
        var baseUrl = "/Cities/{id}/schools".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id City id
     * @param data An object of model property name/value pairs
     */
    cityPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypePatchAttributes");
        }
        var baseUrl = "/Cities/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     * @param data
     */
    cityPrototypeUpdateByIdDistricts: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeUpdateByIdDistricts");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeUpdateByIdDistricts");
        }
        var baseUrl = "/Cities/{id}/districts/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     * @param data
     */
    cityPrototypeUpdateByIdSchools: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityPrototypeUpdateByIdSchools");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling cityPrototypeUpdateByIdSchools");
        }
        var baseUrl = "/Cities/{id}/schools/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    cityReplaceByIdPostCitiesidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityReplaceByIdPostCitiesidReplace");
        }
        var baseUrl = "/Cities/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    cityReplaceByIdPutCitiesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling cityReplaceByIdPutCitiesid");
        }
        var baseUrl = "/Cities/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityReplaceOrCreatePostCitiesReplaceOrCreate: function (params, options) {
        var baseUrl = "/Cities/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityReplaceOrCreatePutCities: function (params, options) {
        var baseUrl = "/Cities";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    cityUpdateAll: function (params, options) {
        var baseUrl = "/Cities/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    cityUpsertWithWhere: function (params, options) {
        var baseUrl = "/Cities/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * CityApi - functional programming interface
 */
export var CityApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    cityCount: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    cityCreate: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    cityCreateChangeStreamGetCitiesChangeStream: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityCreateChangeStreamGetCitiesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    cityCreateChangeStreamPostCitiesChangeStream: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityCreateChangeStreamPostCitiesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    cityDeleteById: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    cityExistsGetCitiesidExists: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityExistsGetCitiesidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    cityExistsHeadCitiesid: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityExistsHeadCitiesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    cityFind: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    cityFindById: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    cityFindOne: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityPatchOrCreate: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts districts of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    cityPrototypeCountDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeCountDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts schools of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    cityPrototypeCountSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeCountSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in districts of this model.
     * @param id City id
     * @param data
     */
    cityPrototypeCreateDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeCreateDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in schools of this model.
     * @param id City id
     * @param data
     */
    cityPrototypeCreateSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeCreateSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all districts of this model.
     * @param id City id
     */
    cityPrototypeDeleteDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeDeleteDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all schools of this model.
     * @param id City id
     */
    cityPrototypeDeleteSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeDeleteSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    cityPrototypeDestroyByIdDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeDestroyByIdDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    cityPrototypeDestroyByIdSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeDestroyByIdSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    cityPrototypeFindByIdDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeFindByIdDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    cityPrototypeFindByIdSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeFindByIdSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries districts of City.
     * @param id City id
     * @param filter
     */
    cityPrototypeGetDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeGetDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries schools of City.
     * @param id City id
     * @param filter
     */
    cityPrototypeGetSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeGetSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id City id
     * @param data An object of model property name/value pairs
     */
    cityPrototypePatchAttributes: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     * @param data
     */
    cityPrototypeUpdateByIdDistricts: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeUpdateByIdDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     * @param data
     */
    cityPrototypeUpdateByIdSchools: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityPrototypeUpdateByIdSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    cityReplaceByIdPostCitiesidReplace: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityReplaceByIdPostCitiesidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    cityReplaceByIdPutCitiesid: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityReplaceByIdPutCitiesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityReplaceOrCreatePostCitiesReplaceOrCreate: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityReplaceOrCreatePostCitiesReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    cityReplaceOrCreatePutCities: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityReplaceOrCreatePutCities(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    cityUpdateAll: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    cityUpsertWithWhere: function (params, options) {
        var fetchArgs = CityApiFetchParamCreator.cityUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * CityApi - object-oriented interface
 */
var CityApi = /** @class */ (function (_super) {
    __extends(CityApi, _super);
    function CityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    CityApi.prototype.cityCount = function (params, options) {
        return CityApiFp.cityCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    CityApi.prototype.cityCreate = function (params, options) {
        return CityApiFp.cityCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    CityApi.prototype.cityCreateChangeStreamGetCitiesChangeStream = function (params, options) {
        return CityApiFp.cityCreateChangeStreamGetCitiesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    CityApi.prototype.cityCreateChangeStreamPostCitiesChangeStream = function (params, options) {
        return CityApiFp.cityCreateChangeStreamPostCitiesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    CityApi.prototype.cityDeleteById = function (params, options) {
        return CityApiFp.cityDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    CityApi.prototype.cityExistsGetCitiesidExists = function (params, options) {
        return CityApiFp.cityExistsGetCitiesidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    CityApi.prototype.cityExistsHeadCitiesid = function (params, options) {
        return CityApiFp.cityExistsHeadCitiesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    CityApi.prototype.cityFind = function (params, options) {
        return CityApiFp.cityFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    CityApi.prototype.cityFindById = function (params, options) {
        return CityApiFp.cityFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    CityApi.prototype.cityFindOne = function (params, options) {
        return CityApiFp.cityFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    CityApi.prototype.cityPatchOrCreate = function (params, options) {
        return CityApiFp.cityPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts districts of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    CityApi.prototype.cityPrototypeCountDistricts = function (params, options) {
        return CityApiFp.cityPrototypeCountDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts schools of City.
     * @param id City id
     * @param where Criteria to match model instances
     */
    CityApi.prototype.cityPrototypeCountSchools = function (params, options) {
        return CityApiFp.cityPrototypeCountSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in districts of this model.
     * @param id City id
     * @param data
     */
    CityApi.prototype.cityPrototypeCreateDistricts = function (params, options) {
        return CityApiFp.cityPrototypeCreateDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in schools of this model.
     * @param id City id
     * @param data
     */
    CityApi.prototype.cityPrototypeCreateSchools = function (params, options) {
        return CityApiFp.cityPrototypeCreateSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all districts of this model.
     * @param id City id
     */
    CityApi.prototype.cityPrototypeDeleteDistricts = function (params, options) {
        return CityApiFp.cityPrototypeDeleteDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all schools of this model.
     * @param id City id
     */
    CityApi.prototype.cityPrototypeDeleteSchools = function (params, options) {
        return CityApiFp.cityPrototypeDeleteSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    CityApi.prototype.cityPrototypeDestroyByIdDistricts = function (params, options) {
        return CityApiFp.cityPrototypeDestroyByIdDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    CityApi.prototype.cityPrototypeDestroyByIdSchools = function (params, options) {
        return CityApiFp.cityPrototypeDestroyByIdSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     */
    CityApi.prototype.cityPrototypeFindByIdDistricts = function (params, options) {
        return CityApiFp.cityPrototypeFindByIdDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     */
    CityApi.prototype.cityPrototypeFindByIdSchools = function (params, options) {
        return CityApiFp.cityPrototypeFindByIdSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries districts of City.
     * @param id City id
     * @param filter
     */
    CityApi.prototype.cityPrototypeGetDistricts = function (params, options) {
        return CityApiFp.cityPrototypeGetDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries schools of City.
     * @param id City id
     * @param filter
     */
    CityApi.prototype.cityPrototypeGetSchools = function (params, options) {
        return CityApiFp.cityPrototypeGetSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id City id
     * @param data An object of model property name/value pairs
     */
    CityApi.prototype.cityPrototypePatchAttributes = function (params, options) {
        return CityApiFp.cityPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for districts.
     * @param id City id
     * @param fk Foreign key for districts
     * @param data
     */
    CityApi.prototype.cityPrototypeUpdateByIdDistricts = function (params, options) {
        return CityApiFp.cityPrototypeUpdateByIdDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for schools.
     * @param id City id
     * @param fk Foreign key for schools
     * @param data
     */
    CityApi.prototype.cityPrototypeUpdateByIdSchools = function (params, options) {
        return CityApiFp.cityPrototypeUpdateByIdSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    CityApi.prototype.cityReplaceByIdPostCitiesidReplace = function (params, options) {
        return CityApiFp.cityReplaceByIdPostCitiesidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    CityApi.prototype.cityReplaceByIdPutCitiesid = function (params, options) {
        return CityApiFp.cityReplaceByIdPutCitiesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    CityApi.prototype.cityReplaceOrCreatePostCitiesReplaceOrCreate = function (params, options) {
        return CityApiFp.cityReplaceOrCreatePostCitiesReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    CityApi.prototype.cityReplaceOrCreatePutCities = function (params, options) {
        return CityApiFp.cityReplaceOrCreatePutCities(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    CityApi.prototype.cityUpdateAll = function (params, options) {
        return CityApiFp.cityUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    CityApi.prototype.cityUpsertWithWhere = function (params, options) {
        return CityApiFp.cityUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return CityApi;
}(BaseAPI));
export { CityApi };
/**
 * CityApi - factory interface
 */
export var CityApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        cityCount: function (params, options) {
            return CityApiFp.cityCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        cityCreate: function (params, options) {
            return CityApiFp.cityCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        cityCreateChangeStreamGetCitiesChangeStream: function (params, options) {
            return CityApiFp.cityCreateChangeStreamGetCitiesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        cityCreateChangeStreamPostCitiesChangeStream: function (params, options) {
            return CityApiFp.cityCreateChangeStreamPostCitiesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        cityDeleteById: function (params, options) {
            return CityApiFp.cityDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        cityExistsGetCitiesidExists: function (params, options) {
            return CityApiFp.cityExistsGetCitiesidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        cityExistsHeadCitiesid: function (params, options) {
            return CityApiFp.cityExistsHeadCitiesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        cityFind: function (params, options) {
            return CityApiFp.cityFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        cityFindById: function (params, options) {
            return CityApiFp.cityFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        cityFindOne: function (params, options) {
            return CityApiFp.cityFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        cityPatchOrCreate: function (params, options) {
            return CityApiFp.cityPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts districts of City.
         * @param id City id
         * @param where Criteria to match model instances
         */
        cityPrototypeCountDistricts: function (params, options) {
            return CityApiFp.cityPrototypeCountDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts schools of City.
         * @param id City id
         * @param where Criteria to match model instances
         */
        cityPrototypeCountSchools: function (params, options) {
            return CityApiFp.cityPrototypeCountSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in districts of this model.
         * @param id City id
         * @param data
         */
        cityPrototypeCreateDistricts: function (params, options) {
            return CityApiFp.cityPrototypeCreateDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in schools of this model.
         * @param id City id
         * @param data
         */
        cityPrototypeCreateSchools: function (params, options) {
            return CityApiFp.cityPrototypeCreateSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all districts of this model.
         * @param id City id
         */
        cityPrototypeDeleteDistricts: function (params, options) {
            return CityApiFp.cityPrototypeDeleteDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all schools of this model.
         * @param id City id
         */
        cityPrototypeDeleteSchools: function (params, options) {
            return CityApiFp.cityPrototypeDeleteSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for districts.
         * @param id City id
         * @param fk Foreign key for districts
         */
        cityPrototypeDestroyByIdDistricts: function (params, options) {
            return CityApiFp.cityPrototypeDestroyByIdDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for schools.
         * @param id City id
         * @param fk Foreign key for schools
         */
        cityPrototypeDestroyByIdSchools: function (params, options) {
            return CityApiFp.cityPrototypeDestroyByIdSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for districts.
         * @param id City id
         * @param fk Foreign key for districts
         */
        cityPrototypeFindByIdDistricts: function (params, options) {
            return CityApiFp.cityPrototypeFindByIdDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for schools.
         * @param id City id
         * @param fk Foreign key for schools
         */
        cityPrototypeFindByIdSchools: function (params, options) {
            return CityApiFp.cityPrototypeFindByIdSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries districts of City.
         * @param id City id
         * @param filter
         */
        cityPrototypeGetDistricts: function (params, options) {
            return CityApiFp.cityPrototypeGetDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries schools of City.
         * @param id City id
         * @param filter
         */
        cityPrototypeGetSchools: function (params, options) {
            return CityApiFp.cityPrototypeGetSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id City id
         * @param data An object of model property name/value pairs
         */
        cityPrototypePatchAttributes: function (params, options) {
            return CityApiFp.cityPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for districts.
         * @param id City id
         * @param fk Foreign key for districts
         * @param data
         */
        cityPrototypeUpdateByIdDistricts: function (params, options) {
            return CityApiFp.cityPrototypeUpdateByIdDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for schools.
         * @param id City id
         * @param fk Foreign key for schools
         * @param data
         */
        cityPrototypeUpdateByIdSchools: function (params, options) {
            return CityApiFp.cityPrototypeUpdateByIdSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        cityReplaceByIdPostCitiesidReplace: function (params, options) {
            return CityApiFp.cityReplaceByIdPostCitiesidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        cityReplaceByIdPutCitiesid: function (params, options) {
            return CityApiFp.cityReplaceByIdPutCitiesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        cityReplaceOrCreatePostCitiesReplaceOrCreate: function (params, options) {
            return CityApiFp.cityReplaceOrCreatePostCitiesReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        cityReplaceOrCreatePutCities: function (params, options) {
            return CityApiFp.cityReplaceOrCreatePutCities(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        cityUpdateAll: function (params, options) {
            return CityApiFp.cityUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        cityUpsertWithWhere: function (params, options) {
            return CityApiFp.cityUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * ContainerApi - fetch parameter creator
 */
export var ContainerApiFetchParamCreator = {
    /**
     *
     * @param options
     */
    containerCreateContainer: function (params, options) {
        var baseUrl = "/Containers";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["options"]) {
            fetchOptions.body = JSON.stringify(params["options"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     */
    containerDestroyContainer: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerDestroyContainer");
        }
        var baseUrl = "/Containers/{container}".replace("{" + "container" + "}", "" + params["container"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerDownload: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerDownload");
        }
        // verify required parameter "file" is set
        if (params["file"] == null) {
            throw new Error("Missing required parameter file when calling containerDownload");
        }
        var baseUrl = "/Containers/{container}/download/{file}"
            .replace("{" + "container" + "}", "" + params["container"])
            .replace("{" + "file" + "}", "" + params["file"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     */
    containerGetContainer: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerGetContainer");
        }
        var baseUrl = "/Containers/{container}".replace("{" + "container" + "}", "" + params["container"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     */
    containerGetContainers: function (options) {
        var baseUrl = "/Containers";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerGetFile: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerGetFile");
        }
        // verify required parameter "file" is set
        if (params["file"] == null) {
            throw new Error("Missing required parameter file when calling containerGetFile");
        }
        var baseUrl = "/Containers/{container}/files/{file}"
            .replace("{" + "container" + "}", "" + params["container"])
            .replace("{" + "file" + "}", "" + params["file"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     */
    containerGetFiles: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerGetFiles");
        }
        var baseUrl = "/Containers/{container}/files".replace("{" + "container" + "}", "" + params["container"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerRemoveFile: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerRemoveFile");
        }
        // verify required parameter "file" is set
        if (params["file"] == null) {
            throw new Error("Missing required parameter file when calling containerRemoveFile");
        }
        var baseUrl = "/Containers/{container}/files/{file}"
            .replace("{" + "container" + "}", "" + params["container"])
            .replace("{" + "file" + "}", "" + params["file"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @param container
     */
    containerUpload: function (params, options) {
        // verify required parameter "container" is set
        if (params["container"] == null) {
            throw new Error("Missing required parameter container when calling containerUpload");
        }
        var baseUrl = "/Containers/{container}/upload".replace("{" + "container" + "}", "" + params["container"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ContainerApi - functional programming interface
 */
export var ContainerApiFp = {
    /**
     *
     * @param options
     */
    containerCreateContainer: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerCreateContainer(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     */
    containerDestroyContainer: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerDestroyContainer(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerDownload: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerDownload(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     */
    containerGetContainer: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerGetContainer(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     */
    containerGetContainers: function (options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerGetContainers(options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerGetFile: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerGetFile(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     */
    containerGetFiles: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerGetFiles(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     * @param file
     */
    containerRemoveFile: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerRemoveFile(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @param container
     */
    containerUpload: function (params, options) {
        var fetchArgs = ContainerApiFetchParamCreator.containerUpload(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ContainerApi - object-oriented interface
 */
var ContainerApi = /** @class */ (function (_super) {
    __extends(ContainerApi, _super);
    function ContainerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param options
     */
    ContainerApi.prototype.containerCreateContainer = function (params, options) {
        return ContainerApiFp.containerCreateContainer(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     */
    ContainerApi.prototype.containerDestroyContainer = function (params, options) {
        return ContainerApiFp.containerDestroyContainer(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     * @param file
     */
    ContainerApi.prototype.containerDownload = function (params, options) {
        return ContainerApiFp.containerDownload(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     */
    ContainerApi.prototype.containerGetContainer = function (params, options) {
        return ContainerApiFp.containerGetContainer(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     */
    ContainerApi.prototype.containerGetContainers = function (options) {
        return ContainerApiFp.containerGetContainers(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     * @param file
     */
    ContainerApi.prototype.containerGetFile = function (params, options) {
        return ContainerApiFp.containerGetFile(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     */
    ContainerApi.prototype.containerGetFiles = function (params, options) {
        return ContainerApiFp.containerGetFiles(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     * @param file
     */
    ContainerApi.prototype.containerRemoveFile = function (params, options) {
        return ContainerApiFp.containerRemoveFile(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @param container
     */
    ContainerApi.prototype.containerUpload = function (params, options) {
        return ContainerApiFp.containerUpload(params, options)(this.fetch, this.basePath);
    };
    return ContainerApi;
}(BaseAPI));
export { ContainerApi };
/**
 * ContainerApi - factory interface
 */
export var ContainerApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @param options
         */
        containerCreateContainer: function (params, options) {
            return ContainerApiFp.containerCreateContainer(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         */
        containerDestroyContainer: function (params, options) {
            return ContainerApiFp.containerDestroyContainer(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         * @param file
         */
        containerDownload: function (params, options) {
            return ContainerApiFp.containerDownload(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         */
        containerGetContainer: function (params, options) {
            return ContainerApiFp.containerGetContainer(params, options)(fetch, basePath);
        },
        /**
         *
         */
        containerGetContainers: function (options) {
            return ContainerApiFp.containerGetContainers(options)(fetch, basePath);
        },
        /**
         *
         * @param container
         * @param file
         */
        containerGetFile: function (params, options) {
            return ContainerApiFp.containerGetFile(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         */
        containerGetFiles: function (params, options) {
            return ContainerApiFp.containerGetFiles(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         * @param file
         */
        containerRemoveFile: function (params, options) {
            return ContainerApiFp.containerRemoveFile(params, options)(fetch, basePath);
        },
        /**
         *
         * @param container
         */
        containerUpload: function (params, options) {
            return ContainerApiFp.containerUpload(params, options)(fetch, basePath);
        },
    };
};
/**
 * ContestApi - fetch parameter creator
 */
export var ContestApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    contestCount: function (params, options) {
        var baseUrl = "/Contests/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    contestCreate: function (params, options) {
        var baseUrl = "/Contests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestCreateChangeStreamGetContestsChangeStream: function (params, options) {
        var baseUrl = "/Contests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestCreateChangeStreamPostContestsChangeStream: function (params, options) {
        var baseUrl = "/Contests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    contestDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestDeleteById");
        }
        var baseUrl = "/Contests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestExistsGetContestsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestExistsGetContestsidExists");
        }
        var baseUrl = "/Contests/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestExistsHeadContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestExistsHeadContestsid");
        }
        var baseUrl = "/Contests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestFind: function (params, options) {
        var baseUrl = "/Contests";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    contestFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestFindById");
        }
        var baseUrl = "/Contests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestFindOne: function (params, options) {
        var baseUrl = "/Contests/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestPatchOrCreate: function (params, options) {
        var baseUrl = "/Contests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts contestGuides of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCountContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts rounds of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCountRounds");
        }
        var baseUrl = "/Contests/{id}/rounds/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts students of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCountStudents");
        }
        var baseUrl = "/Contests/{id}/students/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts teachers of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCountTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCreateContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCreateRounds");
        }
        var baseUrl = "/Contests/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCreateStudents");
        }
        var baseUrl = "/Contests/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeCreateTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDeleteContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDeleteRounds");
        }
        var baseUrl = "/Contests/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDeleteStudents");
        }
        var baseUrl = "/Contests/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDeleteTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    contestPrototypeDestroyByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDestroyByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeDestroyByIdContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    contestPrototypeDestroyByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDestroyByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeDestroyByIdRounds");
        }
        var baseUrl = "/Contests/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeDestroyByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDestroyByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeDestroyByIdStudents");
        }
        var baseUrl = "/Contests/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeDestroyByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeDestroyByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeDestroyByIdTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeExistsStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeExistsStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeExistsStudents");
        }
        var baseUrl = "/Contests/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeExistsTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeExistsTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeExistsTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    contestPrototypeFindByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeFindByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeFindByIdContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    contestPrototypeFindByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeFindByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeFindByIdRounds");
        }
        var baseUrl = "/Contests/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeFindByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeFindByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeFindByIdStudents");
        }
        var baseUrl = "/Contests/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeFindByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeFindByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeFindByIdTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Contest id
     * @param refresh
     */
    contestPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetAccount");
        }
        var baseUrl = "/Contests/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Contest id
     * @param refresh
     */
    contestPrototypeGetCity: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetCity");
        }
        var baseUrl = "/Contests/{id}/city".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries contestGuides of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries rounds of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetRounds");
        }
        var baseUrl = "/Contests/{id}/rounds".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries students of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetStudents");
        }
        var baseUrl = "/Contests/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries teachers of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeGetTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    contestPrototypeLinkStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeLinkStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeLinkStudents");
        }
        var baseUrl = "/Contests/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    contestPrototypeLinkTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeLinkTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeLinkTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Contest id
     * @param data An object of model property name/value pairs
     */
    contestPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypePatchAttributes");
        }
        var baseUrl = "/Contests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeUnlinkStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUnlinkStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUnlinkStudents");
        }
        var baseUrl = "/Contests/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeUnlinkTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUnlinkTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUnlinkTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    contestPrototypeUpdateByIdContestGuides: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUpdateByIdContestGuides");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUpdateByIdContestGuides");
        }
        var baseUrl = "/Contests/{id}/contestGuides/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     * @param data
     */
    contestPrototypeUpdateByIdRounds: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUpdateByIdRounds");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUpdateByIdRounds");
        }
        var baseUrl = "/Contests/{id}/rounds/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    contestPrototypeUpdateByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUpdateByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUpdateByIdStudents");
        }
        var baseUrl = "/Contests/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    contestPrototypeUpdateByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestPrototypeUpdateByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling contestPrototypeUpdateByIdTeachers");
        }
        var baseUrl = "/Contests/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestReplaceByIdPostContestsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestReplaceByIdPostContestsidReplace");
        }
        var baseUrl = "/Contests/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestReplaceByIdPutContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestReplaceByIdPutContestsid");
        }
        var baseUrl = "/Contests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestReplaceOrCreatePostContestsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Contests/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestReplaceOrCreatePutContests: function (params, options) {
        var baseUrl = "/Contests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestUpdateAll: function (params, options) {
        var baseUrl = "/Contests/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestUpsertWithWhere: function (params, options) {
        var baseUrl = "/Contests/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ContestApi - functional programming interface
 */
export var ContestApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    contestCount: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    contestCreate: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestCreateChangeStreamGetContestsChangeStream: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestCreateChangeStreamGetContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestCreateChangeStreamPostContestsChangeStream: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestCreateChangeStreamPostContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    contestDeleteById: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestExistsGetContestsidExists: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestExistsGetContestsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestExistsHeadContestsid: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestExistsHeadContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestFind: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    contestFindById: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestFindOne: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestPatchOrCreate: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts contestGuides of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCountContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts rounds of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCountRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts students of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCountStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts teachers of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    contestPrototypeCountTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCountTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCreateContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCreateRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCreateStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Contest id
     * @param data
     */
    contestPrototypeCreateTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeCreateTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDeleteContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDeleteRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDeleteStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Contest id
     */
    contestPrototypeDeleteTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDeleteTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    contestPrototypeDestroyByIdContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDestroyByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    contestPrototypeDestroyByIdRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDestroyByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeDestroyByIdStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDestroyByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeDestroyByIdTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeDestroyByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeExistsStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeExistsStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeExistsTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeExistsTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    contestPrototypeFindByIdContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeFindByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    contestPrototypeFindByIdRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeFindByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeFindByIdStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeFindByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeFindByIdTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeFindByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Contest id
     * @param refresh
     */
    contestPrototypeGetAccount: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Contest id
     * @param refresh
     */
    contestPrototypeGetCity: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetCity(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries contestGuides of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries rounds of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries students of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries teachers of Contest.
     * @param id Contest id
     * @param filter
     */
    contestPrototypeGetTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeGetTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    contestPrototypeLinkStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeLinkStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    contestPrototypeLinkTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeLinkTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Contest id
     * @param data An object of model property name/value pairs
     */
    contestPrototypePatchAttributes: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    contestPrototypeUnlinkStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUnlinkStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    contestPrototypeUnlinkTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUnlinkTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    contestPrototypeUpdateByIdContestGuides: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUpdateByIdContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     * @param data
     */
    contestPrototypeUpdateByIdRounds: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUpdateByIdRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    contestPrototypeUpdateByIdStudents: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUpdateByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    contestPrototypeUpdateByIdTeachers: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestPrototypeUpdateByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestReplaceByIdPostContestsidReplace: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestReplaceByIdPostContestsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestReplaceByIdPutContestsid: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestReplaceByIdPutContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestReplaceOrCreatePostContestsReplaceOrCreate: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestReplaceOrCreatePostContestsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestReplaceOrCreatePutContests: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestReplaceOrCreatePutContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestUpdateAll: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestUpsertWithWhere: function (params, options) {
        var fetchArgs = ContestApiFetchParamCreator.contestUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ContestApi - object-oriented interface
 */
var ContestApi = /** @class */ (function (_super) {
    __extends(ContestApi, _super);
    function ContestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ContestApi.prototype.contestCount = function (params, options) {
        return ContestApiFp.contestCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ContestApi.prototype.contestCreate = function (params, options) {
        return ContestApiFp.contestCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ContestApi.prototype.contestCreateChangeStreamGetContestsChangeStream = function (params, options) {
        return ContestApiFp.contestCreateChangeStreamGetContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ContestApi.prototype.contestCreateChangeStreamPostContestsChangeStream = function (params, options) {
        return ContestApiFp.contestCreateChangeStreamPostContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ContestApi.prototype.contestDeleteById = function (params, options) {
        return ContestApiFp.contestDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ContestApi.prototype.contestExistsGetContestsidExists = function (params, options) {
        return ContestApiFp.contestExistsGetContestsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ContestApi.prototype.contestExistsHeadContestsid = function (params, options) {
        return ContestApiFp.contestExistsHeadContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ContestApi.prototype.contestFind = function (params, options) {
        return ContestApiFp.contestFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ContestApi.prototype.contestFindById = function (params, options) {
        return ContestApiFp.contestFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ContestApi.prototype.contestFindOne = function (params, options) {
        return ContestApiFp.contestFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestApi.prototype.contestPatchOrCreate = function (params, options) {
        return ContestApiFp.contestPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts contestGuides of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    ContestApi.prototype.contestPrototypeCountContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeCountContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts rounds of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    ContestApi.prototype.contestPrototypeCountRounds = function (params, options) {
        return ContestApiFp.contestPrototypeCountRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts students of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    ContestApi.prototype.contestPrototypeCountStudents = function (params, options) {
        return ContestApiFp.contestPrototypeCountStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts teachers of Contest.
     * @param id Contest id
     * @param where Criteria to match model instances
     */
    ContestApi.prototype.contestPrototypeCountTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeCountTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in contestGuides of this model.
     * @param id Contest id
     * @param data
     */
    ContestApi.prototype.contestPrototypeCreateContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeCreateContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in rounds of this model.
     * @param id Contest id
     * @param data
     */
    ContestApi.prototype.contestPrototypeCreateRounds = function (params, options) {
        return ContestApiFp.contestPrototypeCreateRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Contest id
     * @param data
     */
    ContestApi.prototype.contestPrototypeCreateStudents = function (params, options) {
        return ContestApiFp.contestPrototypeCreateStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Contest id
     * @param data
     */
    ContestApi.prototype.contestPrototypeCreateTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeCreateTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all contestGuides of this model.
     * @param id Contest id
     */
    ContestApi.prototype.contestPrototypeDeleteContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeDeleteContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all rounds of this model.
     * @param id Contest id
     */
    ContestApi.prototype.contestPrototypeDeleteRounds = function (params, options) {
        return ContestApiFp.contestPrototypeDeleteRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Contest id
     */
    ContestApi.prototype.contestPrototypeDeleteStudents = function (params, options) {
        return ContestApiFp.contestPrototypeDeleteStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Contest id
     */
    ContestApi.prototype.contestPrototypeDeleteTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeDeleteTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    ContestApi.prototype.contestPrototypeDestroyByIdContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeDestroyByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    ContestApi.prototype.contestPrototypeDestroyByIdRounds = function (params, options) {
        return ContestApiFp.contestPrototypeDestroyByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    ContestApi.prototype.contestPrototypeDestroyByIdStudents = function (params, options) {
        return ContestApiFp.contestPrototypeDestroyByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    ContestApi.prototype.contestPrototypeDestroyByIdTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeDestroyByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    ContestApi.prototype.contestPrototypeExistsStudents = function (params, options) {
        return ContestApiFp.contestPrototypeExistsStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    ContestApi.prototype.contestPrototypeExistsTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeExistsTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     */
    ContestApi.prototype.contestPrototypeFindByIdContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeFindByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     */
    ContestApi.prototype.contestPrototypeFindByIdRounds = function (params, options) {
        return ContestApiFp.contestPrototypeFindByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    ContestApi.prototype.contestPrototypeFindByIdStudents = function (params, options) {
        return ContestApiFp.contestPrototypeFindByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    ContestApi.prototype.contestPrototypeFindByIdTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeFindByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Contest id
     * @param refresh
     */
    ContestApi.prototype.contestPrototypeGetAccount = function (params, options) {
        return ContestApiFp.contestPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id Contest id
     * @param refresh
     */
    ContestApi.prototype.contestPrototypeGetCity = function (params, options) {
        return ContestApiFp.contestPrototypeGetCity(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries contestGuides of Contest.
     * @param id Contest id
     * @param filter
     */
    ContestApi.prototype.contestPrototypeGetContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeGetContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries rounds of Contest.
     * @param id Contest id
     * @param filter
     */
    ContestApi.prototype.contestPrototypeGetRounds = function (params, options) {
        return ContestApiFp.contestPrototypeGetRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries students of Contest.
     * @param id Contest id
     * @param filter
     */
    ContestApi.prototype.contestPrototypeGetStudents = function (params, options) {
        return ContestApiFp.contestPrototypeGetStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries teachers of Contest.
     * @param id Contest id
     * @param filter
     */
    ContestApi.prototype.contestPrototypeGetTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeGetTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    ContestApi.prototype.contestPrototypeLinkStudents = function (params, options) {
        return ContestApiFp.contestPrototypeLinkStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    ContestApi.prototype.contestPrototypeLinkTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeLinkTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Contest id
     * @param data An object of model property name/value pairs
     */
    ContestApi.prototype.contestPrototypePatchAttributes = function (params, options) {
        return ContestApiFp.contestPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for students
     */
    ContestApi.prototype.contestPrototypeUnlinkStudents = function (params, options) {
        return ContestApiFp.contestPrototypeUnlinkStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Contest id
     * @param fk Foreign key for teachers
     */
    ContestApi.prototype.contestPrototypeUnlinkTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeUnlinkTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for contestGuides.
     * @param id Contest id
     * @param fk Foreign key for contestGuides
     * @param data
     */
    ContestApi.prototype.contestPrototypeUpdateByIdContestGuides = function (params, options) {
        return ContestApiFp.contestPrototypeUpdateByIdContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for rounds.
     * @param id Contest id
     * @param fk Foreign key for rounds
     * @param data
     */
    ContestApi.prototype.contestPrototypeUpdateByIdRounds = function (params, options) {
        return ContestApiFp.contestPrototypeUpdateByIdRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Contest id
     * @param fk Foreign key for students
     * @param data
     */
    ContestApi.prototype.contestPrototypeUpdateByIdStudents = function (params, options) {
        return ContestApiFp.contestPrototypeUpdateByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Contest id
     * @param fk Foreign key for teachers
     * @param data
     */
    ContestApi.prototype.contestPrototypeUpdateByIdTeachers = function (params, options) {
        return ContestApiFp.contestPrototypeUpdateByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ContestApi.prototype.contestReplaceByIdPostContestsidReplace = function (params, options) {
        return ContestApiFp.contestReplaceByIdPostContestsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ContestApi.prototype.contestReplaceByIdPutContestsid = function (params, options) {
        return ContestApiFp.contestReplaceByIdPutContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestApi.prototype.contestReplaceOrCreatePostContestsReplaceOrCreate = function (params, options) {
        return ContestApiFp.contestReplaceOrCreatePostContestsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestApi.prototype.contestReplaceOrCreatePutContests = function (params, options) {
        return ContestApiFp.contestReplaceOrCreatePutContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ContestApi.prototype.contestUpdateAll = function (params, options) {
        return ContestApiFp.contestUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ContestApi.prototype.contestUpsertWithWhere = function (params, options) {
        return ContestApiFp.contestUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return ContestApi;
}(BaseAPI));
export { ContestApi };
/**
 * ContestApi - factory interface
 */
export var ContestApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        contestCount: function (params, options) {
            return ContestApiFp.contestCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        contestCreate: function (params, options) {
            return ContestApiFp.contestCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        contestCreateChangeStreamGetContestsChangeStream: function (params, options) {
            return ContestApiFp.contestCreateChangeStreamGetContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        contestCreateChangeStreamPostContestsChangeStream: function (params, options) {
            return ContestApiFp.contestCreateChangeStreamPostContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        contestDeleteById: function (params, options) {
            return ContestApiFp.contestDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        contestExistsGetContestsidExists: function (params, options) {
            return ContestApiFp.contestExistsGetContestsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        contestExistsHeadContestsid: function (params, options) {
            return ContestApiFp.contestExistsHeadContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        contestFind: function (params, options) {
            return ContestApiFp.contestFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        contestFindById: function (params, options) {
            return ContestApiFp.contestFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        contestFindOne: function (params, options) {
            return ContestApiFp.contestFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestPatchOrCreate: function (params, options) {
            return ContestApiFp.contestPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts contestGuides of Contest.
         * @param id Contest id
         * @param where Criteria to match model instances
         */
        contestPrototypeCountContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeCountContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts rounds of Contest.
         * @param id Contest id
         * @param where Criteria to match model instances
         */
        contestPrototypeCountRounds: function (params, options) {
            return ContestApiFp.contestPrototypeCountRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts students of Contest.
         * @param id Contest id
         * @param where Criteria to match model instances
         */
        contestPrototypeCountStudents: function (params, options) {
            return ContestApiFp.contestPrototypeCountStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts teachers of Contest.
         * @param id Contest id
         * @param where Criteria to match model instances
         */
        contestPrototypeCountTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeCountTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in contestGuides of this model.
         * @param id Contest id
         * @param data
         */
        contestPrototypeCreateContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeCreateContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in rounds of this model.
         * @param id Contest id
         * @param data
         */
        contestPrototypeCreateRounds: function (params, options) {
            return ContestApiFp.contestPrototypeCreateRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in students of this model.
         * @param id Contest id
         * @param data
         */
        contestPrototypeCreateStudents: function (params, options) {
            return ContestApiFp.contestPrototypeCreateStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in teachers of this model.
         * @param id Contest id
         * @param data
         */
        contestPrototypeCreateTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeCreateTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all contestGuides of this model.
         * @param id Contest id
         */
        contestPrototypeDeleteContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeDeleteContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all rounds of this model.
         * @param id Contest id
         */
        contestPrototypeDeleteRounds: function (params, options) {
            return ContestApiFp.contestPrototypeDeleteRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all students of this model.
         * @param id Contest id
         */
        contestPrototypeDeleteStudents: function (params, options) {
            return ContestApiFp.contestPrototypeDeleteStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all teachers of this model.
         * @param id Contest id
         */
        contestPrototypeDeleteTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeDeleteTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for contestGuides.
         * @param id Contest id
         * @param fk Foreign key for contestGuides
         */
        contestPrototypeDestroyByIdContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeDestroyByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for rounds.
         * @param id Contest id
         * @param fk Foreign key for rounds
         */
        contestPrototypeDestroyByIdRounds: function (params, options) {
            return ContestApiFp.contestPrototypeDestroyByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for students.
         * @param id Contest id
         * @param fk Foreign key for students
         */
        contestPrototypeDestroyByIdStudents: function (params, options) {
            return ContestApiFp.contestPrototypeDestroyByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for teachers.
         * @param id Contest id
         * @param fk Foreign key for teachers
         */
        contestPrototypeDestroyByIdTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeDestroyByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of students relation to an item by id.
         * @param id Contest id
         * @param fk Foreign key for students
         */
        contestPrototypeExistsStudents: function (params, options) {
            return ContestApiFp.contestPrototypeExistsStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of teachers relation to an item by id.
         * @param id Contest id
         * @param fk Foreign key for teachers
         */
        contestPrototypeExistsTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeExistsTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for contestGuides.
         * @param id Contest id
         * @param fk Foreign key for contestGuides
         */
        contestPrototypeFindByIdContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeFindByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for rounds.
         * @param id Contest id
         * @param fk Foreign key for rounds
         */
        contestPrototypeFindByIdRounds: function (params, options) {
            return ContestApiFp.contestPrototypeFindByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for students.
         * @param id Contest id
         * @param fk Foreign key for students
         */
        contestPrototypeFindByIdStudents: function (params, options) {
            return ContestApiFp.contestPrototypeFindByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for teachers.
         * @param id Contest id
         * @param fk Foreign key for teachers
         */
        contestPrototypeFindByIdTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeFindByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Contest id
         * @param refresh
         */
        contestPrototypeGetAccount: function (params, options) {
            return ContestApiFp.contestPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation city.
         * @param id Contest id
         * @param refresh
         */
        contestPrototypeGetCity: function (params, options) {
            return ContestApiFp.contestPrototypeGetCity(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries contestGuides of Contest.
         * @param id Contest id
         * @param filter
         */
        contestPrototypeGetContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeGetContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries rounds of Contest.
         * @param id Contest id
         * @param filter
         */
        contestPrototypeGetRounds: function (params, options) {
            return ContestApiFp.contestPrototypeGetRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries students of Contest.
         * @param id Contest id
         * @param filter
         */
        contestPrototypeGetStudents: function (params, options) {
            return ContestApiFp.contestPrototypeGetStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries teachers of Contest.
         * @param id Contest id
         * @param filter
         */
        contestPrototypeGetTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeGetTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for students.
         * @param id Contest id
         * @param fk Foreign key for students
         * @param data
         */
        contestPrototypeLinkStudents: function (params, options) {
            return ContestApiFp.contestPrototypeLinkStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for teachers.
         * @param id Contest id
         * @param fk Foreign key for teachers
         * @param data
         */
        contestPrototypeLinkTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeLinkTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Contest id
         * @param data An object of model property name/value pairs
         */
        contestPrototypePatchAttributes: function (params, options) {
            return ContestApiFp.contestPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the students relation to an item by id.
         * @param id Contest id
         * @param fk Foreign key for students
         */
        contestPrototypeUnlinkStudents: function (params, options) {
            return ContestApiFp.contestPrototypeUnlinkStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the teachers relation to an item by id.
         * @param id Contest id
         * @param fk Foreign key for teachers
         */
        contestPrototypeUnlinkTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeUnlinkTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for contestGuides.
         * @param id Contest id
         * @param fk Foreign key for contestGuides
         * @param data
         */
        contestPrototypeUpdateByIdContestGuides: function (params, options) {
            return ContestApiFp.contestPrototypeUpdateByIdContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for rounds.
         * @param id Contest id
         * @param fk Foreign key for rounds
         * @param data
         */
        contestPrototypeUpdateByIdRounds: function (params, options) {
            return ContestApiFp.contestPrototypeUpdateByIdRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for students.
         * @param id Contest id
         * @param fk Foreign key for students
         * @param data
         */
        contestPrototypeUpdateByIdStudents: function (params, options) {
            return ContestApiFp.contestPrototypeUpdateByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for teachers.
         * @param id Contest id
         * @param fk Foreign key for teachers
         * @param data
         */
        contestPrototypeUpdateByIdTeachers: function (params, options) {
            return ContestApiFp.contestPrototypeUpdateByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        contestReplaceByIdPostContestsidReplace: function (params, options) {
            return ContestApiFp.contestReplaceByIdPostContestsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        contestReplaceByIdPutContestsid: function (params, options) {
            return ContestApiFp.contestReplaceByIdPutContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestReplaceOrCreatePostContestsReplaceOrCreate: function (params, options) {
            return ContestApiFp.contestReplaceOrCreatePostContestsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestReplaceOrCreatePutContests: function (params, options) {
            return ContestApiFp.contestReplaceOrCreatePutContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        contestUpdateAll: function (params, options) {
            return ContestApiFp.contestUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        contestUpsertWithWhere: function (params, options) {
            return ContestApiFp.contestUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * ContestGuideApi - fetch parameter creator
 */
export var ContestGuideApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    contestGuideCount: function (params, options) {
        var baseUrl = "/ContestGuides/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    contestGuideCreate: function (params, options) {
        var baseUrl = "/ContestGuides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestGuideCreateChangeStreamGetContestGuidesChangeStream: function (params, options) {
        var baseUrl = "/ContestGuides/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestGuideCreateChangeStreamPostContestGuidesChangeStream: function (params, options) {
        var baseUrl = "/ContestGuides/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    contestGuideDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideDeleteById");
        }
        var baseUrl = "/ContestGuides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestGuideExistsGetContestGuidesidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideExistsGetContestGuidesidExists");
        }
        var baseUrl = "/ContestGuides/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestGuideExistsHeadContestGuidesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideExistsHeadContestGuidesid");
        }
        var baseUrl = "/ContestGuides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestGuideFind: function (params, options) {
        var baseUrl = "/ContestGuides";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    contestGuideFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideFindById");
        }
        var baseUrl = "/ContestGuides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestGuideFindOne: function (params, options) {
        var baseUrl = "/ContestGuides/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuidePatchOrCreate: function (params, options) {
        var baseUrl = "/ContestGuides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id ContestGuide id
     * @param refresh
     */
    contestGuidePrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuidePrototypeGetAccount");
        }
        var baseUrl = "/ContestGuides/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id ContestGuide id
     * @param refresh
     */
    contestGuidePrototypeGetContest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuidePrototypeGetContest");
        }
        var baseUrl = "/ContestGuides/{id}/contest".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ContestGuide id
     * @param data An object of model property name/value pairs
     */
    contestGuidePrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuidePrototypePatchAttributes");
        }
        var baseUrl = "/ContestGuides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestGuideReplaceByIdPostContestGuidesidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideReplaceByIdPostContestGuidesidReplace");
        }
        var baseUrl = "/ContestGuides/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestGuideReplaceByIdPutContestGuidesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling contestGuideReplaceByIdPutContestGuidesid");
        }
        var baseUrl = "/ContestGuides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate: function (params, options) {
        var baseUrl = "/ContestGuides/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuideReplaceOrCreatePutContestGuides: function (params, options) {
        var baseUrl = "/ContestGuides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestGuideUpdateAll: function (params, options) {
        var baseUrl = "/ContestGuides/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestGuideUpsertWithWhere: function (params, options) {
        var baseUrl = "/ContestGuides/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ContestGuideApi - functional programming interface
 */
export var ContestGuideApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    contestGuideCount: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    contestGuideCreate: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestGuideCreateChangeStreamGetContestGuidesChangeStream: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideCreateChangeStreamGetContestGuidesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    contestGuideCreateChangeStreamPostContestGuidesChangeStream: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideCreateChangeStreamPostContestGuidesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    contestGuideDeleteById: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestGuideExistsGetContestGuidesidExists: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideExistsGetContestGuidesidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    contestGuideExistsHeadContestGuidesid: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideExistsHeadContestGuidesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestGuideFind: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    contestGuideFindById: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    contestGuideFindOne: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuidePatchOrCreate: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuidePatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id ContestGuide id
     * @param refresh
     */
    contestGuidePrototypeGetAccount: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuidePrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id ContestGuide id
     * @param refresh
     */
    contestGuidePrototypeGetContest: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuidePrototypeGetContest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ContestGuide id
     * @param data An object of model property name/value pairs
     */
    contestGuidePrototypePatchAttributes: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuidePrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestGuideReplaceByIdPostContestGuidesidReplace: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideReplaceByIdPostContestGuidesidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    contestGuideReplaceByIdPutContestGuidesid: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideReplaceByIdPutContestGuidesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    contestGuideReplaceOrCreatePutContestGuides: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideReplaceOrCreatePutContestGuides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestGuideUpdateAll: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    contestGuideUpsertWithWhere: function (params, options) {
        var fetchArgs = ContestGuideApiFetchParamCreator.contestGuideUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ContestGuideApi - object-oriented interface
 */
var ContestGuideApi = /** @class */ (function (_super) {
    __extends(ContestGuideApi, _super);
    function ContestGuideApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ContestGuideApi.prototype.contestGuideCount = function (params, options) {
        return ContestGuideApiFp.contestGuideCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuideCreate = function (params, options) {
        return ContestGuideApiFp.contestGuideCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ContestGuideApi.prototype.contestGuideCreateChangeStreamGetContestGuidesChangeStream = function (params, options) {
        return ContestGuideApiFp.contestGuideCreateChangeStreamGetContestGuidesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ContestGuideApi.prototype.contestGuideCreateChangeStreamPostContestGuidesChangeStream = function (params, options) {
        return ContestGuideApiFp.contestGuideCreateChangeStreamPostContestGuidesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ContestGuideApi.prototype.contestGuideDeleteById = function (params, options) {
        return ContestGuideApiFp.contestGuideDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ContestGuideApi.prototype.contestGuideExistsGetContestGuidesidExists = function (params, options) {
        return ContestGuideApiFp.contestGuideExistsGetContestGuidesidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ContestGuideApi.prototype.contestGuideExistsHeadContestGuidesid = function (params, options) {
        return ContestGuideApiFp.contestGuideExistsHeadContestGuidesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ContestGuideApi.prototype.contestGuideFind = function (params, options) {
        return ContestGuideApiFp.contestGuideFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ContestGuideApi.prototype.contestGuideFindById = function (params, options) {
        return ContestGuideApiFp.contestGuideFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ContestGuideApi.prototype.contestGuideFindOne = function (params, options) {
        return ContestGuideApiFp.contestGuideFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuidePatchOrCreate = function (params, options) {
        return ContestGuideApiFp.contestGuidePatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id ContestGuide id
     * @param refresh
     */
    ContestGuideApi.prototype.contestGuidePrototypeGetAccount = function (params, options) {
        return ContestGuideApiFp.contestGuidePrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id ContestGuide id
     * @param refresh
     */
    ContestGuideApi.prototype.contestGuidePrototypeGetContest = function (params, options) {
        return ContestGuideApiFp.contestGuidePrototypeGetContest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ContestGuide id
     * @param data An object of model property name/value pairs
     */
    ContestGuideApi.prototype.contestGuidePrototypePatchAttributes = function (params, options) {
        return ContestGuideApiFp.contestGuidePrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuideReplaceByIdPostContestGuidesidReplace = function (params, options) {
        return ContestGuideApiFp.contestGuideReplaceByIdPostContestGuidesidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuideReplaceByIdPutContestGuidesid = function (params, options) {
        return ContestGuideApiFp.contestGuideReplaceByIdPutContestGuidesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate = function (params, options) {
        return ContestGuideApiFp.contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ContestGuideApi.prototype.contestGuideReplaceOrCreatePutContestGuides = function (params, options) {
        return ContestGuideApiFp.contestGuideReplaceOrCreatePutContestGuides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ContestGuideApi.prototype.contestGuideUpdateAll = function (params, options) {
        return ContestGuideApiFp.contestGuideUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ContestGuideApi.prototype.contestGuideUpsertWithWhere = function (params, options) {
        return ContestGuideApiFp.contestGuideUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return ContestGuideApi;
}(BaseAPI));
export { ContestGuideApi };
/**
 * ContestGuideApi - factory interface
 */
export var ContestGuideApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        contestGuideCount: function (params, options) {
            return ContestGuideApiFp.contestGuideCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        contestGuideCreate: function (params, options) {
            return ContestGuideApiFp.contestGuideCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        contestGuideCreateChangeStreamGetContestGuidesChangeStream: function (params, options) {
            return ContestGuideApiFp.contestGuideCreateChangeStreamGetContestGuidesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        contestGuideCreateChangeStreamPostContestGuidesChangeStream: function (params, options) {
            return ContestGuideApiFp.contestGuideCreateChangeStreamPostContestGuidesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        contestGuideDeleteById: function (params, options) {
            return ContestGuideApiFp.contestGuideDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        contestGuideExistsGetContestGuidesidExists: function (params, options) {
            return ContestGuideApiFp.contestGuideExistsGetContestGuidesidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        contestGuideExistsHeadContestGuidesid: function (params, options) {
            return ContestGuideApiFp.contestGuideExistsHeadContestGuidesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        contestGuideFind: function (params, options) {
            return ContestGuideApiFp.contestGuideFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        contestGuideFindById: function (params, options) {
            return ContestGuideApiFp.contestGuideFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        contestGuideFindOne: function (params, options) {
            return ContestGuideApiFp.contestGuideFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestGuidePatchOrCreate: function (params, options) {
            return ContestGuideApiFp.contestGuidePatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id ContestGuide id
         * @param refresh
         */
        contestGuidePrototypeGetAccount: function (params, options) {
            return ContestGuideApiFp.contestGuidePrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation contest.
         * @param id ContestGuide id
         * @param refresh
         */
        contestGuidePrototypeGetContest: function (params, options) {
            return ContestGuideApiFp.contestGuidePrototypeGetContest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id ContestGuide id
         * @param data An object of model property name/value pairs
         */
        contestGuidePrototypePatchAttributes: function (params, options) {
            return ContestGuideApiFp.contestGuidePrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        contestGuideReplaceByIdPostContestGuidesidReplace: function (params, options) {
            return ContestGuideApiFp.contestGuideReplaceByIdPostContestGuidesidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        contestGuideReplaceByIdPutContestGuidesid: function (params, options) {
            return ContestGuideApiFp.contestGuideReplaceByIdPutContestGuidesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate: function (params, options) {
            return ContestGuideApiFp.contestGuideReplaceOrCreatePostContestGuidesReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        contestGuideReplaceOrCreatePutContestGuides: function (params, options) {
            return ContestGuideApiFp.contestGuideReplaceOrCreatePutContestGuides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        contestGuideUpdateAll: function (params, options) {
            return ContestGuideApiFp.contestGuideUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        contestGuideUpsertWithWhere: function (params, options) {
            return ContestGuideApiFp.contestGuideUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * DistrictApi - fetch parameter creator
 */
export var DistrictApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    districtCount: function (params, options) {
        var baseUrl = "/Districts/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    districtCreate: function (params, options) {
        var baseUrl = "/Districts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    districtCreateChangeStreamGetDistrictsChangeStream: function (params, options) {
        var baseUrl = "/Districts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    districtCreateChangeStreamPostDistrictsChangeStream: function (params, options) {
        var baseUrl = "/Districts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    districtDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtDeleteById");
        }
        var baseUrl = "/Districts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    districtExistsGetDistrictsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtExistsGetDistrictsidExists");
        }
        var baseUrl = "/Districts/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    districtExistsHeadDistrictsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtExistsHeadDistrictsid");
        }
        var baseUrl = "/Districts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    districtFind: function (params, options) {
        var baseUrl = "/Districts";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    districtFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtFindById");
        }
        var baseUrl = "/Districts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    districtFindOne: function (params, options) {
        var baseUrl = "/Districts/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtPatchOrCreate: function (params, options) {
        var baseUrl = "/Districts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts school of District.
     * @param id District id
     * @param where Criteria to match model instances
     */
    districtPrototypeCountSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeCountSchool");
        }
        var baseUrl = "/Districts/{id}/school/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in school of this model.
     * @param id District id
     * @param data
     */
    districtPrototypeCreateSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeCreateSchool");
        }
        var baseUrl = "/Districts/{id}/school".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all school of this model.
     * @param id District id
     */
    districtPrototypeDeleteSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeDeleteSchool");
        }
        var baseUrl = "/Districts/{id}/school".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    districtPrototypeDestroyByIdSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeDestroyByIdSchool");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling districtPrototypeDestroyByIdSchool");
        }
        var baseUrl = "/Districts/{id}/school/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    districtPrototypeFindByIdSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeFindByIdSchool");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling districtPrototypeFindByIdSchool");
        }
        var baseUrl = "/Districts/{id}/school/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id District id
     * @param refresh
     */
    districtPrototypeGetCity: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeGetCity");
        }
        var baseUrl = "/Districts/{id}/city".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries school of District.
     * @param id District id
     * @param filter
     */
    districtPrototypeGetSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeGetSchool");
        }
        var baseUrl = "/Districts/{id}/school".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id District id
     * @param data An object of model property name/value pairs
     */
    districtPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypePatchAttributes");
        }
        var baseUrl = "/Districts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     * @param data
     */
    districtPrototypeUpdateByIdSchool: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtPrototypeUpdateByIdSchool");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling districtPrototypeUpdateByIdSchool");
        }
        var baseUrl = "/Districts/{id}/school/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    districtReplaceByIdPostDistrictsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtReplaceByIdPostDistrictsidReplace");
        }
        var baseUrl = "/Districts/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    districtReplaceByIdPutDistrictsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling districtReplaceByIdPutDistrictsid");
        }
        var baseUrl = "/Districts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtReplaceOrCreatePostDistrictsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Districts/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtReplaceOrCreatePutDistricts: function (params, options) {
        var baseUrl = "/Districts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    districtUpdateAll: function (params, options) {
        var baseUrl = "/Districts/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    districtUpsertWithWhere: function (params, options) {
        var baseUrl = "/Districts/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * DistrictApi - functional programming interface
 */
export var DistrictApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    districtCount: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    districtCreate: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    districtCreateChangeStreamGetDistrictsChangeStream: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtCreateChangeStreamGetDistrictsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    districtCreateChangeStreamPostDistrictsChangeStream: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtCreateChangeStreamPostDistrictsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    districtDeleteById: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    districtExistsGetDistrictsidExists: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtExistsGetDistrictsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    districtExistsHeadDistrictsid: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtExistsHeadDistrictsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    districtFind: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    districtFindById: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    districtFindOne: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtPatchOrCreate: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts school of District.
     * @param id District id
     * @param where Criteria to match model instances
     */
    districtPrototypeCountSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeCountSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in school of this model.
     * @param id District id
     * @param data
     */
    districtPrototypeCreateSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeCreateSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all school of this model.
     * @param id District id
     */
    districtPrototypeDeleteSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeDeleteSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    districtPrototypeDestroyByIdSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeDestroyByIdSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    districtPrototypeFindByIdSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeFindByIdSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id District id
     * @param refresh
     */
    districtPrototypeGetCity: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeGetCity(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries school of District.
     * @param id District id
     * @param filter
     */
    districtPrototypeGetSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeGetSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id District id
     * @param data An object of model property name/value pairs
     */
    districtPrototypePatchAttributes: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     * @param data
     */
    districtPrototypeUpdateByIdSchool: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtPrototypeUpdateByIdSchool(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    districtReplaceByIdPostDistrictsidReplace: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtReplaceByIdPostDistrictsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    districtReplaceByIdPutDistrictsid: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtReplaceByIdPutDistrictsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtReplaceOrCreatePostDistrictsReplaceOrCreate: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtReplaceOrCreatePostDistrictsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    districtReplaceOrCreatePutDistricts: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtReplaceOrCreatePutDistricts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    districtUpdateAll: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    districtUpsertWithWhere: function (params, options) {
        var fetchArgs = DistrictApiFetchParamCreator.districtUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * DistrictApi - object-oriented interface
 */
var DistrictApi = /** @class */ (function (_super) {
    __extends(DistrictApi, _super);
    function DistrictApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    DistrictApi.prototype.districtCount = function (params, options) {
        return DistrictApiFp.districtCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    DistrictApi.prototype.districtCreate = function (params, options) {
        return DistrictApiFp.districtCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    DistrictApi.prototype.districtCreateChangeStreamGetDistrictsChangeStream = function (params, options) {
        return DistrictApiFp.districtCreateChangeStreamGetDistrictsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    DistrictApi.prototype.districtCreateChangeStreamPostDistrictsChangeStream = function (params, options) {
        return DistrictApiFp.districtCreateChangeStreamPostDistrictsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    DistrictApi.prototype.districtDeleteById = function (params, options) {
        return DistrictApiFp.districtDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    DistrictApi.prototype.districtExistsGetDistrictsidExists = function (params, options) {
        return DistrictApiFp.districtExistsGetDistrictsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    DistrictApi.prototype.districtExistsHeadDistrictsid = function (params, options) {
        return DistrictApiFp.districtExistsHeadDistrictsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    DistrictApi.prototype.districtFind = function (params, options) {
        return DistrictApiFp.districtFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    DistrictApi.prototype.districtFindById = function (params, options) {
        return DistrictApiFp.districtFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    DistrictApi.prototype.districtFindOne = function (params, options) {
        return DistrictApiFp.districtFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    DistrictApi.prototype.districtPatchOrCreate = function (params, options) {
        return DistrictApiFp.districtPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts school of District.
     * @param id District id
     * @param where Criteria to match model instances
     */
    DistrictApi.prototype.districtPrototypeCountSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeCountSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in school of this model.
     * @param id District id
     * @param data
     */
    DistrictApi.prototype.districtPrototypeCreateSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeCreateSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all school of this model.
     * @param id District id
     */
    DistrictApi.prototype.districtPrototypeDeleteSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeDeleteSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    DistrictApi.prototype.districtPrototypeDestroyByIdSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeDestroyByIdSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     */
    DistrictApi.prototype.districtPrototypeFindByIdSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeFindByIdSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id District id
     * @param refresh
     */
    DistrictApi.prototype.districtPrototypeGetCity = function (params, options) {
        return DistrictApiFp.districtPrototypeGetCity(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries school of District.
     * @param id District id
     * @param filter
     */
    DistrictApi.prototype.districtPrototypeGetSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeGetSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id District id
     * @param data An object of model property name/value pairs
     */
    DistrictApi.prototype.districtPrototypePatchAttributes = function (params, options) {
        return DistrictApiFp.districtPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for school.
     * @param id District id
     * @param fk Foreign key for school
     * @param data
     */
    DistrictApi.prototype.districtPrototypeUpdateByIdSchool = function (params, options) {
        return DistrictApiFp.districtPrototypeUpdateByIdSchool(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    DistrictApi.prototype.districtReplaceByIdPostDistrictsidReplace = function (params, options) {
        return DistrictApiFp.districtReplaceByIdPostDistrictsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    DistrictApi.prototype.districtReplaceByIdPutDistrictsid = function (params, options) {
        return DistrictApiFp.districtReplaceByIdPutDistrictsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    DistrictApi.prototype.districtReplaceOrCreatePostDistrictsReplaceOrCreate = function (params, options) {
        return DistrictApiFp.districtReplaceOrCreatePostDistrictsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    DistrictApi.prototype.districtReplaceOrCreatePutDistricts = function (params, options) {
        return DistrictApiFp.districtReplaceOrCreatePutDistricts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    DistrictApi.prototype.districtUpdateAll = function (params, options) {
        return DistrictApiFp.districtUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    DistrictApi.prototype.districtUpsertWithWhere = function (params, options) {
        return DistrictApiFp.districtUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return DistrictApi;
}(BaseAPI));
export { DistrictApi };
/**
 * DistrictApi - factory interface
 */
export var DistrictApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        districtCount: function (params, options) {
            return DistrictApiFp.districtCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        districtCreate: function (params, options) {
            return DistrictApiFp.districtCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        districtCreateChangeStreamGetDistrictsChangeStream: function (params, options) {
            return DistrictApiFp.districtCreateChangeStreamGetDistrictsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        districtCreateChangeStreamPostDistrictsChangeStream: function (params, options) {
            return DistrictApiFp.districtCreateChangeStreamPostDistrictsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        districtDeleteById: function (params, options) {
            return DistrictApiFp.districtDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        districtExistsGetDistrictsidExists: function (params, options) {
            return DistrictApiFp.districtExistsGetDistrictsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        districtExistsHeadDistrictsid: function (params, options) {
            return DistrictApiFp.districtExistsHeadDistrictsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        districtFind: function (params, options) {
            return DistrictApiFp.districtFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        districtFindById: function (params, options) {
            return DistrictApiFp.districtFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        districtFindOne: function (params, options) {
            return DistrictApiFp.districtFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        districtPatchOrCreate: function (params, options) {
            return DistrictApiFp.districtPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts school of District.
         * @param id District id
         * @param where Criteria to match model instances
         */
        districtPrototypeCountSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeCountSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in school of this model.
         * @param id District id
         * @param data
         */
        districtPrototypeCreateSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeCreateSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all school of this model.
         * @param id District id
         */
        districtPrototypeDeleteSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeDeleteSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for school.
         * @param id District id
         * @param fk Foreign key for school
         */
        districtPrototypeDestroyByIdSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeDestroyByIdSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for school.
         * @param id District id
         * @param fk Foreign key for school
         */
        districtPrototypeFindByIdSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeFindByIdSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation city.
         * @param id District id
         * @param refresh
         */
        districtPrototypeGetCity: function (params, options) {
            return DistrictApiFp.districtPrototypeGetCity(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries school of District.
         * @param id District id
         * @param filter
         */
        districtPrototypeGetSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeGetSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id District id
         * @param data An object of model property name/value pairs
         */
        districtPrototypePatchAttributes: function (params, options) {
            return DistrictApiFp.districtPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for school.
         * @param id District id
         * @param fk Foreign key for school
         * @param data
         */
        districtPrototypeUpdateByIdSchool: function (params, options) {
            return DistrictApiFp.districtPrototypeUpdateByIdSchool(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        districtReplaceByIdPostDistrictsidReplace: function (params, options) {
            return DistrictApiFp.districtReplaceByIdPostDistrictsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        districtReplaceByIdPutDistrictsid: function (params, options) {
            return DistrictApiFp.districtReplaceByIdPutDistrictsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        districtReplaceOrCreatePostDistrictsReplaceOrCreate: function (params, options) {
            return DistrictApiFp.districtReplaceOrCreatePostDistrictsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        districtReplaceOrCreatePutDistricts: function (params, options) {
            return DistrictApiFp.districtReplaceOrCreatePutDistricts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        districtUpdateAll: function (params, options) {
            return DistrictApiFp.districtUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        districtUpsertWithWhere: function (params, options) {
            return DistrictApiFp.districtUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * EmailContactApi - fetch parameter creator
 */
export var EmailContactApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    emailContactCount: function (params, options) {
        var baseUrl = "/EmailContacts/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    emailContactCreate: function (params, options) {
        var baseUrl = "/EmailContacts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    emailContactCreateChangeStreamGetEmailContactsChangeStream: function (params, options) {
        var baseUrl = "/EmailContacts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    emailContactCreateChangeStreamPostEmailContactsChangeStream: function (params, options) {
        var baseUrl = "/EmailContacts/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    emailContactDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactDeleteById");
        }
        var baseUrl = "/EmailContacts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    emailContactExistsGetEmailContactsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactExistsGetEmailContactsidExists");
        }
        var baseUrl = "/EmailContacts/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    emailContactExistsHeadEmailContactsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactExistsHeadEmailContactsid");
        }
        var baseUrl = "/EmailContacts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    emailContactFind: function (params, options) {
        var baseUrl = "/EmailContacts";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    emailContactFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactFindById");
        }
        var baseUrl = "/EmailContacts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    emailContactFindOne: function (params, options) {
        var baseUrl = "/EmailContacts/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactPatchOrCreate: function (params, options) {
        var baseUrl = "/EmailContacts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id EmailContact id
     * @param refresh
     */
    emailContactPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactPrototypeGetAccount");
        }
        var baseUrl = "/EmailContacts/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id EmailContact id
     * @param data An object of model property name/value pairs
     */
    emailContactPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactPrototypePatchAttributes");
        }
        var baseUrl = "/EmailContacts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    emailContactReplaceByIdPostEmailContactsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactReplaceByIdPostEmailContactsidReplace");
        }
        var baseUrl = "/EmailContacts/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    emailContactReplaceByIdPutEmailContactsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling emailContactReplaceByIdPutEmailContactsid");
        }
        var baseUrl = "/EmailContacts/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate: function (params, options) {
        var baseUrl = "/EmailContacts/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactReplaceOrCreatePutEmailContacts: function (params, options) {
        var baseUrl = "/EmailContacts";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    emailContactUpdateAll: function (params, options) {
        var baseUrl = "/EmailContacts/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    emailContactUpsertWithWhere: function (params, options) {
        var baseUrl = "/EmailContacts/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * EmailContactApi - functional programming interface
 */
export var EmailContactApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    emailContactCount: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    emailContactCreate: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    emailContactCreateChangeStreamGetEmailContactsChangeStream: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactCreateChangeStreamGetEmailContactsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    emailContactCreateChangeStreamPostEmailContactsChangeStream: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactCreateChangeStreamPostEmailContactsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    emailContactDeleteById: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    emailContactExistsGetEmailContactsidExists: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactExistsGetEmailContactsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    emailContactExistsHeadEmailContactsid: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactExistsHeadEmailContactsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    emailContactFind: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    emailContactFindById: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    emailContactFindOne: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactPatchOrCreate: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id EmailContact id
     * @param refresh
     */
    emailContactPrototypeGetAccount: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id EmailContact id
     * @param data An object of model property name/value pairs
     */
    emailContactPrototypePatchAttributes: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    emailContactReplaceByIdPostEmailContactsidReplace: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactReplaceByIdPostEmailContactsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    emailContactReplaceByIdPutEmailContactsid: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactReplaceByIdPutEmailContactsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    emailContactReplaceOrCreatePutEmailContacts: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactReplaceOrCreatePutEmailContacts(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    emailContactUpdateAll: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    emailContactUpsertWithWhere: function (params, options) {
        var fetchArgs = EmailContactApiFetchParamCreator.emailContactUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * EmailContactApi - object-oriented interface
 */
var EmailContactApi = /** @class */ (function (_super) {
    __extends(EmailContactApi, _super);
    function EmailContactApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    EmailContactApi.prototype.emailContactCount = function (params, options) {
        return EmailContactApiFp.emailContactCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactCreate = function (params, options) {
        return EmailContactApiFp.emailContactCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    EmailContactApi.prototype.emailContactCreateChangeStreamGetEmailContactsChangeStream = function (params, options) {
        return EmailContactApiFp.emailContactCreateChangeStreamGetEmailContactsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    EmailContactApi.prototype.emailContactCreateChangeStreamPostEmailContactsChangeStream = function (params, options) {
        return EmailContactApiFp.emailContactCreateChangeStreamPostEmailContactsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    EmailContactApi.prototype.emailContactDeleteById = function (params, options) {
        return EmailContactApiFp.emailContactDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    EmailContactApi.prototype.emailContactExistsGetEmailContactsidExists = function (params, options) {
        return EmailContactApiFp.emailContactExistsGetEmailContactsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    EmailContactApi.prototype.emailContactExistsHeadEmailContactsid = function (params, options) {
        return EmailContactApiFp.emailContactExistsHeadEmailContactsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    EmailContactApi.prototype.emailContactFind = function (params, options) {
        return EmailContactApiFp.emailContactFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    EmailContactApi.prototype.emailContactFindById = function (params, options) {
        return EmailContactApiFp.emailContactFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    EmailContactApi.prototype.emailContactFindOne = function (params, options) {
        return EmailContactApiFp.emailContactFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactPatchOrCreate = function (params, options) {
        return EmailContactApiFp.emailContactPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id EmailContact id
     * @param refresh
     */
    EmailContactApi.prototype.emailContactPrototypeGetAccount = function (params, options) {
        return EmailContactApiFp.emailContactPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id EmailContact id
     * @param data An object of model property name/value pairs
     */
    EmailContactApi.prototype.emailContactPrototypePatchAttributes = function (params, options) {
        return EmailContactApiFp.emailContactPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactReplaceByIdPostEmailContactsidReplace = function (params, options) {
        return EmailContactApiFp.emailContactReplaceByIdPostEmailContactsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactReplaceByIdPutEmailContactsid = function (params, options) {
        return EmailContactApiFp.emailContactReplaceByIdPutEmailContactsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate = function (params, options) {
        return EmailContactApiFp.emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    EmailContactApi.prototype.emailContactReplaceOrCreatePutEmailContacts = function (params, options) {
        return EmailContactApiFp.emailContactReplaceOrCreatePutEmailContacts(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    EmailContactApi.prototype.emailContactUpdateAll = function (params, options) {
        return EmailContactApiFp.emailContactUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    EmailContactApi.prototype.emailContactUpsertWithWhere = function (params, options) {
        return EmailContactApiFp.emailContactUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return EmailContactApi;
}(BaseAPI));
export { EmailContactApi };
/**
 * EmailContactApi - factory interface
 */
export var EmailContactApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        emailContactCount: function (params, options) {
            return EmailContactApiFp.emailContactCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        emailContactCreate: function (params, options) {
            return EmailContactApiFp.emailContactCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        emailContactCreateChangeStreamGetEmailContactsChangeStream: function (params, options) {
            return EmailContactApiFp.emailContactCreateChangeStreamGetEmailContactsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        emailContactCreateChangeStreamPostEmailContactsChangeStream: function (params, options) {
            return EmailContactApiFp.emailContactCreateChangeStreamPostEmailContactsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        emailContactDeleteById: function (params, options) {
            return EmailContactApiFp.emailContactDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        emailContactExistsGetEmailContactsidExists: function (params, options) {
            return EmailContactApiFp.emailContactExistsGetEmailContactsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        emailContactExistsHeadEmailContactsid: function (params, options) {
            return EmailContactApiFp.emailContactExistsHeadEmailContactsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        emailContactFind: function (params, options) {
            return EmailContactApiFp.emailContactFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        emailContactFindById: function (params, options) {
            return EmailContactApiFp.emailContactFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        emailContactFindOne: function (params, options) {
            return EmailContactApiFp.emailContactFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        emailContactPatchOrCreate: function (params, options) {
            return EmailContactApiFp.emailContactPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id EmailContact id
         * @param refresh
         */
        emailContactPrototypeGetAccount: function (params, options) {
            return EmailContactApiFp.emailContactPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id EmailContact id
         * @param data An object of model property name/value pairs
         */
        emailContactPrototypePatchAttributes: function (params, options) {
            return EmailContactApiFp.emailContactPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        emailContactReplaceByIdPostEmailContactsidReplace: function (params, options) {
            return EmailContactApiFp.emailContactReplaceByIdPostEmailContactsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        emailContactReplaceByIdPutEmailContactsid: function (params, options) {
            return EmailContactApiFp.emailContactReplaceByIdPutEmailContactsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate: function (params, options) {
            return EmailContactApiFp.emailContactReplaceOrCreatePostEmailContactsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        emailContactReplaceOrCreatePutEmailContacts: function (params, options) {
            return EmailContactApiFp.emailContactReplaceOrCreatePutEmailContacts(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        emailContactUpdateAll: function (params, options) {
            return EmailContactApiFp.emailContactUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        emailContactUpsertWithWhere: function (params, options) {
            return EmailContactApiFp.emailContactUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * ExamApi - fetch parameter creator
 */
export var ExamApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    examCount: function (params, options) {
        var baseUrl = "/Exams/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    examCreate: function (params, options) {
        var baseUrl = "/Exams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    examCreateChangeStreamGetExamsChangeStream: function (params, options) {
        var baseUrl = "/Exams/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    examCreateChangeStreamPostExamsChangeStream: function (params, options) {
        var baseUrl = "/Exams/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    examDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examDeleteById");
        }
        var baseUrl = "/Exams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    examExistsGetExamsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examExistsGetExamsidExists");
        }
        var baseUrl = "/Exams/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    examExistsHeadExamsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examExistsHeadExamsid");
        }
        var baseUrl = "/Exams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    examFind: function (params, options) {
        var baseUrl = "/Exams";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    examFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examFindById");
        }
        var baseUrl = "/Exams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    examFindOne: function (params, options) {
        var baseUrl = "/Exams/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary send Mail to teacher
     * @param exam
     */
    examMailingExam: function (params, options) {
        var baseUrl = "/Exams/mailingExam";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            exam: params["exam"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examPatchOrCreate: function (params, options) {
        var baseUrl = "/Exams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts studentInfo of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCountStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts submitExams of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCountSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts test of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCountTest");
        }
        var baseUrl = "/Exams/{id}/test/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCreateStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCreateSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeCreateTest");
        }
        var baseUrl = "/Exams/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all studentInfo of this model.
     * @param id Exam id
     */
    examPrototypeDeleteStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDeleteStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Exam id
     */
    examPrototypeDeleteSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDeleteSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Exam id
     */
    examPrototypeDeleteTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDeleteTest");
        }
        var baseUrl = "/Exams/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    examPrototypeDestroyByIdStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDestroyByIdStudentInfo");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeDestroyByIdStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    examPrototypeDestroyByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDestroyByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeDestroyByIdSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    examPrototypeDestroyByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeDestroyByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeDestroyByIdTest");
        }
        var baseUrl = "/Exams/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    examPrototypeFindByIdStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeFindByIdStudentInfo");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeFindByIdStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    examPrototypeFindByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeFindByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeFindByIdSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    examPrototypeFindByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeFindByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeFindByIdTest");
        }
        var baseUrl = "/Exams/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id Exam id
     * @param refresh
     */
    examPrototypeGetRound: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeGetRound");
        }
        var baseUrl = "/Exams/{id}/round".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries studentInfo of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeGetStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries submitExams of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeGetSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id Exam id
     * @param refresh
     */
    examPrototypeGetTeacher: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeGetTeacher");
        }
        var baseUrl = "/Exams/{id}/teacher".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries test of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeGetTest");
        }
        var baseUrl = "/Exams/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Exam id
     * @param data An object of model property name/value pairs
     */
    examPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypePatchAttributes");
        }
        var baseUrl = "/Exams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     * @param data
     */
    examPrototypeUpdateByIdStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeUpdateByIdStudentInfo");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeUpdateByIdStudentInfo");
        }
        var baseUrl = "/Exams/{id}/studentInfo/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     * @param data
     */
    examPrototypeUpdateByIdSubmitExams: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeUpdateByIdSubmitExams");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeUpdateByIdSubmitExams");
        }
        var baseUrl = "/Exams/{id}/submitExams/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     * @param data
     */
    examPrototypeUpdateByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examPrototypeUpdateByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling examPrototypeUpdateByIdTest");
        }
        var baseUrl = "/Exams/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    examReplaceByIdPostExamsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examReplaceByIdPostExamsidReplace");
        }
        var baseUrl = "/Exams/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    examReplaceByIdPutExamsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling examReplaceByIdPutExamsid");
        }
        var baseUrl = "/Exams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examReplaceOrCreatePostExamsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Exams/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examReplaceOrCreatePutExams: function (params, options) {
        var baseUrl = "/Exams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    examUpdateAll: function (params, options) {
        var baseUrl = "/Exams/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    examUpsertWithWhere: function (params, options) {
        var baseUrl = "/Exams/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ExamApi - functional programming interface
 */
export var ExamApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    examCount: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    examCreate: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    examCreateChangeStreamGetExamsChangeStream: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examCreateChangeStreamGetExamsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    examCreateChangeStreamPostExamsChangeStream: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examCreateChangeStreamPostExamsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    examDeleteById: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    examExistsGetExamsidExists: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examExistsGetExamsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    examExistsHeadExamsid: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examExistsHeadExamsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    examFind: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    examFindById: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    examFindOne: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary send Mail to teacher
     * @param exam
     */
    examMailingExam: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examMailingExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examPatchOrCreate: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts studentInfo of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCountStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts submitExams of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCountSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts test of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    examPrototypeCountTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCountTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCreateStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCreateSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Exam id
     * @param data
     */
    examPrototypeCreateTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeCreateTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all studentInfo of this model.
     * @param id Exam id
     */
    examPrototypeDeleteStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDeleteStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Exam id
     */
    examPrototypeDeleteSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDeleteSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Exam id
     */
    examPrototypeDeleteTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDeleteTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    examPrototypeDestroyByIdStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDestroyByIdStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    examPrototypeDestroyByIdSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDestroyByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    examPrototypeDestroyByIdTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeDestroyByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    examPrototypeFindByIdStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeFindByIdStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    examPrototypeFindByIdSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeFindByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    examPrototypeFindByIdTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeFindByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id Exam id
     * @param refresh
     */
    examPrototypeGetRound: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeGetRound(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries studentInfo of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeGetStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries submitExams of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeGetSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id Exam id
     * @param refresh
     */
    examPrototypeGetTeacher: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeGetTeacher(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries test of Exam.
     * @param id Exam id
     * @param filter
     */
    examPrototypeGetTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeGetTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Exam id
     * @param data An object of model property name/value pairs
     */
    examPrototypePatchAttributes: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     * @param data
     */
    examPrototypeUpdateByIdStudentInfo: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeUpdateByIdStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     * @param data
     */
    examPrototypeUpdateByIdSubmitExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeUpdateByIdSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     * @param data
     */
    examPrototypeUpdateByIdTest: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examPrototypeUpdateByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    examReplaceByIdPostExamsidReplace: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examReplaceByIdPostExamsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    examReplaceByIdPutExamsid: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examReplaceByIdPutExamsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examReplaceOrCreatePostExamsReplaceOrCreate: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examReplaceOrCreatePostExamsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    examReplaceOrCreatePutExams: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examReplaceOrCreatePutExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    examUpdateAll: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    examUpsertWithWhere: function (params, options) {
        var fetchArgs = ExamApiFetchParamCreator.examUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ExamApi - object-oriented interface
 */
var ExamApi = /** @class */ (function (_super) {
    __extends(ExamApi, _super);
    function ExamApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ExamApi.prototype.examCount = function (params, options) {
        return ExamApiFp.examCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ExamApi.prototype.examCreate = function (params, options) {
        return ExamApiFp.examCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ExamApi.prototype.examCreateChangeStreamGetExamsChangeStream = function (params, options) {
        return ExamApiFp.examCreateChangeStreamGetExamsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ExamApi.prototype.examCreateChangeStreamPostExamsChangeStream = function (params, options) {
        return ExamApiFp.examCreateChangeStreamPostExamsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ExamApi.prototype.examDeleteById = function (params, options) {
        return ExamApiFp.examDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ExamApi.prototype.examExistsGetExamsidExists = function (params, options) {
        return ExamApiFp.examExistsGetExamsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ExamApi.prototype.examExistsHeadExamsid = function (params, options) {
        return ExamApiFp.examExistsHeadExamsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ExamApi.prototype.examFind = function (params, options) {
        return ExamApiFp.examFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ExamApi.prototype.examFindById = function (params, options) {
        return ExamApiFp.examFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ExamApi.prototype.examFindOne = function (params, options) {
        return ExamApiFp.examFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary send Mail to teacher
     * @param exam
     */
    ExamApi.prototype.examMailingExam = function (params, options) {
        return ExamApiFp.examMailingExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ExamApi.prototype.examPatchOrCreate = function (params, options) {
        return ExamApiFp.examPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts studentInfo of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    ExamApi.prototype.examPrototypeCountStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeCountStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts submitExams of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    ExamApi.prototype.examPrototypeCountSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeCountSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts test of Exam.
     * @param id Exam id
     * @param where Criteria to match model instances
     */
    ExamApi.prototype.examPrototypeCountTest = function (params, options) {
        return ExamApiFp.examPrototypeCountTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Exam id
     * @param data
     */
    ExamApi.prototype.examPrototypeCreateStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeCreateStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in submitExams of this model.
     * @param id Exam id
     * @param data
     */
    ExamApi.prototype.examPrototypeCreateSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeCreateSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Exam id
     * @param data
     */
    ExamApi.prototype.examPrototypeCreateTest = function (params, options) {
        return ExamApiFp.examPrototypeCreateTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all studentInfo of this model.
     * @param id Exam id
     */
    ExamApi.prototype.examPrototypeDeleteStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeDeleteStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all submitExams of this model.
     * @param id Exam id
     */
    ExamApi.prototype.examPrototypeDeleteSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeDeleteSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Exam id
     */
    ExamApi.prototype.examPrototypeDeleteTest = function (params, options) {
        return ExamApiFp.examPrototypeDeleteTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    ExamApi.prototype.examPrototypeDestroyByIdStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeDestroyByIdStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    ExamApi.prototype.examPrototypeDestroyByIdSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeDestroyByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    ExamApi.prototype.examPrototypeDestroyByIdTest = function (params, options) {
        return ExamApiFp.examPrototypeDestroyByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     */
    ExamApi.prototype.examPrototypeFindByIdStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeFindByIdStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     */
    ExamApi.prototype.examPrototypeFindByIdSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeFindByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     */
    ExamApi.prototype.examPrototypeFindByIdTest = function (params, options) {
        return ExamApiFp.examPrototypeFindByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id Exam id
     * @param refresh
     */
    ExamApi.prototype.examPrototypeGetRound = function (params, options) {
        return ExamApiFp.examPrototypeGetRound(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries studentInfo of Exam.
     * @param id Exam id
     * @param filter
     */
    ExamApi.prototype.examPrototypeGetStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeGetStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries submitExams of Exam.
     * @param id Exam id
     * @param filter
     */
    ExamApi.prototype.examPrototypeGetSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeGetSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id Exam id
     * @param refresh
     */
    ExamApi.prototype.examPrototypeGetTeacher = function (params, options) {
        return ExamApiFp.examPrototypeGetTeacher(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries test of Exam.
     * @param id Exam id
     * @param filter
     */
    ExamApi.prototype.examPrototypeGetTest = function (params, options) {
        return ExamApiFp.examPrototypeGetTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Exam id
     * @param data An object of model property name/value pairs
     */
    ExamApi.prototype.examPrototypePatchAttributes = function (params, options) {
        return ExamApiFp.examPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for studentInfo.
     * @param id Exam id
     * @param fk Foreign key for studentInfo
     * @param data
     */
    ExamApi.prototype.examPrototypeUpdateByIdStudentInfo = function (params, options) {
        return ExamApiFp.examPrototypeUpdateByIdStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for submitExams.
     * @param id Exam id
     * @param fk Foreign key for submitExams
     * @param data
     */
    ExamApi.prototype.examPrototypeUpdateByIdSubmitExams = function (params, options) {
        return ExamApiFp.examPrototypeUpdateByIdSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Exam id
     * @param fk Foreign key for test
     * @param data
     */
    ExamApi.prototype.examPrototypeUpdateByIdTest = function (params, options) {
        return ExamApiFp.examPrototypeUpdateByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ExamApi.prototype.examReplaceByIdPostExamsidReplace = function (params, options) {
        return ExamApiFp.examReplaceByIdPostExamsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ExamApi.prototype.examReplaceByIdPutExamsid = function (params, options) {
        return ExamApiFp.examReplaceByIdPutExamsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ExamApi.prototype.examReplaceOrCreatePostExamsReplaceOrCreate = function (params, options) {
        return ExamApiFp.examReplaceOrCreatePostExamsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ExamApi.prototype.examReplaceOrCreatePutExams = function (params, options) {
        return ExamApiFp.examReplaceOrCreatePutExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ExamApi.prototype.examUpdateAll = function (params, options) {
        return ExamApiFp.examUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ExamApi.prototype.examUpsertWithWhere = function (params, options) {
        return ExamApiFp.examUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return ExamApi;
}(BaseAPI));
export { ExamApi };
/**
 * ExamApi - factory interface
 */
export var ExamApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        examCount: function (params, options) {
            return ExamApiFp.examCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        examCreate: function (params, options) {
            return ExamApiFp.examCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        examCreateChangeStreamGetExamsChangeStream: function (params, options) {
            return ExamApiFp.examCreateChangeStreamGetExamsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        examCreateChangeStreamPostExamsChangeStream: function (params, options) {
            return ExamApiFp.examCreateChangeStreamPostExamsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        examDeleteById: function (params, options) {
            return ExamApiFp.examDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        examExistsGetExamsidExists: function (params, options) {
            return ExamApiFp.examExistsGetExamsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        examExistsHeadExamsid: function (params, options) {
            return ExamApiFp.examExistsHeadExamsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        examFind: function (params, options) {
            return ExamApiFp.examFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        examFindById: function (params, options) {
            return ExamApiFp.examFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        examFindOne: function (params, options) {
            return ExamApiFp.examFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary send Mail to teacher
         * @param exam
         */
        examMailingExam: function (params, options) {
            return ExamApiFp.examMailingExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        examPatchOrCreate: function (params, options) {
            return ExamApiFp.examPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts studentInfo of Exam.
         * @param id Exam id
         * @param where Criteria to match model instances
         */
        examPrototypeCountStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeCountStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts submitExams of Exam.
         * @param id Exam id
         * @param where Criteria to match model instances
         */
        examPrototypeCountSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeCountSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts test of Exam.
         * @param id Exam id
         * @param where Criteria to match model instances
         */
        examPrototypeCountTest: function (params, options) {
            return ExamApiFp.examPrototypeCountTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in studentInfo of this model.
         * @param id Exam id
         * @param data
         */
        examPrototypeCreateStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeCreateStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in submitExams of this model.
         * @param id Exam id
         * @param data
         */
        examPrototypeCreateSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeCreateSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in test of this model.
         * @param id Exam id
         * @param data
         */
        examPrototypeCreateTest: function (params, options) {
            return ExamApiFp.examPrototypeCreateTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all studentInfo of this model.
         * @param id Exam id
         */
        examPrototypeDeleteStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeDeleteStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all submitExams of this model.
         * @param id Exam id
         */
        examPrototypeDeleteSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeDeleteSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all test of this model.
         * @param id Exam id
         */
        examPrototypeDeleteTest: function (params, options) {
            return ExamApiFp.examPrototypeDeleteTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for studentInfo.
         * @param id Exam id
         * @param fk Foreign key for studentInfo
         */
        examPrototypeDestroyByIdStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeDestroyByIdStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for submitExams.
         * @param id Exam id
         * @param fk Foreign key for submitExams
         */
        examPrototypeDestroyByIdSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeDestroyByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for test.
         * @param id Exam id
         * @param fk Foreign key for test
         */
        examPrototypeDestroyByIdTest: function (params, options) {
            return ExamApiFp.examPrototypeDestroyByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for studentInfo.
         * @param id Exam id
         * @param fk Foreign key for studentInfo
         */
        examPrototypeFindByIdStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeFindByIdStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for submitExams.
         * @param id Exam id
         * @param fk Foreign key for submitExams
         */
        examPrototypeFindByIdSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeFindByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for test.
         * @param id Exam id
         * @param fk Foreign key for test
         */
        examPrototypeFindByIdTest: function (params, options) {
            return ExamApiFp.examPrototypeFindByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation round.
         * @param id Exam id
         * @param refresh
         */
        examPrototypeGetRound: function (params, options) {
            return ExamApiFp.examPrototypeGetRound(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries studentInfo of Exam.
         * @param id Exam id
         * @param filter
         */
        examPrototypeGetStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeGetStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries submitExams of Exam.
         * @param id Exam id
         * @param filter
         */
        examPrototypeGetSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeGetSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation teacher.
         * @param id Exam id
         * @param refresh
         */
        examPrototypeGetTeacher: function (params, options) {
            return ExamApiFp.examPrototypeGetTeacher(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries test of Exam.
         * @param id Exam id
         * @param filter
         */
        examPrototypeGetTest: function (params, options) {
            return ExamApiFp.examPrototypeGetTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Exam id
         * @param data An object of model property name/value pairs
         */
        examPrototypePatchAttributes: function (params, options) {
            return ExamApiFp.examPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for studentInfo.
         * @param id Exam id
         * @param fk Foreign key for studentInfo
         * @param data
         */
        examPrototypeUpdateByIdStudentInfo: function (params, options) {
            return ExamApiFp.examPrototypeUpdateByIdStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for submitExams.
         * @param id Exam id
         * @param fk Foreign key for submitExams
         * @param data
         */
        examPrototypeUpdateByIdSubmitExams: function (params, options) {
            return ExamApiFp.examPrototypeUpdateByIdSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for test.
         * @param id Exam id
         * @param fk Foreign key for test
         * @param data
         */
        examPrototypeUpdateByIdTest: function (params, options) {
            return ExamApiFp.examPrototypeUpdateByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        examReplaceByIdPostExamsidReplace: function (params, options) {
            return ExamApiFp.examReplaceByIdPostExamsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        examReplaceByIdPutExamsid: function (params, options) {
            return ExamApiFp.examReplaceByIdPutExamsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        examReplaceOrCreatePostExamsReplaceOrCreate: function (params, options) {
            return ExamApiFp.examReplaceOrCreatePostExamsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        examReplaceOrCreatePutExams: function (params, options) {
            return ExamApiFp.examReplaceOrCreatePutExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        examUpdateAll: function (params, options) {
            return ExamApiFp.examUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        examUpsertWithWhere: function (params, options) {
            return ExamApiFp.examUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * HelpApi - fetch parameter creator
 */
export var HelpApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    helpCount: function (params, options) {
        var baseUrl = "/Helps/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    helpCreate: function (params, options) {
        var baseUrl = "/Helps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    helpCreateChangeStreamGetHelpsChangeStream: function (params, options) {
        var baseUrl = "/Helps/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    helpCreateChangeStreamPostHelpsChangeStream: function (params, options) {
        var baseUrl = "/Helps/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    helpDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpDeleteById");
        }
        var baseUrl = "/Helps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    helpExistsGetHelpsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpExistsGetHelpsidExists");
        }
        var baseUrl = "/Helps/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    helpExistsHeadHelpsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpExistsHeadHelpsid");
        }
        var baseUrl = "/Helps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    helpFind: function (params, options) {
        var baseUrl = "/Helps";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    helpFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpFindById");
        }
        var baseUrl = "/Helps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    helpFindOne: function (params, options) {
        var baseUrl = "/Helps/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpPatchOrCreate: function (params, options) {
        var baseUrl = "/Helps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts QuesHelp of Help.
     * @param id Help id
     * @param where Criteria to match model instances
     */
    helpPrototypeCountQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeCountQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in QuesHelp of this model.
     * @param id Help id
     * @param data
     */
    helpPrototypeCreateQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeCreateQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all QuesHelp of this model.
     * @param id Help id
     */
    helpPrototypeDeleteQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeDeleteQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    helpPrototypeDestroyByIdQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeDestroyByIdQuesHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling helpPrototypeDestroyByIdQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    helpPrototypeFindByIdQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeFindByIdQuesHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling helpPrototypeFindByIdQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Help id
     * @param refresh
     */
    helpPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeGetAccount");
        }
        var baseUrl = "/Helps/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries QuesHelp of Help.
     * @param id Help id
     * @param filter
     */
    helpPrototypeGetQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeGetQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Help id
     * @param data An object of model property name/value pairs
     */
    helpPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypePatchAttributes");
        }
        var baseUrl = "/Helps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     * @param data
     */
    helpPrototypeUpdateByIdQuesHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpPrototypeUpdateByIdQuesHelp");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling helpPrototypeUpdateByIdQuesHelp");
        }
        var baseUrl = "/Helps/{id}/QuesHelp/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    helpReplaceByIdPostHelpsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpReplaceByIdPostHelpsidReplace");
        }
        var baseUrl = "/Helps/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    helpReplaceByIdPutHelpsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling helpReplaceByIdPutHelpsid");
        }
        var baseUrl = "/Helps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpReplaceOrCreatePostHelpsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Helps/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpReplaceOrCreatePutHelps: function (params, options) {
        var baseUrl = "/Helps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    helpUpdateAll: function (params, options) {
        var baseUrl = "/Helps/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    helpUpsertWithWhere: function (params, options) {
        var baseUrl = "/Helps/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * HelpApi - functional programming interface
 */
export var HelpApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    helpCount: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    helpCreate: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    helpCreateChangeStreamGetHelpsChangeStream: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpCreateChangeStreamGetHelpsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    helpCreateChangeStreamPostHelpsChangeStream: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpCreateChangeStreamPostHelpsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    helpDeleteById: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    helpExistsGetHelpsidExists: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpExistsGetHelpsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    helpExistsHeadHelpsid: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpExistsHeadHelpsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    helpFind: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    helpFindById: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    helpFindOne: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpPatchOrCreate: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts QuesHelp of Help.
     * @param id Help id
     * @param where Criteria to match model instances
     */
    helpPrototypeCountQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeCountQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in QuesHelp of this model.
     * @param id Help id
     * @param data
     */
    helpPrototypeCreateQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeCreateQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all QuesHelp of this model.
     * @param id Help id
     */
    helpPrototypeDeleteQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeDeleteQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    helpPrototypeDestroyByIdQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeDestroyByIdQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    helpPrototypeFindByIdQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeFindByIdQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Help id
     * @param refresh
     */
    helpPrototypeGetAccount: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries QuesHelp of Help.
     * @param id Help id
     * @param filter
     */
    helpPrototypeGetQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeGetQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Help id
     * @param data An object of model property name/value pairs
     */
    helpPrototypePatchAttributes: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     * @param data
     */
    helpPrototypeUpdateByIdQuesHelp: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpPrototypeUpdateByIdQuesHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    helpReplaceByIdPostHelpsidReplace: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpReplaceByIdPostHelpsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    helpReplaceByIdPutHelpsid: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpReplaceByIdPutHelpsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpReplaceOrCreatePostHelpsReplaceOrCreate: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpReplaceOrCreatePostHelpsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    helpReplaceOrCreatePutHelps: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpReplaceOrCreatePutHelps(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    helpUpdateAll: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    helpUpsertWithWhere: function (params, options) {
        var fetchArgs = HelpApiFetchParamCreator.helpUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * HelpApi - object-oriented interface
 */
var HelpApi = /** @class */ (function (_super) {
    __extends(HelpApi, _super);
    function HelpApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    HelpApi.prototype.helpCount = function (params, options) {
        return HelpApiFp.helpCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    HelpApi.prototype.helpCreate = function (params, options) {
        return HelpApiFp.helpCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    HelpApi.prototype.helpCreateChangeStreamGetHelpsChangeStream = function (params, options) {
        return HelpApiFp.helpCreateChangeStreamGetHelpsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    HelpApi.prototype.helpCreateChangeStreamPostHelpsChangeStream = function (params, options) {
        return HelpApiFp.helpCreateChangeStreamPostHelpsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    HelpApi.prototype.helpDeleteById = function (params, options) {
        return HelpApiFp.helpDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    HelpApi.prototype.helpExistsGetHelpsidExists = function (params, options) {
        return HelpApiFp.helpExistsGetHelpsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    HelpApi.prototype.helpExistsHeadHelpsid = function (params, options) {
        return HelpApiFp.helpExistsHeadHelpsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    HelpApi.prototype.helpFind = function (params, options) {
        return HelpApiFp.helpFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    HelpApi.prototype.helpFindById = function (params, options) {
        return HelpApiFp.helpFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    HelpApi.prototype.helpFindOne = function (params, options) {
        return HelpApiFp.helpFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HelpApi.prototype.helpPatchOrCreate = function (params, options) {
        return HelpApiFp.helpPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts QuesHelp of Help.
     * @param id Help id
     * @param where Criteria to match model instances
     */
    HelpApi.prototype.helpPrototypeCountQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeCountQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in QuesHelp of this model.
     * @param id Help id
     * @param data
     */
    HelpApi.prototype.helpPrototypeCreateQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeCreateQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all QuesHelp of this model.
     * @param id Help id
     */
    HelpApi.prototype.helpPrototypeDeleteQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeDeleteQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    HelpApi.prototype.helpPrototypeDestroyByIdQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeDestroyByIdQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     */
    HelpApi.prototype.helpPrototypeFindByIdQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeFindByIdQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Help id
     * @param refresh
     */
    HelpApi.prototype.helpPrototypeGetAccount = function (params, options) {
        return HelpApiFp.helpPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries QuesHelp of Help.
     * @param id Help id
     * @param filter
     */
    HelpApi.prototype.helpPrototypeGetQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeGetQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Help id
     * @param data An object of model property name/value pairs
     */
    HelpApi.prototype.helpPrototypePatchAttributes = function (params, options) {
        return HelpApiFp.helpPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for QuesHelp.
     * @param id Help id
     * @param fk Foreign key for QuesHelp
     * @param data
     */
    HelpApi.prototype.helpPrototypeUpdateByIdQuesHelp = function (params, options) {
        return HelpApiFp.helpPrototypeUpdateByIdQuesHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    HelpApi.prototype.helpReplaceByIdPostHelpsidReplace = function (params, options) {
        return HelpApiFp.helpReplaceByIdPostHelpsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    HelpApi.prototype.helpReplaceByIdPutHelpsid = function (params, options) {
        return HelpApiFp.helpReplaceByIdPutHelpsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HelpApi.prototype.helpReplaceOrCreatePostHelpsReplaceOrCreate = function (params, options) {
        return HelpApiFp.helpReplaceOrCreatePostHelpsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HelpApi.prototype.helpReplaceOrCreatePutHelps = function (params, options) {
        return HelpApiFp.helpReplaceOrCreatePutHelps(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    HelpApi.prototype.helpUpdateAll = function (params, options) {
        return HelpApiFp.helpUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    HelpApi.prototype.helpUpsertWithWhere = function (params, options) {
        return HelpApiFp.helpUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return HelpApi;
}(BaseAPI));
export { HelpApi };
/**
 * HelpApi - factory interface
 */
export var HelpApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        helpCount: function (params, options) {
            return HelpApiFp.helpCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        helpCreate: function (params, options) {
            return HelpApiFp.helpCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        helpCreateChangeStreamGetHelpsChangeStream: function (params, options) {
            return HelpApiFp.helpCreateChangeStreamGetHelpsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        helpCreateChangeStreamPostHelpsChangeStream: function (params, options) {
            return HelpApiFp.helpCreateChangeStreamPostHelpsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        helpDeleteById: function (params, options) {
            return HelpApiFp.helpDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        helpExistsGetHelpsidExists: function (params, options) {
            return HelpApiFp.helpExistsGetHelpsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        helpExistsHeadHelpsid: function (params, options) {
            return HelpApiFp.helpExistsHeadHelpsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        helpFind: function (params, options) {
            return HelpApiFp.helpFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        helpFindById: function (params, options) {
            return HelpApiFp.helpFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        helpFindOne: function (params, options) {
            return HelpApiFp.helpFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        helpPatchOrCreate: function (params, options) {
            return HelpApiFp.helpPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts QuesHelp of Help.
         * @param id Help id
         * @param where Criteria to match model instances
         */
        helpPrototypeCountQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeCountQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in QuesHelp of this model.
         * @param id Help id
         * @param data
         */
        helpPrototypeCreateQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeCreateQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all QuesHelp of this model.
         * @param id Help id
         */
        helpPrototypeDeleteQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeDeleteQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for QuesHelp.
         * @param id Help id
         * @param fk Foreign key for QuesHelp
         */
        helpPrototypeDestroyByIdQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeDestroyByIdQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for QuesHelp.
         * @param id Help id
         * @param fk Foreign key for QuesHelp
         */
        helpPrototypeFindByIdQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeFindByIdQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Help id
         * @param refresh
         */
        helpPrototypeGetAccount: function (params, options) {
            return HelpApiFp.helpPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries QuesHelp of Help.
         * @param id Help id
         * @param filter
         */
        helpPrototypeGetQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeGetQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Help id
         * @param data An object of model property name/value pairs
         */
        helpPrototypePatchAttributes: function (params, options) {
            return HelpApiFp.helpPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for QuesHelp.
         * @param id Help id
         * @param fk Foreign key for QuesHelp
         * @param data
         */
        helpPrototypeUpdateByIdQuesHelp: function (params, options) {
            return HelpApiFp.helpPrototypeUpdateByIdQuesHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        helpReplaceByIdPostHelpsidReplace: function (params, options) {
            return HelpApiFp.helpReplaceByIdPostHelpsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        helpReplaceByIdPutHelpsid: function (params, options) {
            return HelpApiFp.helpReplaceByIdPutHelpsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        helpReplaceOrCreatePostHelpsReplaceOrCreate: function (params, options) {
            return HelpApiFp.helpReplaceOrCreatePostHelpsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        helpReplaceOrCreatePutHelps: function (params, options) {
            return HelpApiFp.helpReplaceOrCreatePutHelps(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        helpUpdateAll: function (params, options) {
            return HelpApiFp.helpUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        helpUpsertWithWhere: function (params, options) {
            return HelpApiFp.helpUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * HomeApi - fetch parameter creator
 */
export var HomeApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    homeCount: function (params, options) {
        var baseUrl = "/Homes/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    homeCreate: function (params, options) {
        var baseUrl = "/Homes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    homeCreateChangeStreamGetHomesChangeStream: function (params, options) {
        var baseUrl = "/Homes/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    homeCreateChangeStreamPostHomesChangeStream: function (params, options) {
        var baseUrl = "/Homes/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    homeDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeDeleteById");
        }
        var baseUrl = "/Homes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    homeExistsGetHomesidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeExistsGetHomesidExists");
        }
        var baseUrl = "/Homes/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    homeExistsHeadHomesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeExistsHeadHomesid");
        }
        var baseUrl = "/Homes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    homeFind: function (params, options) {
        var baseUrl = "/Homes";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    homeFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeFindById");
        }
        var baseUrl = "/Homes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    homeFindOne: function (params, options) {
        var baseUrl = "/Homes/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homePatchOrCreate: function (params, options) {
        var baseUrl = "/Homes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Home id
     * @param data An object of model property name/value pairs
     */
    homePrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homePrototypePatchAttributes");
        }
        var baseUrl = "/Homes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    homeReplaceByIdPostHomesidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeReplaceByIdPostHomesidReplace");
        }
        var baseUrl = "/Homes/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    homeReplaceByIdPutHomesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling homeReplaceByIdPutHomesid");
        }
        var baseUrl = "/Homes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homeReplaceOrCreatePostHomesReplaceOrCreate: function (params, options) {
        var baseUrl = "/Homes/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homeReplaceOrCreatePutHomes: function (params, options) {
        var baseUrl = "/Homes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    homeUpdateAll: function (params, options) {
        var baseUrl = "/Homes/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    homeUpsertWithWhere: function (params, options) {
        var baseUrl = "/Homes/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * HomeApi - functional programming interface
 */
export var HomeApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    homeCount: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    homeCreate: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    homeCreateChangeStreamGetHomesChangeStream: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeCreateChangeStreamGetHomesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    homeCreateChangeStreamPostHomesChangeStream: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeCreateChangeStreamPostHomesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    homeDeleteById: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    homeExistsGetHomesidExists: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeExistsGetHomesidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    homeExistsHeadHomesid: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeExistsHeadHomesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    homeFind: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    homeFindById: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    homeFindOne: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homePatchOrCreate: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homePatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Home id
     * @param data An object of model property name/value pairs
     */
    homePrototypePatchAttributes: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homePrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    homeReplaceByIdPostHomesidReplace: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeReplaceByIdPostHomesidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    homeReplaceByIdPutHomesid: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeReplaceByIdPutHomesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homeReplaceOrCreatePostHomesReplaceOrCreate: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeReplaceOrCreatePostHomesReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    homeReplaceOrCreatePutHomes: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeReplaceOrCreatePutHomes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    homeUpdateAll: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    homeUpsertWithWhere: function (params, options) {
        var fetchArgs = HomeApiFetchParamCreator.homeUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * HomeApi - object-oriented interface
 */
var HomeApi = /** @class */ (function (_super) {
    __extends(HomeApi, _super);
    function HomeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    HomeApi.prototype.homeCount = function (params, options) {
        return HomeApiFp.homeCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    HomeApi.prototype.homeCreate = function (params, options) {
        return HomeApiFp.homeCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    HomeApi.prototype.homeCreateChangeStreamGetHomesChangeStream = function (params, options) {
        return HomeApiFp.homeCreateChangeStreamGetHomesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    HomeApi.prototype.homeCreateChangeStreamPostHomesChangeStream = function (params, options) {
        return HomeApiFp.homeCreateChangeStreamPostHomesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    HomeApi.prototype.homeDeleteById = function (params, options) {
        return HomeApiFp.homeDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    HomeApi.prototype.homeExistsGetHomesidExists = function (params, options) {
        return HomeApiFp.homeExistsGetHomesidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    HomeApi.prototype.homeExistsHeadHomesid = function (params, options) {
        return HomeApiFp.homeExistsHeadHomesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    HomeApi.prototype.homeFind = function (params, options) {
        return HomeApiFp.homeFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    HomeApi.prototype.homeFindById = function (params, options) {
        return HomeApiFp.homeFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    HomeApi.prototype.homeFindOne = function (params, options) {
        return HomeApiFp.homeFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HomeApi.prototype.homePatchOrCreate = function (params, options) {
        return HomeApiFp.homePatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Home id
     * @param data An object of model property name/value pairs
     */
    HomeApi.prototype.homePrototypePatchAttributes = function (params, options) {
        return HomeApiFp.homePrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    HomeApi.prototype.homeReplaceByIdPostHomesidReplace = function (params, options) {
        return HomeApiFp.homeReplaceByIdPostHomesidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    HomeApi.prototype.homeReplaceByIdPutHomesid = function (params, options) {
        return HomeApiFp.homeReplaceByIdPutHomesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HomeApi.prototype.homeReplaceOrCreatePostHomesReplaceOrCreate = function (params, options) {
        return HomeApiFp.homeReplaceOrCreatePostHomesReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    HomeApi.prototype.homeReplaceOrCreatePutHomes = function (params, options) {
        return HomeApiFp.homeReplaceOrCreatePutHomes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    HomeApi.prototype.homeUpdateAll = function (params, options) {
        return HomeApiFp.homeUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    HomeApi.prototype.homeUpsertWithWhere = function (params, options) {
        return HomeApiFp.homeUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return HomeApi;
}(BaseAPI));
export { HomeApi };
/**
 * HomeApi - factory interface
 */
export var HomeApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        homeCount: function (params, options) {
            return HomeApiFp.homeCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        homeCreate: function (params, options) {
            return HomeApiFp.homeCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        homeCreateChangeStreamGetHomesChangeStream: function (params, options) {
            return HomeApiFp.homeCreateChangeStreamGetHomesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        homeCreateChangeStreamPostHomesChangeStream: function (params, options) {
            return HomeApiFp.homeCreateChangeStreamPostHomesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        homeDeleteById: function (params, options) {
            return HomeApiFp.homeDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        homeExistsGetHomesidExists: function (params, options) {
            return HomeApiFp.homeExistsGetHomesidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        homeExistsHeadHomesid: function (params, options) {
            return HomeApiFp.homeExistsHeadHomesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        homeFind: function (params, options) {
            return HomeApiFp.homeFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        homeFindById: function (params, options) {
            return HomeApiFp.homeFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        homeFindOne: function (params, options) {
            return HomeApiFp.homeFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        homePatchOrCreate: function (params, options) {
            return HomeApiFp.homePatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Home id
         * @param data An object of model property name/value pairs
         */
        homePrototypePatchAttributes: function (params, options) {
            return HomeApiFp.homePrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        homeReplaceByIdPostHomesidReplace: function (params, options) {
            return HomeApiFp.homeReplaceByIdPostHomesidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        homeReplaceByIdPutHomesid: function (params, options) {
            return HomeApiFp.homeReplaceByIdPutHomesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        homeReplaceOrCreatePostHomesReplaceOrCreate: function (params, options) {
            return HomeApiFp.homeReplaceOrCreatePostHomesReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        homeReplaceOrCreatePutHomes: function (params, options) {
            return HomeApiFp.homeReplaceOrCreatePutHomes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        homeUpdateAll: function (params, options) {
            return HomeApiFp.homeUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        homeUpsertWithWhere: function (params, options) {
            return HomeApiFp.homeUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * ImageSlideApi - fetch parameter creator
 */
export var ImageSlideApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    imageSlideCount: function (params, options) {
        var baseUrl = "/ImageSlides/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    imageSlideCreate: function (params, options) {
        var baseUrl = "/ImageSlides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    imageSlideCreateChangeStreamGetImageSlidesChangeStream: function (params, options) {
        var baseUrl = "/ImageSlides/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    imageSlideCreateChangeStreamPostImageSlidesChangeStream: function (params, options) {
        var baseUrl = "/ImageSlides/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    imageSlideDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideDeleteById");
        }
        var baseUrl = "/ImageSlides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    imageSlideExistsGetImageSlidesidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideExistsGetImageSlidesidExists");
        }
        var baseUrl = "/ImageSlides/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    imageSlideExistsHeadImageSlidesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideExistsHeadImageSlidesid");
        }
        var baseUrl = "/ImageSlides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    imageSlideFind: function (params, options) {
        var baseUrl = "/ImageSlides";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    imageSlideFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideFindById");
        }
        var baseUrl = "/ImageSlides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    imageSlideFindOne: function (params, options) {
        var baseUrl = "/ImageSlides/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlidePatchOrCreate: function (params, options) {
        var baseUrl = "/ImageSlides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ImageSlide id
     * @param data An object of model property name/value pairs
     */
    imageSlidePrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlidePrototypePatchAttributes");
        }
        var baseUrl = "/ImageSlides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    imageSlideReplaceByIdPostImageSlidesidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideReplaceByIdPostImageSlidesidReplace");
        }
        var baseUrl = "/ImageSlides/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    imageSlideReplaceByIdPutImageSlidesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling imageSlideReplaceByIdPutImageSlidesid");
        }
        var baseUrl = "/ImageSlides/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate: function (params, options) {
        var baseUrl = "/ImageSlides/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlideReplaceOrCreatePutImageSlides: function (params, options) {
        var baseUrl = "/ImageSlides";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    imageSlideUpdateAll: function (params, options) {
        var baseUrl = "/ImageSlides/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    imageSlideUpsertWithWhere: function (params, options) {
        var baseUrl = "/ImageSlides/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ImageSlideApi - functional programming interface
 */
export var ImageSlideApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    imageSlideCount: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    imageSlideCreate: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    imageSlideCreateChangeStreamGetImageSlidesChangeStream: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideCreateChangeStreamGetImageSlidesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    imageSlideCreateChangeStreamPostImageSlidesChangeStream: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideCreateChangeStreamPostImageSlidesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    imageSlideDeleteById: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    imageSlideExistsGetImageSlidesidExists: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideExistsGetImageSlidesidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    imageSlideExistsHeadImageSlidesid: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideExistsHeadImageSlidesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    imageSlideFind: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    imageSlideFindById: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    imageSlideFindOne: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlidePatchOrCreate: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlidePatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ImageSlide id
     * @param data An object of model property name/value pairs
     */
    imageSlidePrototypePatchAttributes: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlidePrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    imageSlideReplaceByIdPostImageSlidesidReplace: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideReplaceByIdPostImageSlidesidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    imageSlideReplaceByIdPutImageSlidesid: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideReplaceByIdPutImageSlidesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    imageSlideReplaceOrCreatePutImageSlides: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideReplaceOrCreatePutImageSlides(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    imageSlideUpdateAll: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    imageSlideUpsertWithWhere: function (params, options) {
        var fetchArgs = ImageSlideApiFetchParamCreator.imageSlideUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ImageSlideApi - object-oriented interface
 */
var ImageSlideApi = /** @class */ (function (_super) {
    __extends(ImageSlideApi, _super);
    function ImageSlideApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ImageSlideApi.prototype.imageSlideCount = function (params, options) {
        return ImageSlideApiFp.imageSlideCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlideCreate = function (params, options) {
        return ImageSlideApiFp.imageSlideCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ImageSlideApi.prototype.imageSlideCreateChangeStreamGetImageSlidesChangeStream = function (params, options) {
        return ImageSlideApiFp.imageSlideCreateChangeStreamGetImageSlidesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ImageSlideApi.prototype.imageSlideCreateChangeStreamPostImageSlidesChangeStream = function (params, options) {
        return ImageSlideApiFp.imageSlideCreateChangeStreamPostImageSlidesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ImageSlideApi.prototype.imageSlideDeleteById = function (params, options) {
        return ImageSlideApiFp.imageSlideDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ImageSlideApi.prototype.imageSlideExistsGetImageSlidesidExists = function (params, options) {
        return ImageSlideApiFp.imageSlideExistsGetImageSlidesidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ImageSlideApi.prototype.imageSlideExistsHeadImageSlidesid = function (params, options) {
        return ImageSlideApiFp.imageSlideExistsHeadImageSlidesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ImageSlideApi.prototype.imageSlideFind = function (params, options) {
        return ImageSlideApiFp.imageSlideFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ImageSlideApi.prototype.imageSlideFindById = function (params, options) {
        return ImageSlideApiFp.imageSlideFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ImageSlideApi.prototype.imageSlideFindOne = function (params, options) {
        return ImageSlideApiFp.imageSlideFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlidePatchOrCreate = function (params, options) {
        return ImageSlideApiFp.imageSlidePatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id ImageSlide id
     * @param data An object of model property name/value pairs
     */
    ImageSlideApi.prototype.imageSlidePrototypePatchAttributes = function (params, options) {
        return ImageSlideApiFp.imageSlidePrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlideReplaceByIdPostImageSlidesidReplace = function (params, options) {
        return ImageSlideApiFp.imageSlideReplaceByIdPostImageSlidesidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlideReplaceByIdPutImageSlidesid = function (params, options) {
        return ImageSlideApiFp.imageSlideReplaceByIdPutImageSlidesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate = function (params, options) {
        return ImageSlideApiFp.imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ImageSlideApi.prototype.imageSlideReplaceOrCreatePutImageSlides = function (params, options) {
        return ImageSlideApiFp.imageSlideReplaceOrCreatePutImageSlides(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ImageSlideApi.prototype.imageSlideUpdateAll = function (params, options) {
        return ImageSlideApiFp.imageSlideUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ImageSlideApi.prototype.imageSlideUpsertWithWhere = function (params, options) {
        return ImageSlideApiFp.imageSlideUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return ImageSlideApi;
}(BaseAPI));
export { ImageSlideApi };
/**
 * ImageSlideApi - factory interface
 */
export var ImageSlideApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        imageSlideCount: function (params, options) {
            return ImageSlideApiFp.imageSlideCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        imageSlideCreate: function (params, options) {
            return ImageSlideApiFp.imageSlideCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        imageSlideCreateChangeStreamGetImageSlidesChangeStream: function (params, options) {
            return ImageSlideApiFp.imageSlideCreateChangeStreamGetImageSlidesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        imageSlideCreateChangeStreamPostImageSlidesChangeStream: function (params, options) {
            return ImageSlideApiFp.imageSlideCreateChangeStreamPostImageSlidesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        imageSlideDeleteById: function (params, options) {
            return ImageSlideApiFp.imageSlideDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        imageSlideExistsGetImageSlidesidExists: function (params, options) {
            return ImageSlideApiFp.imageSlideExistsGetImageSlidesidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        imageSlideExistsHeadImageSlidesid: function (params, options) {
            return ImageSlideApiFp.imageSlideExistsHeadImageSlidesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        imageSlideFind: function (params, options) {
            return ImageSlideApiFp.imageSlideFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        imageSlideFindById: function (params, options) {
            return ImageSlideApiFp.imageSlideFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        imageSlideFindOne: function (params, options) {
            return ImageSlideApiFp.imageSlideFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        imageSlidePatchOrCreate: function (params, options) {
            return ImageSlideApiFp.imageSlidePatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id ImageSlide id
         * @param data An object of model property name/value pairs
         */
        imageSlidePrototypePatchAttributes: function (params, options) {
            return ImageSlideApiFp.imageSlidePrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        imageSlideReplaceByIdPostImageSlidesidReplace: function (params, options) {
            return ImageSlideApiFp.imageSlideReplaceByIdPostImageSlidesidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        imageSlideReplaceByIdPutImageSlidesid: function (params, options) {
            return ImageSlideApiFp.imageSlideReplaceByIdPutImageSlidesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate: function (params, options) {
            return ImageSlideApiFp.imageSlideReplaceOrCreatePostImageSlidesReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        imageSlideReplaceOrCreatePutImageSlides: function (params, options) {
            return ImageSlideApiFp.imageSlideReplaceOrCreatePutImageSlides(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        imageSlideUpdateAll: function (params, options) {
            return ImageSlideApiFp.imageSlideUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        imageSlideUpsertWithWhere: function (params, options) {
            return ImageSlideApiFp.imageSlideUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * KeyApi - fetch parameter creator
 */
export var KeyApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    keyCount: function (params, options) {
        var baseUrl = "/Keys/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    keyCreate: function (params, options) {
        var baseUrl = "/Keys";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    keyCreateChangeStreamGetKeysChangeStream: function (params, options) {
        var baseUrl = "/Keys/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    keyCreateChangeStreamPostKeysChangeStream: function (params, options) {
        var baseUrl = "/Keys/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    keyDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyDeleteById");
        }
        var baseUrl = "/Keys/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    keyExistsGetKeysidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyExistsGetKeysidExists");
        }
        var baseUrl = "/Keys/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    keyExistsHeadKeysid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyExistsHeadKeysid");
        }
        var baseUrl = "/Keys/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    keyFind: function (params, options) {
        var baseUrl = "/Keys";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    keyFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyFindById");
        }
        var baseUrl = "/Keys/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    keyFindOne: function (params, options) {
        var baseUrl = "/Keys/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyPatchOrCreate: function (params, options) {
        var baseUrl = "/Keys";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Key id
     * @param refresh
     */
    keyPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyPrototypeGetAccount");
        }
        var baseUrl = "/Keys/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id Key id
     * @param refresh
     */
    keyPrototypeGetQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyPrototypeGetQuestion");
        }
        var baseUrl = "/Keys/{id}/question".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Key id
     * @param data An object of model property name/value pairs
     */
    keyPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyPrototypePatchAttributes");
        }
        var baseUrl = "/Keys/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    keyReplaceByIdPostKeysidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyReplaceByIdPostKeysidReplace");
        }
        var baseUrl = "/Keys/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    keyReplaceByIdPutKeysid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling keyReplaceByIdPutKeysid");
        }
        var baseUrl = "/Keys/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyReplaceOrCreatePostKeysReplaceOrCreate: function (params, options) {
        var baseUrl = "/Keys/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyReplaceOrCreatePutKeys: function (params, options) {
        var baseUrl = "/Keys";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    keyUpdateAll: function (params, options) {
        var baseUrl = "/Keys/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    keyUpsertWithWhere: function (params, options) {
        var baseUrl = "/Keys/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * KeyApi - functional programming interface
 */
export var KeyApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    keyCount: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    keyCreate: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    keyCreateChangeStreamGetKeysChangeStream: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyCreateChangeStreamGetKeysChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    keyCreateChangeStreamPostKeysChangeStream: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyCreateChangeStreamPostKeysChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    keyDeleteById: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    keyExistsGetKeysidExists: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyExistsGetKeysidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    keyExistsHeadKeysid: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyExistsHeadKeysid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    keyFind: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    keyFindById: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    keyFindOne: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyPatchOrCreate: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Key id
     * @param refresh
     */
    keyPrototypeGetAccount: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id Key id
     * @param refresh
     */
    keyPrototypeGetQuestion: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyPrototypeGetQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Key id
     * @param data An object of model property name/value pairs
     */
    keyPrototypePatchAttributes: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    keyReplaceByIdPostKeysidReplace: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyReplaceByIdPostKeysidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    keyReplaceByIdPutKeysid: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyReplaceByIdPutKeysid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyReplaceOrCreatePostKeysReplaceOrCreate: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyReplaceOrCreatePostKeysReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    keyReplaceOrCreatePutKeys: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyReplaceOrCreatePutKeys(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    keyUpdateAll: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    keyUpsertWithWhere: function (params, options) {
        var fetchArgs = KeyApiFetchParamCreator.keyUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * KeyApi - object-oriented interface
 */
var KeyApi = /** @class */ (function (_super) {
    __extends(KeyApi, _super);
    function KeyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    KeyApi.prototype.keyCount = function (params, options) {
        return KeyApiFp.keyCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    KeyApi.prototype.keyCreate = function (params, options) {
        return KeyApiFp.keyCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    KeyApi.prototype.keyCreateChangeStreamGetKeysChangeStream = function (params, options) {
        return KeyApiFp.keyCreateChangeStreamGetKeysChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    KeyApi.prototype.keyCreateChangeStreamPostKeysChangeStream = function (params, options) {
        return KeyApiFp.keyCreateChangeStreamPostKeysChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    KeyApi.prototype.keyDeleteById = function (params, options) {
        return KeyApiFp.keyDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    KeyApi.prototype.keyExistsGetKeysidExists = function (params, options) {
        return KeyApiFp.keyExistsGetKeysidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    KeyApi.prototype.keyExistsHeadKeysid = function (params, options) {
        return KeyApiFp.keyExistsHeadKeysid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    KeyApi.prototype.keyFind = function (params, options) {
        return KeyApiFp.keyFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    KeyApi.prototype.keyFindById = function (params, options) {
        return KeyApiFp.keyFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    KeyApi.prototype.keyFindOne = function (params, options) {
        return KeyApiFp.keyFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    KeyApi.prototype.keyPatchOrCreate = function (params, options) {
        return KeyApiFp.keyPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Key id
     * @param refresh
     */
    KeyApi.prototype.keyPrototypeGetAccount = function (params, options) {
        return KeyApiFp.keyPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id Key id
     * @param refresh
     */
    KeyApi.prototype.keyPrototypeGetQuestion = function (params, options) {
        return KeyApiFp.keyPrototypeGetQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Key id
     * @param data An object of model property name/value pairs
     */
    KeyApi.prototype.keyPrototypePatchAttributes = function (params, options) {
        return KeyApiFp.keyPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    KeyApi.prototype.keyReplaceByIdPostKeysidReplace = function (params, options) {
        return KeyApiFp.keyReplaceByIdPostKeysidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    KeyApi.prototype.keyReplaceByIdPutKeysid = function (params, options) {
        return KeyApiFp.keyReplaceByIdPutKeysid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    KeyApi.prototype.keyReplaceOrCreatePostKeysReplaceOrCreate = function (params, options) {
        return KeyApiFp.keyReplaceOrCreatePostKeysReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    KeyApi.prototype.keyReplaceOrCreatePutKeys = function (params, options) {
        return KeyApiFp.keyReplaceOrCreatePutKeys(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    KeyApi.prototype.keyUpdateAll = function (params, options) {
        return KeyApiFp.keyUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    KeyApi.prototype.keyUpsertWithWhere = function (params, options) {
        return KeyApiFp.keyUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return KeyApi;
}(BaseAPI));
export { KeyApi };
/**
 * KeyApi - factory interface
 */
export var KeyApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        keyCount: function (params, options) {
            return KeyApiFp.keyCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        keyCreate: function (params, options) {
            return KeyApiFp.keyCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        keyCreateChangeStreamGetKeysChangeStream: function (params, options) {
            return KeyApiFp.keyCreateChangeStreamGetKeysChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        keyCreateChangeStreamPostKeysChangeStream: function (params, options) {
            return KeyApiFp.keyCreateChangeStreamPostKeysChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        keyDeleteById: function (params, options) {
            return KeyApiFp.keyDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        keyExistsGetKeysidExists: function (params, options) {
            return KeyApiFp.keyExistsGetKeysidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        keyExistsHeadKeysid: function (params, options) {
            return KeyApiFp.keyExistsHeadKeysid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        keyFind: function (params, options) {
            return KeyApiFp.keyFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        keyFindById: function (params, options) {
            return KeyApiFp.keyFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        keyFindOne: function (params, options) {
            return KeyApiFp.keyFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        keyPatchOrCreate: function (params, options) {
            return KeyApiFp.keyPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Key id
         * @param refresh
         */
        keyPrototypeGetAccount: function (params, options) {
            return KeyApiFp.keyPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation question.
         * @param id Key id
         * @param refresh
         */
        keyPrototypeGetQuestion: function (params, options) {
            return KeyApiFp.keyPrototypeGetQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Key id
         * @param data An object of model property name/value pairs
         */
        keyPrototypePatchAttributes: function (params, options) {
            return KeyApiFp.keyPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        keyReplaceByIdPostKeysidReplace: function (params, options) {
            return KeyApiFp.keyReplaceByIdPostKeysidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        keyReplaceByIdPutKeysid: function (params, options) {
            return KeyApiFp.keyReplaceByIdPutKeysid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        keyReplaceOrCreatePostKeysReplaceOrCreate: function (params, options) {
            return KeyApiFp.keyReplaceOrCreatePostKeysReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        keyReplaceOrCreatePutKeys: function (params, options) {
            return KeyApiFp.keyReplaceOrCreatePutKeys(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        keyUpdateAll: function (params, options) {
            return KeyApiFp.keyUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        keyUpsertWithWhere: function (params, options) {
            return KeyApiFp.keyUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * NotificationApi - fetch parameter creator
 */
export var NotificationApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    notificationCount: function (params, options) {
        var baseUrl = "/Notifications/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    notificationCreate: function (params, options) {
        var baseUrl = "/Notifications";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    notificationCreateChangeStreamGetNotificationsChangeStream: function (params, options) {
        var baseUrl = "/Notifications/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    notificationCreateChangeStreamPostNotificationsChangeStream: function (params, options) {
        var baseUrl = "/Notifications/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    notificationDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationDeleteById");
        }
        var baseUrl = "/Notifications/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    notificationExistsGetNotificationsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationExistsGetNotificationsidExists");
        }
        var baseUrl = "/Notifications/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    notificationExistsHeadNotificationsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationExistsHeadNotificationsid");
        }
        var baseUrl = "/Notifications/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    notificationFind: function (params, options) {
        var baseUrl = "/Notifications";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    notificationFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationFindById");
        }
        var baseUrl = "/Notifications/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    notificationFindOne: function (params, options) {
        var baseUrl = "/Notifications/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationPatchOrCreate: function (params, options) {
        var baseUrl = "/Notifications";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Notification id
     * @param refresh
     */
    notificationPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationPrototypeGetAccount");
        }
        var baseUrl = "/Notifications/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Notification id
     * @param data An object of model property name/value pairs
     */
    notificationPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationPrototypePatchAttributes");
        }
        var baseUrl = "/Notifications/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    notificationReplaceByIdPostNotificationsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationReplaceByIdPostNotificationsidReplace");
        }
        var baseUrl = "/Notifications/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    notificationReplaceByIdPutNotificationsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling notificationReplaceByIdPutNotificationsid");
        }
        var baseUrl = "/Notifications/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationReplaceOrCreatePostNotificationsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Notifications/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationReplaceOrCreatePutNotifications: function (params, options) {
        var baseUrl = "/Notifications";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    notificationUpdateAll: function (params, options) {
        var baseUrl = "/Notifications/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    notificationUpsertWithWhere: function (params, options) {
        var baseUrl = "/Notifications/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * NotificationApi - functional programming interface
 */
export var NotificationApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    notificationCount: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    notificationCreate: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    notificationCreateChangeStreamGetNotificationsChangeStream: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationCreateChangeStreamGetNotificationsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    notificationCreateChangeStreamPostNotificationsChangeStream: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationCreateChangeStreamPostNotificationsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    notificationDeleteById: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    notificationExistsGetNotificationsidExists: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationExistsGetNotificationsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    notificationExistsHeadNotificationsid: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationExistsHeadNotificationsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    notificationFind: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    notificationFindById: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    notificationFindOne: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationPatchOrCreate: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Notification id
     * @param refresh
     */
    notificationPrototypeGetAccount: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Notification id
     * @param data An object of model property name/value pairs
     */
    notificationPrototypePatchAttributes: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    notificationReplaceByIdPostNotificationsidReplace: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationReplaceByIdPostNotificationsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    notificationReplaceByIdPutNotificationsid: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationReplaceByIdPutNotificationsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationReplaceOrCreatePostNotificationsReplaceOrCreate: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationReplaceOrCreatePostNotificationsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    notificationReplaceOrCreatePutNotifications: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationReplaceOrCreatePutNotifications(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    notificationUpdateAll: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    notificationUpsertWithWhere: function (params, options) {
        var fetchArgs = NotificationApiFetchParamCreator.notificationUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * NotificationApi - object-oriented interface
 */
var NotificationApi = /** @class */ (function (_super) {
    __extends(NotificationApi, _super);
    function NotificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    NotificationApi.prototype.notificationCount = function (params, options) {
        return NotificationApiFp.notificationCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationCreate = function (params, options) {
        return NotificationApiFp.notificationCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    NotificationApi.prototype.notificationCreateChangeStreamGetNotificationsChangeStream = function (params, options) {
        return NotificationApiFp.notificationCreateChangeStreamGetNotificationsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    NotificationApi.prototype.notificationCreateChangeStreamPostNotificationsChangeStream = function (params, options) {
        return NotificationApiFp.notificationCreateChangeStreamPostNotificationsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    NotificationApi.prototype.notificationDeleteById = function (params, options) {
        return NotificationApiFp.notificationDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    NotificationApi.prototype.notificationExistsGetNotificationsidExists = function (params, options) {
        return NotificationApiFp.notificationExistsGetNotificationsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    NotificationApi.prototype.notificationExistsHeadNotificationsid = function (params, options) {
        return NotificationApiFp.notificationExistsHeadNotificationsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    NotificationApi.prototype.notificationFind = function (params, options) {
        return NotificationApiFp.notificationFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    NotificationApi.prototype.notificationFindById = function (params, options) {
        return NotificationApiFp.notificationFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    NotificationApi.prototype.notificationFindOne = function (params, options) {
        return NotificationApiFp.notificationFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationPatchOrCreate = function (params, options) {
        return NotificationApiFp.notificationPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Notification id
     * @param refresh
     */
    NotificationApi.prototype.notificationPrototypeGetAccount = function (params, options) {
        return NotificationApiFp.notificationPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Notification id
     * @param data An object of model property name/value pairs
     */
    NotificationApi.prototype.notificationPrototypePatchAttributes = function (params, options) {
        return NotificationApiFp.notificationPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationReplaceByIdPostNotificationsidReplace = function (params, options) {
        return NotificationApiFp.notificationReplaceByIdPostNotificationsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationReplaceByIdPutNotificationsid = function (params, options) {
        return NotificationApiFp.notificationReplaceByIdPutNotificationsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationReplaceOrCreatePostNotificationsReplaceOrCreate = function (params, options) {
        return NotificationApiFp.notificationReplaceOrCreatePostNotificationsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    NotificationApi.prototype.notificationReplaceOrCreatePutNotifications = function (params, options) {
        return NotificationApiFp.notificationReplaceOrCreatePutNotifications(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    NotificationApi.prototype.notificationUpdateAll = function (params, options) {
        return NotificationApiFp.notificationUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    NotificationApi.prototype.notificationUpsertWithWhere = function (params, options) {
        return NotificationApiFp.notificationUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return NotificationApi;
}(BaseAPI));
export { NotificationApi };
/**
 * NotificationApi - factory interface
 */
export var NotificationApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        notificationCount: function (params, options) {
            return NotificationApiFp.notificationCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        notificationCreate: function (params, options) {
            return NotificationApiFp.notificationCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        notificationCreateChangeStreamGetNotificationsChangeStream: function (params, options) {
            return NotificationApiFp.notificationCreateChangeStreamGetNotificationsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        notificationCreateChangeStreamPostNotificationsChangeStream: function (params, options) {
            return NotificationApiFp.notificationCreateChangeStreamPostNotificationsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        notificationDeleteById: function (params, options) {
            return NotificationApiFp.notificationDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        notificationExistsGetNotificationsidExists: function (params, options) {
            return NotificationApiFp.notificationExistsGetNotificationsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        notificationExistsHeadNotificationsid: function (params, options) {
            return NotificationApiFp.notificationExistsHeadNotificationsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        notificationFind: function (params, options) {
            return NotificationApiFp.notificationFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        notificationFindById: function (params, options) {
            return NotificationApiFp.notificationFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        notificationFindOne: function (params, options) {
            return NotificationApiFp.notificationFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        notificationPatchOrCreate: function (params, options) {
            return NotificationApiFp.notificationPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Notification id
         * @param refresh
         */
        notificationPrototypeGetAccount: function (params, options) {
            return NotificationApiFp.notificationPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Notification id
         * @param data An object of model property name/value pairs
         */
        notificationPrototypePatchAttributes: function (params, options) {
            return NotificationApiFp.notificationPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        notificationReplaceByIdPostNotificationsidReplace: function (params, options) {
            return NotificationApiFp.notificationReplaceByIdPostNotificationsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        notificationReplaceByIdPutNotificationsid: function (params, options) {
            return NotificationApiFp.notificationReplaceByIdPutNotificationsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        notificationReplaceOrCreatePostNotificationsReplaceOrCreate: function (params, options) {
            return NotificationApiFp.notificationReplaceOrCreatePostNotificationsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        notificationReplaceOrCreatePutNotifications: function (params, options) {
            return NotificationApiFp.notificationReplaceOrCreatePutNotifications(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        notificationUpdateAll: function (params, options) {
            return NotificationApiFp.notificationUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        notificationUpsertWithWhere: function (params, options) {
            return NotificationApiFp.notificationUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * QuesHelpApi - fetch parameter creator
 */
export var QuesHelpApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    quesHelpCount: function (params, options) {
        var baseUrl = "/QuesHelps/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    quesHelpCreate: function (params, options) {
        var baseUrl = "/QuesHelps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    quesHelpCreateChangeStreamGetQuesHelpsChangeStream: function (params, options) {
        var baseUrl = "/QuesHelps/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    quesHelpCreateChangeStreamPostQuesHelpsChangeStream: function (params, options) {
        var baseUrl = "/QuesHelps/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    quesHelpDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpDeleteById");
        }
        var baseUrl = "/QuesHelps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    quesHelpExistsGetQuesHelpsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpExistsGetQuesHelpsidExists");
        }
        var baseUrl = "/QuesHelps/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    quesHelpExistsHeadQuesHelpsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpExistsHeadQuesHelpsid");
        }
        var baseUrl = "/QuesHelps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    quesHelpFind: function (params, options) {
        var baseUrl = "/QuesHelps";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    quesHelpFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpFindById");
        }
        var baseUrl = "/QuesHelps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    quesHelpFindOne: function (params, options) {
        var baseUrl = "/QuesHelps/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpPatchOrCreate: function (params, options) {
        var baseUrl = "/QuesHelps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation help.
     * @param id QuesHelp id
     * @param refresh
     */
    quesHelpPrototypeGetHelp: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpPrototypeGetHelp");
        }
        var baseUrl = "/QuesHelps/{id}/help".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuesHelp id
     * @param data An object of model property name/value pairs
     */
    quesHelpPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpPrototypePatchAttributes");
        }
        var baseUrl = "/QuesHelps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    quesHelpReplaceByIdPostQuesHelpsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpReplaceByIdPostQuesHelpsidReplace");
        }
        var baseUrl = "/QuesHelps/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    quesHelpReplaceByIdPutQuesHelpsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling quesHelpReplaceByIdPutQuesHelpsid");
        }
        var baseUrl = "/QuesHelps/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate: function (params, options) {
        var baseUrl = "/QuesHelps/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpReplaceOrCreatePutQuesHelps: function (params, options) {
        var baseUrl = "/QuesHelps";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    quesHelpUpdateAll: function (params, options) {
        var baseUrl = "/QuesHelps/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    quesHelpUpsertWithWhere: function (params, options) {
        var baseUrl = "/QuesHelps/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * QuesHelpApi - functional programming interface
 */
export var QuesHelpApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    quesHelpCount: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    quesHelpCreate: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    quesHelpCreateChangeStreamGetQuesHelpsChangeStream: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpCreateChangeStreamGetQuesHelpsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    quesHelpCreateChangeStreamPostQuesHelpsChangeStream: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpCreateChangeStreamPostQuesHelpsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    quesHelpDeleteById: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    quesHelpExistsGetQuesHelpsidExists: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpExistsGetQuesHelpsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    quesHelpExistsHeadQuesHelpsid: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpExistsHeadQuesHelpsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    quesHelpFind: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    quesHelpFindById: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    quesHelpFindOne: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpPatchOrCreate: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation help.
     * @param id QuesHelp id
     * @param refresh
     */
    quesHelpPrototypeGetHelp: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpPrototypeGetHelp(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuesHelp id
     * @param data An object of model property name/value pairs
     */
    quesHelpPrototypePatchAttributes: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    quesHelpReplaceByIdPostQuesHelpsidReplace: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpReplaceByIdPostQuesHelpsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    quesHelpReplaceByIdPutQuesHelpsid: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpReplaceByIdPutQuesHelpsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    quesHelpReplaceOrCreatePutQuesHelps: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpReplaceOrCreatePutQuesHelps(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    quesHelpUpdateAll: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    quesHelpUpsertWithWhere: function (params, options) {
        var fetchArgs = QuesHelpApiFetchParamCreator.quesHelpUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * QuesHelpApi - object-oriented interface
 */
var QuesHelpApi = /** @class */ (function (_super) {
    __extends(QuesHelpApi, _super);
    function QuesHelpApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    QuesHelpApi.prototype.quesHelpCount = function (params, options) {
        return QuesHelpApiFp.quesHelpCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpCreate = function (params, options) {
        return QuesHelpApiFp.quesHelpCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuesHelpApi.prototype.quesHelpCreateChangeStreamGetQuesHelpsChangeStream = function (params, options) {
        return QuesHelpApiFp.quesHelpCreateChangeStreamGetQuesHelpsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuesHelpApi.prototype.quesHelpCreateChangeStreamPostQuesHelpsChangeStream = function (params, options) {
        return QuesHelpApiFp.quesHelpCreateChangeStreamPostQuesHelpsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    QuesHelpApi.prototype.quesHelpDeleteById = function (params, options) {
        return QuesHelpApiFp.quesHelpDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuesHelpApi.prototype.quesHelpExistsGetQuesHelpsidExists = function (params, options) {
        return QuesHelpApiFp.quesHelpExistsGetQuesHelpsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuesHelpApi.prototype.quesHelpExistsHeadQuesHelpsid = function (params, options) {
        return QuesHelpApiFp.quesHelpExistsHeadQuesHelpsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuesHelpApi.prototype.quesHelpFind = function (params, options) {
        return QuesHelpApiFp.quesHelpFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    QuesHelpApi.prototype.quesHelpFindById = function (params, options) {
        return QuesHelpApiFp.quesHelpFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuesHelpApi.prototype.quesHelpFindOne = function (params, options) {
        return QuesHelpApiFp.quesHelpFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpPatchOrCreate = function (params, options) {
        return QuesHelpApiFp.quesHelpPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation help.
     * @param id QuesHelp id
     * @param refresh
     */
    QuesHelpApi.prototype.quesHelpPrototypeGetHelp = function (params, options) {
        return QuesHelpApiFp.quesHelpPrototypeGetHelp(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuesHelp id
     * @param data An object of model property name/value pairs
     */
    QuesHelpApi.prototype.quesHelpPrototypePatchAttributes = function (params, options) {
        return QuesHelpApiFp.quesHelpPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpReplaceByIdPostQuesHelpsidReplace = function (params, options) {
        return QuesHelpApiFp.quesHelpReplaceByIdPostQuesHelpsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpReplaceByIdPutQuesHelpsid = function (params, options) {
        return QuesHelpApiFp.quesHelpReplaceByIdPutQuesHelpsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate = function (params, options) {
        return QuesHelpApiFp.quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuesHelpApi.prototype.quesHelpReplaceOrCreatePutQuesHelps = function (params, options) {
        return QuesHelpApiFp.quesHelpReplaceOrCreatePutQuesHelps(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuesHelpApi.prototype.quesHelpUpdateAll = function (params, options) {
        return QuesHelpApiFp.quesHelpUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuesHelpApi.prototype.quesHelpUpsertWithWhere = function (params, options) {
        return QuesHelpApiFp.quesHelpUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return QuesHelpApi;
}(BaseAPI));
export { QuesHelpApi };
/**
 * QuesHelpApi - factory interface
 */
export var QuesHelpApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        quesHelpCount: function (params, options) {
            return QuesHelpApiFp.quesHelpCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        quesHelpCreate: function (params, options) {
            return QuesHelpApiFp.quesHelpCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        quesHelpCreateChangeStreamGetQuesHelpsChangeStream: function (params, options) {
            return QuesHelpApiFp.quesHelpCreateChangeStreamGetQuesHelpsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        quesHelpCreateChangeStreamPostQuesHelpsChangeStream: function (params, options) {
            return QuesHelpApiFp.quesHelpCreateChangeStreamPostQuesHelpsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        quesHelpDeleteById: function (params, options) {
            return QuesHelpApiFp.quesHelpDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        quesHelpExistsGetQuesHelpsidExists: function (params, options) {
            return QuesHelpApiFp.quesHelpExistsGetQuesHelpsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        quesHelpExistsHeadQuesHelpsid: function (params, options) {
            return QuesHelpApiFp.quesHelpExistsHeadQuesHelpsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        quesHelpFind: function (params, options) {
            return QuesHelpApiFp.quesHelpFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        quesHelpFindById: function (params, options) {
            return QuesHelpApiFp.quesHelpFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        quesHelpFindOne: function (params, options) {
            return QuesHelpApiFp.quesHelpFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        quesHelpPatchOrCreate: function (params, options) {
            return QuesHelpApiFp.quesHelpPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation help.
         * @param id QuesHelp id
         * @param refresh
         */
        quesHelpPrototypeGetHelp: function (params, options) {
            return QuesHelpApiFp.quesHelpPrototypeGetHelp(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id QuesHelp id
         * @param data An object of model property name/value pairs
         */
        quesHelpPrototypePatchAttributes: function (params, options) {
            return QuesHelpApiFp.quesHelpPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        quesHelpReplaceByIdPostQuesHelpsidReplace: function (params, options) {
            return QuesHelpApiFp.quesHelpReplaceByIdPostQuesHelpsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        quesHelpReplaceByIdPutQuesHelpsid: function (params, options) {
            return QuesHelpApiFp.quesHelpReplaceByIdPutQuesHelpsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate: function (params, options) {
            return QuesHelpApiFp.quesHelpReplaceOrCreatePostQuesHelpsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        quesHelpReplaceOrCreatePutQuesHelps: function (params, options) {
            return QuesHelpApiFp.quesHelpReplaceOrCreatePutQuesHelps(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        quesHelpUpdateAll: function (params, options) {
            return QuesHelpApiFp.quesHelpUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        quesHelpUpsertWithWhere: function (params, options) {
            return QuesHelpApiFp.quesHelpUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * QuestionApi - fetch parameter creator
 */
export var QuestionApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionCount: function (params, options) {
        var baseUrl = "/Questions/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionCreate: function (params, options) {
        var baseUrl = "/Questions";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionCreateChangeStreamGetQuestionsChangeStream: function (params, options) {
        var baseUrl = "/Questions/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionCreateChangeStreamPostQuestionsChangeStream: function (params, options) {
        var baseUrl = "/Questions/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionDeleteById");
        }
        var baseUrl = "/Questions/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionExistsGetQuestionsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionExistsGetQuestionsidExists");
        }
        var baseUrl = "/Questions/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionExistsHeadQuestionsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionExistsHeadQuestionsid");
        }
        var baseUrl = "/Questions/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionFind: function (params, options) {
        var baseUrl = "/Questions";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionFindById");
        }
        var baseUrl = "/Questions/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionFindOne: function (params, options) {
        var baseUrl = "/Questions/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionPatchOrCreate: function (params, options) {
        var baseUrl = "/Questions";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts test of Question.
     * @param id Question id
     * @param where Criteria to match model instances
     */
    questionPrototypeCountTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeCountTest");
        }
        var baseUrl = "/Questions/{id}/test/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in key of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeCreateKey: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeCreateKey");
        }
        var baseUrl = "/Questions/{id}/key".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeCreateTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeCreateTest");
        }
        var baseUrl = "/Questions/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Question id
     */
    questionPrototypeDeleteTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeDeleteTest");
        }
        var baseUrl = "/Questions/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeDestroyByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeDestroyByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeDestroyByIdTest");
        }
        var baseUrl = "/Questions/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes key of this model.
     * @param id Question id
     */
    questionPrototypeDestroyKey: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeDestroyKey");
        }
        var baseUrl = "/Questions/{id}/key".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeExistsTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeExistsTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeExistsTest");
        }
        var baseUrl = "/Questions/{id}/test/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeFindByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeFindByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeFindByIdTest");
        }
        var baseUrl = "/Questions/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeGetAccount");
        }
        var baseUrl = "/Questions/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches hasOne relation key.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetKey: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeGetKey");
        }
        var baseUrl = "/Questions/{id}/key".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries test of Question.
     * @param id Question id
     * @param filter
     */
    questionPrototypeGetTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeGetTest");
        }
        var baseUrl = "/Questions/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation type.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetType: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeGetType");
        }
        var baseUrl = "/Questions/{id}/type".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    questionPrototypeLinkTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeLinkTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeLinkTest");
        }
        var baseUrl = "/Questions/{id}/test/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Question id
     * @param data An object of model property name/value pairs
     */
    questionPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypePatchAttributes");
        }
        var baseUrl = "/Questions/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeUnlinkTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeUnlinkTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeUnlinkTest");
        }
        var baseUrl = "/Questions/{id}/test/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    questionPrototypeUpdateByIdTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeUpdateByIdTest");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling questionPrototypeUpdateByIdTest");
        }
        var baseUrl = "/Questions/{id}/test/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update key of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeUpdateKey: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionPrototypeUpdateKey");
        }
        var baseUrl = "/Questions/{id}/key".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionReplaceByIdPostQuestionsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionReplaceByIdPostQuestionsidReplace");
        }
        var baseUrl = "/Questions/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionReplaceByIdPutQuestionsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionReplaceByIdPutQuestionsid");
        }
        var baseUrl = "/Questions/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionReplaceOrCreatePostQuestionsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Questions/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionReplaceOrCreatePutQuestions: function (params, options) {
        var baseUrl = "/Questions";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionUpdateAll: function (params, options) {
        var baseUrl = "/Questions/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionUpsertWithWhere: function (params, options) {
        var baseUrl = "/Questions/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * QuestionApi - functional programming interface
 */
export var QuestionApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionCount: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionCreate: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionCreateChangeStreamGetQuestionsChangeStream: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionCreateChangeStreamGetQuestionsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionCreateChangeStreamPostQuestionsChangeStream: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionCreateChangeStreamPostQuestionsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionDeleteById: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionExistsGetQuestionsidExists: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionExistsGetQuestionsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionExistsHeadQuestionsid: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionExistsHeadQuestionsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionFind: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionFindById: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionFindOne: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionPatchOrCreate: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts test of Question.
     * @param id Question id
     * @param where Criteria to match model instances
     */
    questionPrototypeCountTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeCountTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in key of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeCreateKey: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeCreateKey(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeCreateTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeCreateTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Question id
     */
    questionPrototypeDeleteTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeDeleteTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeDestroyByIdTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeDestroyByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes key of this model.
     * @param id Question id
     */
    questionPrototypeDestroyKey: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeDestroyKey(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeExistsTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeExistsTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeFindByIdTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeFindByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetAccount: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches hasOne relation key.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetKey: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeGetKey(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries test of Question.
     * @param id Question id
     * @param filter
     */
    questionPrototypeGetTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeGetTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation type.
     * @param id Question id
     * @param refresh
     */
    questionPrototypeGetType: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeGetType(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    questionPrototypeLinkTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeLinkTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Question id
     * @param data An object of model property name/value pairs
     */
    questionPrototypePatchAttributes: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    questionPrototypeUnlinkTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeUnlinkTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    questionPrototypeUpdateByIdTest: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeUpdateByIdTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update key of this model.
     * @param id Question id
     * @param data
     */
    questionPrototypeUpdateKey: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionPrototypeUpdateKey(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionReplaceByIdPostQuestionsidReplace: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionReplaceByIdPostQuestionsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionReplaceByIdPutQuestionsid: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionReplaceByIdPutQuestionsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionReplaceOrCreatePostQuestionsReplaceOrCreate: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionReplaceOrCreatePostQuestionsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionReplaceOrCreatePutQuestions: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionReplaceOrCreatePutQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionUpdateAll: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionUpsertWithWhere: function (params, options) {
        var fetchArgs = QuestionApiFetchParamCreator.questionUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * QuestionApi - object-oriented interface
 */
var QuestionApi = /** @class */ (function (_super) {
    __extends(QuestionApi, _super);
    function QuestionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    QuestionApi.prototype.questionCount = function (params, options) {
        return QuestionApiFp.questionCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    QuestionApi.prototype.questionCreate = function (params, options) {
        return QuestionApiFp.questionCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionApi.prototype.questionCreateChangeStreamGetQuestionsChangeStream = function (params, options) {
        return QuestionApiFp.questionCreateChangeStreamGetQuestionsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionApi.prototype.questionCreateChangeStreamPostQuestionsChangeStream = function (params, options) {
        return QuestionApiFp.questionCreateChangeStreamPostQuestionsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    QuestionApi.prototype.questionDeleteById = function (params, options) {
        return QuestionApiFp.questionDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionApi.prototype.questionExistsGetQuestionsidExists = function (params, options) {
        return QuestionApiFp.questionExistsGetQuestionsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionApi.prototype.questionExistsHeadQuestionsid = function (params, options) {
        return QuestionApiFp.questionExistsHeadQuestionsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionApi.prototype.questionFind = function (params, options) {
        return QuestionApiFp.questionFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    QuestionApi.prototype.questionFindById = function (params, options) {
        return QuestionApiFp.questionFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionApi.prototype.questionFindOne = function (params, options) {
        return QuestionApiFp.questionFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionApi.prototype.questionPatchOrCreate = function (params, options) {
        return QuestionApiFp.questionPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts test of Question.
     * @param id Question id
     * @param where Criteria to match model instances
     */
    QuestionApi.prototype.questionPrototypeCountTest = function (params, options) {
        return QuestionApiFp.questionPrototypeCountTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in key of this model.
     * @param id Question id
     * @param data
     */
    QuestionApi.prototype.questionPrototypeCreateKey = function (params, options) {
        return QuestionApiFp.questionPrototypeCreateKey(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in test of this model.
     * @param id Question id
     * @param data
     */
    QuestionApi.prototype.questionPrototypeCreateTest = function (params, options) {
        return QuestionApiFp.questionPrototypeCreateTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all test of this model.
     * @param id Question id
     */
    QuestionApi.prototype.questionPrototypeDeleteTest = function (params, options) {
        return QuestionApiFp.questionPrototypeDeleteTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    QuestionApi.prototype.questionPrototypeDestroyByIdTest = function (params, options) {
        return QuestionApiFp.questionPrototypeDestroyByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes key of this model.
     * @param id Question id
     */
    QuestionApi.prototype.questionPrototypeDestroyKey = function (params, options) {
        return QuestionApiFp.questionPrototypeDestroyKey(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    QuestionApi.prototype.questionPrototypeExistsTest = function (params, options) {
        return QuestionApiFp.questionPrototypeExistsTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     */
    QuestionApi.prototype.questionPrototypeFindByIdTest = function (params, options) {
        return QuestionApiFp.questionPrototypeFindByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Question id
     * @param refresh
     */
    QuestionApi.prototype.questionPrototypeGetAccount = function (params, options) {
        return QuestionApiFp.questionPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches hasOne relation key.
     * @param id Question id
     * @param refresh
     */
    QuestionApi.prototype.questionPrototypeGetKey = function (params, options) {
        return QuestionApiFp.questionPrototypeGetKey(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries test of Question.
     * @param id Question id
     * @param filter
     */
    QuestionApi.prototype.questionPrototypeGetTest = function (params, options) {
        return QuestionApiFp.questionPrototypeGetTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation type.
     * @param id Question id
     * @param refresh
     */
    QuestionApi.prototype.questionPrototypeGetType = function (params, options) {
        return QuestionApiFp.questionPrototypeGetType(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    QuestionApi.prototype.questionPrototypeLinkTest = function (params, options) {
        return QuestionApiFp.questionPrototypeLinkTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Question id
     * @param data An object of model property name/value pairs
     */
    QuestionApi.prototype.questionPrototypePatchAttributes = function (params, options) {
        return QuestionApiFp.questionPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the test relation to an item by id.
     * @param id Question id
     * @param fk Foreign key for test
     */
    QuestionApi.prototype.questionPrototypeUnlinkTest = function (params, options) {
        return QuestionApiFp.questionPrototypeUnlinkTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for test.
     * @param id Question id
     * @param fk Foreign key for test
     * @param data
     */
    QuestionApi.prototype.questionPrototypeUpdateByIdTest = function (params, options) {
        return QuestionApiFp.questionPrototypeUpdateByIdTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update key of this model.
     * @param id Question id
     * @param data
     */
    QuestionApi.prototype.questionPrototypeUpdateKey = function (params, options) {
        return QuestionApiFp.questionPrototypeUpdateKey(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionApi.prototype.questionReplaceByIdPostQuestionsidReplace = function (params, options) {
        return QuestionApiFp.questionReplaceByIdPostQuestionsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionApi.prototype.questionReplaceByIdPutQuestionsid = function (params, options) {
        return QuestionApiFp.questionReplaceByIdPutQuestionsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionApi.prototype.questionReplaceOrCreatePostQuestionsReplaceOrCreate = function (params, options) {
        return QuestionApiFp.questionReplaceOrCreatePostQuestionsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionApi.prototype.questionReplaceOrCreatePutQuestions = function (params, options) {
        return QuestionApiFp.questionReplaceOrCreatePutQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionApi.prototype.questionUpdateAll = function (params, options) {
        return QuestionApiFp.questionUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionApi.prototype.questionUpsertWithWhere = function (params, options) {
        return QuestionApiFp.questionUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return QuestionApi;
}(BaseAPI));
export { QuestionApi };
/**
 * QuestionApi - factory interface
 */
export var QuestionApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        questionCount: function (params, options) {
            return QuestionApiFp.questionCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        questionCreate: function (params, options) {
            return QuestionApiFp.questionCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionCreateChangeStreamGetQuestionsChangeStream: function (params, options) {
            return QuestionApiFp.questionCreateChangeStreamGetQuestionsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionCreateChangeStreamPostQuestionsChangeStream: function (params, options) {
            return QuestionApiFp.questionCreateChangeStreamPostQuestionsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        questionDeleteById: function (params, options) {
            return QuestionApiFp.questionDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionExistsGetQuestionsidExists: function (params, options) {
            return QuestionApiFp.questionExistsGetQuestionsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionExistsHeadQuestionsid: function (params, options) {
            return QuestionApiFp.questionExistsHeadQuestionsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionFind: function (params, options) {
            return QuestionApiFp.questionFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        questionFindById: function (params, options) {
            return QuestionApiFp.questionFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionFindOne: function (params, options) {
            return QuestionApiFp.questionFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionPatchOrCreate: function (params, options) {
            return QuestionApiFp.questionPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts test of Question.
         * @param id Question id
         * @param where Criteria to match model instances
         */
        questionPrototypeCountTest: function (params, options) {
            return QuestionApiFp.questionPrototypeCountTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in key of this model.
         * @param id Question id
         * @param data
         */
        questionPrototypeCreateKey: function (params, options) {
            return QuestionApiFp.questionPrototypeCreateKey(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in test of this model.
         * @param id Question id
         * @param data
         */
        questionPrototypeCreateTest: function (params, options) {
            return QuestionApiFp.questionPrototypeCreateTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all test of this model.
         * @param id Question id
         */
        questionPrototypeDeleteTest: function (params, options) {
            return QuestionApiFp.questionPrototypeDeleteTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for test.
         * @param id Question id
         * @param fk Foreign key for test
         */
        questionPrototypeDestroyByIdTest: function (params, options) {
            return QuestionApiFp.questionPrototypeDestroyByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes key of this model.
         * @param id Question id
         */
        questionPrototypeDestroyKey: function (params, options) {
            return QuestionApiFp.questionPrototypeDestroyKey(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of test relation to an item by id.
         * @param id Question id
         * @param fk Foreign key for test
         */
        questionPrototypeExistsTest: function (params, options) {
            return QuestionApiFp.questionPrototypeExistsTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for test.
         * @param id Question id
         * @param fk Foreign key for test
         */
        questionPrototypeFindByIdTest: function (params, options) {
            return QuestionApiFp.questionPrototypeFindByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Question id
         * @param refresh
         */
        questionPrototypeGetAccount: function (params, options) {
            return QuestionApiFp.questionPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches hasOne relation key.
         * @param id Question id
         * @param refresh
         */
        questionPrototypeGetKey: function (params, options) {
            return QuestionApiFp.questionPrototypeGetKey(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries test of Question.
         * @param id Question id
         * @param filter
         */
        questionPrototypeGetTest: function (params, options) {
            return QuestionApiFp.questionPrototypeGetTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation type.
         * @param id Question id
         * @param refresh
         */
        questionPrototypeGetType: function (params, options) {
            return QuestionApiFp.questionPrototypeGetType(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for test.
         * @param id Question id
         * @param fk Foreign key for test
         * @param data
         */
        questionPrototypeLinkTest: function (params, options) {
            return QuestionApiFp.questionPrototypeLinkTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Question id
         * @param data An object of model property name/value pairs
         */
        questionPrototypePatchAttributes: function (params, options) {
            return QuestionApiFp.questionPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the test relation to an item by id.
         * @param id Question id
         * @param fk Foreign key for test
         */
        questionPrototypeUnlinkTest: function (params, options) {
            return QuestionApiFp.questionPrototypeUnlinkTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for test.
         * @param id Question id
         * @param fk Foreign key for test
         * @param data
         */
        questionPrototypeUpdateByIdTest: function (params, options) {
            return QuestionApiFp.questionPrototypeUpdateByIdTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update key of this model.
         * @param id Question id
         * @param data
         */
        questionPrototypeUpdateKey: function (params, options) {
            return QuestionApiFp.questionPrototypeUpdateKey(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionReplaceByIdPostQuestionsidReplace: function (params, options) {
            return QuestionApiFp.questionReplaceByIdPostQuestionsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionReplaceByIdPutQuestionsid: function (params, options) {
            return QuestionApiFp.questionReplaceByIdPutQuestionsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionReplaceOrCreatePostQuestionsReplaceOrCreate: function (params, options) {
            return QuestionApiFp.questionReplaceOrCreatePostQuestionsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionReplaceOrCreatePutQuestions: function (params, options) {
            return QuestionApiFp.questionReplaceOrCreatePutQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionUpdateAll: function (params, options) {
            return QuestionApiFp.questionUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionUpsertWithWhere: function (params, options) {
            return QuestionApiFp.questionUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * QuestionTestApi - fetch parameter creator
 */
export var QuestionTestApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionTestCount: function (params, options) {
        var baseUrl = "/QuestionTests/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionTestCreate: function (params, options) {
        var baseUrl = "/QuestionTests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTestCreateChangeStreamGetQuestionTestsChangeStream: function (params, options) {
        var baseUrl = "/QuestionTests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTestCreateChangeStreamPostQuestionTestsChangeStream: function (params, options) {
        var baseUrl = "/QuestionTests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionTestDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestDeleteById");
        }
        var baseUrl = "/QuestionTests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTestExistsGetQuestionTestsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestExistsGetQuestionTestsidExists");
        }
        var baseUrl = "/QuestionTests/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTestExistsHeadQuestionTestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestExistsHeadQuestionTestsid");
        }
        var baseUrl = "/QuestionTests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTestFind: function (params, options) {
        var baseUrl = "/QuestionTests";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionTestFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestFindById");
        }
        var baseUrl = "/QuestionTests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTestFindOne: function (params, options) {
        var baseUrl = "/QuestionTests/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestPatchOrCreate: function (params, options) {
        var baseUrl = "/QuestionTests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id QuestionTest id
     * @param refresh
     */
    questionTestPrototypeGetQuestion: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestPrototypeGetQuestion");
        }
        var baseUrl = "/QuestionTests/{id}/question".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id QuestionTest id
     * @param refresh
     */
    questionTestPrototypeGetTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestPrototypeGetTest");
        }
        var baseUrl = "/QuestionTests/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionTest id
     * @param data An object of model property name/value pairs
     */
    questionTestPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestPrototypePatchAttributes");
        }
        var baseUrl = "/QuestionTests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTestReplaceByIdPostQuestionTestsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestReplaceByIdPostQuestionTestsidReplace");
        }
        var baseUrl = "/QuestionTests/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTestReplaceByIdPutQuestionTestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTestReplaceByIdPutQuestionTestsid");
        }
        var baseUrl = "/QuestionTests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate: function (params, options) {
        var baseUrl = "/QuestionTests/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestReplaceOrCreatePutQuestionTests: function (params, options) {
        var baseUrl = "/QuestionTests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTestUpdateAll: function (params, options) {
        var baseUrl = "/QuestionTests/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTestUpsertWithWhere: function (params, options) {
        var baseUrl = "/QuestionTests/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * QuestionTestApi - functional programming interface
 */
export var QuestionTestApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionTestCount: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionTestCreate: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTestCreateChangeStreamGetQuestionTestsChangeStream: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestCreateChangeStreamGetQuestionTestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTestCreateChangeStreamPostQuestionTestsChangeStream: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestCreateChangeStreamPostQuestionTestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionTestDeleteById: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTestExistsGetQuestionTestsidExists: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestExistsGetQuestionTestsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTestExistsHeadQuestionTestsid: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestExistsHeadQuestionTestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTestFind: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionTestFindById: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTestFindOne: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestPatchOrCreate: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id QuestionTest id
     * @param refresh
     */
    questionTestPrototypeGetQuestion: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestPrototypeGetQuestion(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id QuestionTest id
     * @param refresh
     */
    questionTestPrototypeGetTest: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestPrototypeGetTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionTest id
     * @param data An object of model property name/value pairs
     */
    questionTestPrototypePatchAttributes: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTestReplaceByIdPostQuestionTestsidReplace: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestReplaceByIdPostQuestionTestsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTestReplaceByIdPutQuestionTestsid: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestReplaceByIdPutQuestionTestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTestReplaceOrCreatePutQuestionTests: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestReplaceOrCreatePutQuestionTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTestUpdateAll: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTestUpsertWithWhere: function (params, options) {
        var fetchArgs = QuestionTestApiFetchParamCreator.questionTestUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * QuestionTestApi - object-oriented interface
 */
var QuestionTestApi = /** @class */ (function (_super) {
    __extends(QuestionTestApi, _super);
    function QuestionTestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    QuestionTestApi.prototype.questionTestCount = function (params, options) {
        return QuestionTestApiFp.questionTestCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestCreate = function (params, options) {
        return QuestionTestApiFp.questionTestCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionTestApi.prototype.questionTestCreateChangeStreamGetQuestionTestsChangeStream = function (params, options) {
        return QuestionTestApiFp.questionTestCreateChangeStreamGetQuestionTestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionTestApi.prototype.questionTestCreateChangeStreamPostQuestionTestsChangeStream = function (params, options) {
        return QuestionTestApiFp.questionTestCreateChangeStreamPostQuestionTestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    QuestionTestApi.prototype.questionTestDeleteById = function (params, options) {
        return QuestionTestApiFp.questionTestDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionTestApi.prototype.questionTestExistsGetQuestionTestsidExists = function (params, options) {
        return QuestionTestApiFp.questionTestExistsGetQuestionTestsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionTestApi.prototype.questionTestExistsHeadQuestionTestsid = function (params, options) {
        return QuestionTestApiFp.questionTestExistsHeadQuestionTestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionTestApi.prototype.questionTestFind = function (params, options) {
        return QuestionTestApiFp.questionTestFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    QuestionTestApi.prototype.questionTestFindById = function (params, options) {
        return QuestionTestApiFp.questionTestFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionTestApi.prototype.questionTestFindOne = function (params, options) {
        return QuestionTestApiFp.questionTestFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestPatchOrCreate = function (params, options) {
        return QuestionTestApiFp.questionTestPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation question.
     * @param id QuestionTest id
     * @param refresh
     */
    QuestionTestApi.prototype.questionTestPrototypeGetQuestion = function (params, options) {
        return QuestionTestApiFp.questionTestPrototypeGetQuestion(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id QuestionTest id
     * @param refresh
     */
    QuestionTestApi.prototype.questionTestPrototypeGetTest = function (params, options) {
        return QuestionTestApiFp.questionTestPrototypeGetTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionTest id
     * @param data An object of model property name/value pairs
     */
    QuestionTestApi.prototype.questionTestPrototypePatchAttributes = function (params, options) {
        return QuestionTestApiFp.questionTestPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestReplaceByIdPostQuestionTestsidReplace = function (params, options) {
        return QuestionTestApiFp.questionTestReplaceByIdPostQuestionTestsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestReplaceByIdPutQuestionTestsid = function (params, options) {
        return QuestionTestApiFp.questionTestReplaceByIdPutQuestionTestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate = function (params, options) {
        return QuestionTestApiFp.questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTestApi.prototype.questionTestReplaceOrCreatePutQuestionTests = function (params, options) {
        return QuestionTestApiFp.questionTestReplaceOrCreatePutQuestionTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionTestApi.prototype.questionTestUpdateAll = function (params, options) {
        return QuestionTestApiFp.questionTestUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionTestApi.prototype.questionTestUpsertWithWhere = function (params, options) {
        return QuestionTestApiFp.questionTestUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return QuestionTestApi;
}(BaseAPI));
export { QuestionTestApi };
/**
 * QuestionTestApi - factory interface
 */
export var QuestionTestApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        questionTestCount: function (params, options) {
            return QuestionTestApiFp.questionTestCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        questionTestCreate: function (params, options) {
            return QuestionTestApiFp.questionTestCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionTestCreateChangeStreamGetQuestionTestsChangeStream: function (params, options) {
            return QuestionTestApiFp.questionTestCreateChangeStreamGetQuestionTestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionTestCreateChangeStreamPostQuestionTestsChangeStream: function (params, options) {
            return QuestionTestApiFp.questionTestCreateChangeStreamPostQuestionTestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        questionTestDeleteById: function (params, options) {
            return QuestionTestApiFp.questionTestDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionTestExistsGetQuestionTestsidExists: function (params, options) {
            return QuestionTestApiFp.questionTestExistsGetQuestionTestsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionTestExistsHeadQuestionTestsid: function (params, options) {
            return QuestionTestApiFp.questionTestExistsHeadQuestionTestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionTestFind: function (params, options) {
            return QuestionTestApiFp.questionTestFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        questionTestFindById: function (params, options) {
            return QuestionTestApiFp.questionTestFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionTestFindOne: function (params, options) {
            return QuestionTestApiFp.questionTestFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTestPatchOrCreate: function (params, options) {
            return QuestionTestApiFp.questionTestPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation question.
         * @param id QuestionTest id
         * @param refresh
         */
        questionTestPrototypeGetQuestion: function (params, options) {
            return QuestionTestApiFp.questionTestPrototypeGetQuestion(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation test.
         * @param id QuestionTest id
         * @param refresh
         */
        questionTestPrototypeGetTest: function (params, options) {
            return QuestionTestApiFp.questionTestPrototypeGetTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id QuestionTest id
         * @param data An object of model property name/value pairs
         */
        questionTestPrototypePatchAttributes: function (params, options) {
            return QuestionTestApiFp.questionTestPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionTestReplaceByIdPostQuestionTestsidReplace: function (params, options) {
            return QuestionTestApiFp.questionTestReplaceByIdPostQuestionTestsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionTestReplaceByIdPutQuestionTestsid: function (params, options) {
            return QuestionTestApiFp.questionTestReplaceByIdPutQuestionTestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate: function (params, options) {
            return QuestionTestApiFp.questionTestReplaceOrCreatePostQuestionTestsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTestReplaceOrCreatePutQuestionTests: function (params, options) {
            return QuestionTestApiFp.questionTestReplaceOrCreatePutQuestionTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionTestUpdateAll: function (params, options) {
            return QuestionTestApiFp.questionTestUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionTestUpsertWithWhere: function (params, options) {
            return QuestionTestApiFp.questionTestUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * QuestionTypeApi - fetch parameter creator
 */
export var QuestionTypeApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionTypeCount: function (params, options) {
        var baseUrl = "/QuestionTypes/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionTypeCreate: function (params, options) {
        var baseUrl = "/QuestionTypes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTypeCreateChangeStreamGetQuestionTypesChangeStream: function (params, options) {
        var baseUrl = "/QuestionTypes/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTypeCreateChangeStreamPostQuestionTypesChangeStream: function (params, options) {
        var baseUrl = "/QuestionTypes/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionTypeDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeDeleteById");
        }
        var baseUrl = "/QuestionTypes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTypeExistsGetQuestionTypesidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeExistsGetQuestionTypesidExists");
        }
        var baseUrl = "/QuestionTypes/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTypeExistsHeadQuestionTypesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeExistsHeadQuestionTypesid");
        }
        var baseUrl = "/QuestionTypes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTypeFind: function (params, options) {
        var baseUrl = "/QuestionTypes";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionTypeFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeFindById");
        }
        var baseUrl = "/QuestionTypes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTypeFindOne: function (params, options) {
        var baseUrl = "/QuestionTypes/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypePatchOrCreate: function (params, options) {
        var baseUrl = "/QuestionTypes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id QuestionType id
     * @param refresh
     */
    questionTypePrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypePrototypeGetAccount");
        }
        var baseUrl = "/QuestionTypes/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionType id
     * @param data An object of model property name/value pairs
     */
    questionTypePrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypePrototypePatchAttributes");
        }
        var baseUrl = "/QuestionTypes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTypeReplaceByIdPostQuestionTypesidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeReplaceByIdPostQuestionTypesidReplace");
        }
        var baseUrl = "/QuestionTypes/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTypeReplaceByIdPutQuestionTypesid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling questionTypeReplaceByIdPutQuestionTypesid");
        }
        var baseUrl = "/QuestionTypes/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate: function (params, options) {
        var baseUrl = "/QuestionTypes/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypeReplaceOrCreatePutQuestionTypes: function (params, options) {
        var baseUrl = "/QuestionTypes";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTypeUpdateAll: function (params, options) {
        var baseUrl = "/QuestionTypes/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTypeUpsertWithWhere: function (params, options) {
        var baseUrl = "/QuestionTypes/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * QuestionTypeApi - functional programming interface
 */
export var QuestionTypeApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    questionTypeCount: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    questionTypeCreate: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTypeCreateChangeStreamGetQuestionTypesChangeStream: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeCreateChangeStreamGetQuestionTypesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    questionTypeCreateChangeStreamPostQuestionTypesChangeStream: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeCreateChangeStreamPostQuestionTypesChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    questionTypeDeleteById: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTypeExistsGetQuestionTypesidExists: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeExistsGetQuestionTypesidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    questionTypeExistsHeadQuestionTypesid: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeExistsHeadQuestionTypesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTypeFind: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    questionTypeFindById: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    questionTypeFindOne: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypePatchOrCreate: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypePatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id QuestionType id
     * @param refresh
     */
    questionTypePrototypeGetAccount: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypePrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionType id
     * @param data An object of model property name/value pairs
     */
    questionTypePrototypePatchAttributes: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypePrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTypeReplaceByIdPostQuestionTypesidReplace: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeReplaceByIdPostQuestionTypesidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    questionTypeReplaceByIdPutQuestionTypesid: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeReplaceByIdPutQuestionTypesid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    questionTypeReplaceOrCreatePutQuestionTypes: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeReplaceOrCreatePutQuestionTypes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTypeUpdateAll: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    questionTypeUpsertWithWhere: function (params, options) {
        var fetchArgs = QuestionTypeApiFetchParamCreator.questionTypeUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * QuestionTypeApi - object-oriented interface
 */
var QuestionTypeApi = /** @class */ (function (_super) {
    __extends(QuestionTypeApi, _super);
    function QuestionTypeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    QuestionTypeApi.prototype.questionTypeCount = function (params, options) {
        return QuestionTypeApiFp.questionTypeCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypeCreate = function (params, options) {
        return QuestionTypeApiFp.questionTypeCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionTypeApi.prototype.questionTypeCreateChangeStreamGetQuestionTypesChangeStream = function (params, options) {
        return QuestionTypeApiFp.questionTypeCreateChangeStreamGetQuestionTypesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    QuestionTypeApi.prototype.questionTypeCreateChangeStreamPostQuestionTypesChangeStream = function (params, options) {
        return QuestionTypeApiFp.questionTypeCreateChangeStreamPostQuestionTypesChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    QuestionTypeApi.prototype.questionTypeDeleteById = function (params, options) {
        return QuestionTypeApiFp.questionTypeDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionTypeApi.prototype.questionTypeExistsGetQuestionTypesidExists = function (params, options) {
        return QuestionTypeApiFp.questionTypeExistsGetQuestionTypesidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    QuestionTypeApi.prototype.questionTypeExistsHeadQuestionTypesid = function (params, options) {
        return QuestionTypeApiFp.questionTypeExistsHeadQuestionTypesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionTypeApi.prototype.questionTypeFind = function (params, options) {
        return QuestionTypeApiFp.questionTypeFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    QuestionTypeApi.prototype.questionTypeFindById = function (params, options) {
        return QuestionTypeApiFp.questionTypeFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    QuestionTypeApi.prototype.questionTypeFindOne = function (params, options) {
        return QuestionTypeApiFp.questionTypeFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypePatchOrCreate = function (params, options) {
        return QuestionTypeApiFp.questionTypePatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id QuestionType id
     * @param refresh
     */
    QuestionTypeApi.prototype.questionTypePrototypeGetAccount = function (params, options) {
        return QuestionTypeApiFp.questionTypePrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id QuestionType id
     * @param data An object of model property name/value pairs
     */
    QuestionTypeApi.prototype.questionTypePrototypePatchAttributes = function (params, options) {
        return QuestionTypeApiFp.questionTypePrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypeReplaceByIdPostQuestionTypesidReplace = function (params, options) {
        return QuestionTypeApiFp.questionTypeReplaceByIdPostQuestionTypesidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypeReplaceByIdPutQuestionTypesid = function (params, options) {
        return QuestionTypeApiFp.questionTypeReplaceByIdPutQuestionTypesid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate = function (params, options) {
        return QuestionTypeApiFp.questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    QuestionTypeApi.prototype.questionTypeReplaceOrCreatePutQuestionTypes = function (params, options) {
        return QuestionTypeApiFp.questionTypeReplaceOrCreatePutQuestionTypes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionTypeApi.prototype.questionTypeUpdateAll = function (params, options) {
        return QuestionTypeApiFp.questionTypeUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    QuestionTypeApi.prototype.questionTypeUpsertWithWhere = function (params, options) {
        return QuestionTypeApiFp.questionTypeUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return QuestionTypeApi;
}(BaseAPI));
export { QuestionTypeApi };
/**
 * QuestionTypeApi - factory interface
 */
export var QuestionTypeApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        questionTypeCount: function (params, options) {
            return QuestionTypeApiFp.questionTypeCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        questionTypeCreate: function (params, options) {
            return QuestionTypeApiFp.questionTypeCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionTypeCreateChangeStreamGetQuestionTypesChangeStream: function (params, options) {
            return QuestionTypeApiFp.questionTypeCreateChangeStreamGetQuestionTypesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        questionTypeCreateChangeStreamPostQuestionTypesChangeStream: function (params, options) {
            return QuestionTypeApiFp.questionTypeCreateChangeStreamPostQuestionTypesChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        questionTypeDeleteById: function (params, options) {
            return QuestionTypeApiFp.questionTypeDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionTypeExistsGetQuestionTypesidExists: function (params, options) {
            return QuestionTypeApiFp.questionTypeExistsGetQuestionTypesidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        questionTypeExistsHeadQuestionTypesid: function (params, options) {
            return QuestionTypeApiFp.questionTypeExistsHeadQuestionTypesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionTypeFind: function (params, options) {
            return QuestionTypeApiFp.questionTypeFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        questionTypeFindById: function (params, options) {
            return QuestionTypeApiFp.questionTypeFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        questionTypeFindOne: function (params, options) {
            return QuestionTypeApiFp.questionTypeFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTypePatchOrCreate: function (params, options) {
            return QuestionTypeApiFp.questionTypePatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id QuestionType id
         * @param refresh
         */
        questionTypePrototypeGetAccount: function (params, options) {
            return QuestionTypeApiFp.questionTypePrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id QuestionType id
         * @param data An object of model property name/value pairs
         */
        questionTypePrototypePatchAttributes: function (params, options) {
            return QuestionTypeApiFp.questionTypePrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionTypeReplaceByIdPostQuestionTypesidReplace: function (params, options) {
            return QuestionTypeApiFp.questionTypeReplaceByIdPostQuestionTypesidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        questionTypeReplaceByIdPutQuestionTypesid: function (params, options) {
            return QuestionTypeApiFp.questionTypeReplaceByIdPutQuestionTypesid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate: function (params, options) {
            return QuestionTypeApiFp.questionTypeReplaceOrCreatePostQuestionTypesReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        questionTypeReplaceOrCreatePutQuestionTypes: function (params, options) {
            return QuestionTypeApiFp.questionTypeReplaceOrCreatePutQuestionTypes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionTypeUpdateAll: function (params, options) {
            return QuestionTypeApiFp.questionTypeUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        questionTypeUpsertWithWhere: function (params, options) {
            return QuestionTypeApiFp.questionTypeUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * RanksApi - fetch parameter creator
 */
export var RanksApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ranksCount: function (params, options) {
        var baseUrl = "/Ranks/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ranksCreate: function (params, options) {
        var baseUrl = "/Ranks";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ranksCreateChangeStreamGetRanksChangeStream: function (params, options) {
        var baseUrl = "/Ranks/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ranksCreateChangeStreamPostRanksChangeStream: function (params, options) {
        var baseUrl = "/Ranks/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ranksDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksDeleteById");
        }
        var baseUrl = "/Ranks/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ranksExistsGetRanksidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksExistsGetRanksidExists");
        }
        var baseUrl = "/Ranks/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ranksExistsHeadRanksid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksExistsHeadRanksid");
        }
        var baseUrl = "/Ranks/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ranksFind: function (params, options) {
        var baseUrl = "/Ranks";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ranksFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksFindById");
        }
        var baseUrl = "/Ranks/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ranksFindOne: function (params, options) {
        var baseUrl = "/Ranks/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksPatchOrCreate: function (params, options) {
        var baseUrl = "/Ranks";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Ranks id
     * @param data An object of model property name/value pairs
     */
    ranksPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksPrototypePatchAttributes");
        }
        var baseUrl = "/Ranks/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ranksReplaceByIdPostRanksidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksReplaceByIdPostRanksidReplace");
        }
        var baseUrl = "/Ranks/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ranksReplaceByIdPutRanksid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling ranksReplaceByIdPutRanksid");
        }
        var baseUrl = "/Ranks/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksReplaceOrCreatePostRanksReplaceOrCreate: function (params, options) {
        var baseUrl = "/Ranks/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksReplaceOrCreatePutRanks: function (params, options) {
        var baseUrl = "/Ranks";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ranksUpdateAll: function (params, options) {
        var baseUrl = "/Ranks/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ranksUpsertWithWhere: function (params, options) {
        var baseUrl = "/Ranks/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * RanksApi - functional programming interface
 */
export var RanksApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ranksCount: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ranksCreate: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ranksCreateChangeStreamGetRanksChangeStream: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksCreateChangeStreamGetRanksChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ranksCreateChangeStreamPostRanksChangeStream: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksCreateChangeStreamPostRanksChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ranksDeleteById: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ranksExistsGetRanksidExists: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksExistsGetRanksidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ranksExistsHeadRanksid: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksExistsHeadRanksid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ranksFind: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ranksFindById: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ranksFindOne: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksPatchOrCreate: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Ranks id
     * @param data An object of model property name/value pairs
     */
    ranksPrototypePatchAttributes: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ranksReplaceByIdPostRanksidReplace: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksReplaceByIdPostRanksidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ranksReplaceByIdPutRanksid: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksReplaceByIdPutRanksid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksReplaceOrCreatePostRanksReplaceOrCreate: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksReplaceOrCreatePostRanksReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ranksReplaceOrCreatePutRanks: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksReplaceOrCreatePutRanks(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ranksUpdateAll: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ranksUpsertWithWhere: function (params, options) {
        var fetchArgs = RanksApiFetchParamCreator.ranksUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * RanksApi - object-oriented interface
 */
var RanksApi = /** @class */ (function (_super) {
    __extends(RanksApi, _super);
    function RanksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    RanksApi.prototype.ranksCount = function (params, options) {
        return RanksApiFp.ranksCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    RanksApi.prototype.ranksCreate = function (params, options) {
        return RanksApiFp.ranksCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    RanksApi.prototype.ranksCreateChangeStreamGetRanksChangeStream = function (params, options) {
        return RanksApiFp.ranksCreateChangeStreamGetRanksChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    RanksApi.prototype.ranksCreateChangeStreamPostRanksChangeStream = function (params, options) {
        return RanksApiFp.ranksCreateChangeStreamPostRanksChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    RanksApi.prototype.ranksDeleteById = function (params, options) {
        return RanksApiFp.ranksDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    RanksApi.prototype.ranksExistsGetRanksidExists = function (params, options) {
        return RanksApiFp.ranksExistsGetRanksidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    RanksApi.prototype.ranksExistsHeadRanksid = function (params, options) {
        return RanksApiFp.ranksExistsHeadRanksid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    RanksApi.prototype.ranksFind = function (params, options) {
        return RanksApiFp.ranksFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    RanksApi.prototype.ranksFindById = function (params, options) {
        return RanksApiFp.ranksFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    RanksApi.prototype.ranksFindOne = function (params, options) {
        return RanksApiFp.ranksFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RanksApi.prototype.ranksPatchOrCreate = function (params, options) {
        return RanksApiFp.ranksPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Ranks id
     * @param data An object of model property name/value pairs
     */
    RanksApi.prototype.ranksPrototypePatchAttributes = function (params, options) {
        return RanksApiFp.ranksPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    RanksApi.prototype.ranksReplaceByIdPostRanksidReplace = function (params, options) {
        return RanksApiFp.ranksReplaceByIdPostRanksidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    RanksApi.prototype.ranksReplaceByIdPutRanksid = function (params, options) {
        return RanksApiFp.ranksReplaceByIdPutRanksid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RanksApi.prototype.ranksReplaceOrCreatePostRanksReplaceOrCreate = function (params, options) {
        return RanksApiFp.ranksReplaceOrCreatePostRanksReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RanksApi.prototype.ranksReplaceOrCreatePutRanks = function (params, options) {
        return RanksApiFp.ranksReplaceOrCreatePutRanks(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    RanksApi.prototype.ranksUpdateAll = function (params, options) {
        return RanksApiFp.ranksUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    RanksApi.prototype.ranksUpsertWithWhere = function (params, options) {
        return RanksApiFp.ranksUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return RanksApi;
}(BaseAPI));
export { RanksApi };
/**
 * RanksApi - factory interface
 */
export var RanksApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        ranksCount: function (params, options) {
            return RanksApiFp.ranksCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        ranksCreate: function (params, options) {
            return RanksApiFp.ranksCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        ranksCreateChangeStreamGetRanksChangeStream: function (params, options) {
            return RanksApiFp.ranksCreateChangeStreamGetRanksChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        ranksCreateChangeStreamPostRanksChangeStream: function (params, options) {
            return RanksApiFp.ranksCreateChangeStreamPostRanksChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        ranksDeleteById: function (params, options) {
            return RanksApiFp.ranksDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        ranksExistsGetRanksidExists: function (params, options) {
            return RanksApiFp.ranksExistsGetRanksidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        ranksExistsHeadRanksid: function (params, options) {
            return RanksApiFp.ranksExistsHeadRanksid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        ranksFind: function (params, options) {
            return RanksApiFp.ranksFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        ranksFindById: function (params, options) {
            return RanksApiFp.ranksFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        ranksFindOne: function (params, options) {
            return RanksApiFp.ranksFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        ranksPatchOrCreate: function (params, options) {
            return RanksApiFp.ranksPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Ranks id
         * @param data An object of model property name/value pairs
         */
        ranksPrototypePatchAttributes: function (params, options) {
            return RanksApiFp.ranksPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        ranksReplaceByIdPostRanksidReplace: function (params, options) {
            return RanksApiFp.ranksReplaceByIdPostRanksidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        ranksReplaceByIdPutRanksid: function (params, options) {
            return RanksApiFp.ranksReplaceByIdPutRanksid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        ranksReplaceOrCreatePostRanksReplaceOrCreate: function (params, options) {
            return RanksApiFp.ranksReplaceOrCreatePostRanksReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        ranksReplaceOrCreatePutRanks: function (params, options) {
            return RanksApiFp.ranksReplaceOrCreatePutRanks(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        ranksUpdateAll: function (params, options) {
            return RanksApiFp.ranksUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        ranksUpsertWithWhere: function (params, options) {
            return RanksApiFp.ranksUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * ResultApi - fetch parameter creator
 */
export var ResultApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    resultCount: function (params, options) {
        var baseUrl = "/Results/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    resultCreate: function (params, options) {
        var baseUrl = "/Results";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    resultCreateChangeStreamGetResultsChangeStream: function (params, options) {
        var baseUrl = "/Results/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    resultCreateChangeStreamPostResultsChangeStream: function (params, options) {
        var baseUrl = "/Results/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    resultDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultDeleteById");
        }
        var baseUrl = "/Results/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    resultExistsGetResultsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultExistsGetResultsidExists");
        }
        var baseUrl = "/Results/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    resultExistsHeadResultsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultExistsHeadResultsid");
        }
        var baseUrl = "/Results/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    resultFind: function (params, options) {
        var baseUrl = "/Results";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    resultFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultFindById");
        }
        var baseUrl = "/Results/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    resultFindOne: function (params, options) {
        var baseUrl = "/Results/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultPatchOrCreate: function (params, options) {
        var baseUrl = "/Results";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Result id
     * @param data An object of model property name/value pairs
     */
    resultPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultPrototypePatchAttributes");
        }
        var baseUrl = "/Results/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    resultReplaceByIdPostResultsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultReplaceByIdPostResultsidReplace");
        }
        var baseUrl = "/Results/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    resultReplaceByIdPutResultsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling resultReplaceByIdPutResultsid");
        }
        var baseUrl = "/Results/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultReplaceOrCreatePostResultsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Results/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultReplaceOrCreatePutResults: function (params, options) {
        var baseUrl = "/Results";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    resultUpdateAll: function (params, options) {
        var baseUrl = "/Results/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    resultUpsertWithWhere: function (params, options) {
        var baseUrl = "/Results/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * ResultApi - functional programming interface
 */
export var ResultApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    resultCount: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    resultCreate: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    resultCreateChangeStreamGetResultsChangeStream: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultCreateChangeStreamGetResultsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    resultCreateChangeStreamPostResultsChangeStream: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultCreateChangeStreamPostResultsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    resultDeleteById: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    resultExistsGetResultsidExists: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultExistsGetResultsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    resultExistsHeadResultsid: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultExistsHeadResultsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    resultFind: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    resultFindById: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    resultFindOne: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultPatchOrCreate: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Result id
     * @param data An object of model property name/value pairs
     */
    resultPrototypePatchAttributes: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    resultReplaceByIdPostResultsidReplace: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultReplaceByIdPostResultsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    resultReplaceByIdPutResultsid: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultReplaceByIdPutResultsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultReplaceOrCreatePostResultsReplaceOrCreate: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultReplaceOrCreatePostResultsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    resultReplaceOrCreatePutResults: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultReplaceOrCreatePutResults(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    resultUpdateAll: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    resultUpsertWithWhere: function (params, options) {
        var fetchArgs = ResultApiFetchParamCreator.resultUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * ResultApi - object-oriented interface
 */
var ResultApi = /** @class */ (function (_super) {
    __extends(ResultApi, _super);
    function ResultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    ResultApi.prototype.resultCount = function (params, options) {
        return ResultApiFp.resultCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    ResultApi.prototype.resultCreate = function (params, options) {
        return ResultApiFp.resultCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ResultApi.prototype.resultCreateChangeStreamGetResultsChangeStream = function (params, options) {
        return ResultApiFp.resultCreateChangeStreamGetResultsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    ResultApi.prototype.resultCreateChangeStreamPostResultsChangeStream = function (params, options) {
        return ResultApiFp.resultCreateChangeStreamPostResultsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    ResultApi.prototype.resultDeleteById = function (params, options) {
        return ResultApiFp.resultDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ResultApi.prototype.resultExistsGetResultsidExists = function (params, options) {
        return ResultApiFp.resultExistsGetResultsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    ResultApi.prototype.resultExistsHeadResultsid = function (params, options) {
        return ResultApiFp.resultExistsHeadResultsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ResultApi.prototype.resultFind = function (params, options) {
        return ResultApiFp.resultFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    ResultApi.prototype.resultFindById = function (params, options) {
        return ResultApiFp.resultFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    ResultApi.prototype.resultFindOne = function (params, options) {
        return ResultApiFp.resultFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ResultApi.prototype.resultPatchOrCreate = function (params, options) {
        return ResultApiFp.resultPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Result id
     * @param data An object of model property name/value pairs
     */
    ResultApi.prototype.resultPrototypePatchAttributes = function (params, options) {
        return ResultApiFp.resultPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ResultApi.prototype.resultReplaceByIdPostResultsidReplace = function (params, options) {
        return ResultApiFp.resultReplaceByIdPostResultsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    ResultApi.prototype.resultReplaceByIdPutResultsid = function (params, options) {
        return ResultApiFp.resultReplaceByIdPutResultsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ResultApi.prototype.resultReplaceOrCreatePostResultsReplaceOrCreate = function (params, options) {
        return ResultApiFp.resultReplaceOrCreatePostResultsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    ResultApi.prototype.resultReplaceOrCreatePutResults = function (params, options) {
        return ResultApiFp.resultReplaceOrCreatePutResults(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ResultApi.prototype.resultUpdateAll = function (params, options) {
        return ResultApiFp.resultUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    ResultApi.prototype.resultUpsertWithWhere = function (params, options) {
        return ResultApiFp.resultUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return ResultApi;
}(BaseAPI));
export { ResultApi };
/**
 * ResultApi - factory interface
 */
export var ResultApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        resultCount: function (params, options) {
            return ResultApiFp.resultCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        resultCreate: function (params, options) {
            return ResultApiFp.resultCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        resultCreateChangeStreamGetResultsChangeStream: function (params, options) {
            return ResultApiFp.resultCreateChangeStreamGetResultsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        resultCreateChangeStreamPostResultsChangeStream: function (params, options) {
            return ResultApiFp.resultCreateChangeStreamPostResultsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        resultDeleteById: function (params, options) {
            return ResultApiFp.resultDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        resultExistsGetResultsidExists: function (params, options) {
            return ResultApiFp.resultExistsGetResultsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        resultExistsHeadResultsid: function (params, options) {
            return ResultApiFp.resultExistsHeadResultsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        resultFind: function (params, options) {
            return ResultApiFp.resultFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        resultFindById: function (params, options) {
            return ResultApiFp.resultFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        resultFindOne: function (params, options) {
            return ResultApiFp.resultFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        resultPatchOrCreate: function (params, options) {
            return ResultApiFp.resultPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Result id
         * @param data An object of model property name/value pairs
         */
        resultPrototypePatchAttributes: function (params, options) {
            return ResultApiFp.resultPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        resultReplaceByIdPostResultsidReplace: function (params, options) {
            return ResultApiFp.resultReplaceByIdPostResultsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        resultReplaceByIdPutResultsid: function (params, options) {
            return ResultApiFp.resultReplaceByIdPutResultsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        resultReplaceOrCreatePostResultsReplaceOrCreate: function (params, options) {
            return ResultApiFp.resultReplaceOrCreatePostResultsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        resultReplaceOrCreatePutResults: function (params, options) {
            return ResultApiFp.resultReplaceOrCreatePutResults(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        resultUpdateAll: function (params, options) {
            return ResultApiFp.resultUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        resultUpsertWithWhere: function (params, options) {
            return ResultApiFp.resultUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * RoundApi - fetch parameter creator
 */
export var RoundApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    roundCount: function (params, options) {
        var baseUrl = "/Rounds/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    roundCreate: function (params, options) {
        var baseUrl = "/Rounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    roundCreateChangeStreamGetRoundsChangeStream: function (params, options) {
        var baseUrl = "/Rounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    roundCreateChangeStreamPostRoundsChangeStream: function (params, options) {
        var baseUrl = "/Rounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    roundDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundDeleteById");
        }
        var baseUrl = "/Rounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    roundExistsGetRoundsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundExistsGetRoundsidExists");
        }
        var baseUrl = "/Rounds/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    roundExistsHeadRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundExistsHeadRoundsid");
        }
        var baseUrl = "/Rounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    roundFind: function (params, options) {
        var baseUrl = "/Rounds";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    roundFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundFindById");
        }
        var baseUrl = "/Rounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    roundFindOne: function (params, options) {
        var baseUrl = "/Rounds/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundPatchOrCreate: function (params, options) {
        var baseUrl = "/Rounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts students of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    roundPrototypeCountStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeCountStudents");
        }
        var baseUrl = "/Rounds/{id}/students/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts teachers of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    roundPrototypeCountTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeCountTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeCreateExam");
        }
        var baseUrl = "/Rounds/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeCreateStudents");
        }
        var baseUrl = "/Rounds/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeCreateTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Round id
     */
    roundPrototypeDeleteStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeDeleteStudents");
        }
        var baseUrl = "/Rounds/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Round id
     */
    roundPrototypeDeleteTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeDeleteTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeDestroyByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeDestroyByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeDestroyByIdStudents");
        }
        var baseUrl = "/Rounds/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeDestroyByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeDestroyByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeDestroyByIdTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes exam of this model.
     * @param id Round id
     */
    roundPrototypeDestroyExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeDestroyExam");
        }
        var baseUrl = "/Rounds/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeExistsStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeExistsStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeExistsStudents");
        }
        var baseUrl = "/Rounds/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeExistsTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeExistsTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeExistsTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeFindByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeFindByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeFindByIdStudents");
        }
        var baseUrl = "/Rounds/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeFindByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeFindByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeFindByIdTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeGetAccount");
        }
        var baseUrl = "/Rounds/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetContest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeGetContest");
        }
        var baseUrl = "/Rounds/{id}/contest".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeGetExam");
        }
        var baseUrl = "/Rounds/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries students of Round.
     * @param id Round id
     * @param filter
     */
    roundPrototypeGetStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeGetStudents");
        }
        var baseUrl = "/Rounds/{id}/students".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries teachers of Round.
     * @param id Round id
     * @param filter
     */
    roundPrototypeGetTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeGetTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    roundPrototypeLinkStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeLinkStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeLinkStudents");
        }
        var baseUrl = "/Rounds/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    roundPrototypeLinkTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeLinkTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeLinkTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Round id
     * @param data An object of model property name/value pairs
     */
    roundPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypePatchAttributes");
        }
        var baseUrl = "/Rounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeUnlinkStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeUnlinkStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeUnlinkStudents");
        }
        var baseUrl = "/Rounds/{id}/students/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeUnlinkTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeUnlinkTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeUnlinkTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    roundPrototypeUpdateByIdStudents: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeUpdateByIdStudents");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeUpdateByIdStudents");
        }
        var baseUrl = "/Rounds/{id}/students/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    roundPrototypeUpdateByIdTeachers: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeUpdateByIdTeachers");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling roundPrototypeUpdateByIdTeachers");
        }
        var baseUrl = "/Rounds/{id}/teachers/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update exam of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeUpdateExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundPrototypeUpdateExam");
        }
        var baseUrl = "/Rounds/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    roundReplaceByIdPostRoundsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundReplaceByIdPostRoundsidReplace");
        }
        var baseUrl = "/Rounds/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    roundReplaceByIdPutRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling roundReplaceByIdPutRoundsid");
        }
        var baseUrl = "/Rounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundReplaceOrCreatePostRoundsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Rounds/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundReplaceOrCreatePutRounds: function (params, options) {
        var baseUrl = "/Rounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    roundUpdateAll: function (params, options) {
        var baseUrl = "/Rounds/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    roundUpsertWithWhere: function (params, options) {
        var baseUrl = "/Rounds/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * RoundApi - functional programming interface
 */
export var RoundApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    roundCount: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    roundCreate: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    roundCreateChangeStreamGetRoundsChangeStream: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundCreateChangeStreamGetRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    roundCreateChangeStreamPostRoundsChangeStream: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundCreateChangeStreamPostRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    roundDeleteById: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    roundExistsGetRoundsidExists: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundExistsGetRoundsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    roundExistsHeadRoundsid: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundExistsHeadRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    roundFind: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    roundFindById: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    roundFindOne: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundPatchOrCreate: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts students of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    roundPrototypeCountStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeCountStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts teachers of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    roundPrototypeCountTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeCountTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateExam: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeCreateExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeCreateStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeCreateTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeCreateTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Round id
     */
    roundPrototypeDeleteStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeDeleteStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Round id
     */
    roundPrototypeDeleteTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeDeleteTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeDestroyByIdStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeDestroyByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeDestroyByIdTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeDestroyByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes exam of this model.
     * @param id Round id
     */
    roundPrototypeDestroyExam: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeDestroyExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeExistsStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeExistsStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeExistsTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeExistsTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeFindByIdStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeFindByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeFindByIdTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeFindByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetAccount: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetContest: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeGetContest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id Round id
     * @param refresh
     */
    roundPrototypeGetExam: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeGetExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries students of Round.
     * @param id Round id
     * @param filter
     */
    roundPrototypeGetStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeGetStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries teachers of Round.
     * @param id Round id
     * @param filter
     */
    roundPrototypeGetTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeGetTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    roundPrototypeLinkStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeLinkStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    roundPrototypeLinkTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeLinkTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Round id
     * @param data An object of model property name/value pairs
     */
    roundPrototypePatchAttributes: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    roundPrototypeUnlinkStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeUnlinkStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    roundPrototypeUnlinkTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeUnlinkTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    roundPrototypeUpdateByIdStudents: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeUpdateByIdStudents(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    roundPrototypeUpdateByIdTeachers: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeUpdateByIdTeachers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update exam of this model.
     * @param id Round id
     * @param data
     */
    roundPrototypeUpdateExam: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundPrototypeUpdateExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    roundReplaceByIdPostRoundsidReplace: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundReplaceByIdPostRoundsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    roundReplaceByIdPutRoundsid: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundReplaceByIdPutRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundReplaceOrCreatePostRoundsReplaceOrCreate: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundReplaceOrCreatePostRoundsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    roundReplaceOrCreatePutRounds: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundReplaceOrCreatePutRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    roundUpdateAll: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    roundUpsertWithWhere: function (params, options) {
        var fetchArgs = RoundApiFetchParamCreator.roundUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * RoundApi - object-oriented interface
 */
var RoundApi = /** @class */ (function (_super) {
    __extends(RoundApi, _super);
    function RoundApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    RoundApi.prototype.roundCount = function (params, options) {
        return RoundApiFp.roundCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    RoundApi.prototype.roundCreate = function (params, options) {
        return RoundApiFp.roundCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    RoundApi.prototype.roundCreateChangeStreamGetRoundsChangeStream = function (params, options) {
        return RoundApiFp.roundCreateChangeStreamGetRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    RoundApi.prototype.roundCreateChangeStreamPostRoundsChangeStream = function (params, options) {
        return RoundApiFp.roundCreateChangeStreamPostRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    RoundApi.prototype.roundDeleteById = function (params, options) {
        return RoundApiFp.roundDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    RoundApi.prototype.roundExistsGetRoundsidExists = function (params, options) {
        return RoundApiFp.roundExistsGetRoundsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    RoundApi.prototype.roundExistsHeadRoundsid = function (params, options) {
        return RoundApiFp.roundExistsHeadRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    RoundApi.prototype.roundFind = function (params, options) {
        return RoundApiFp.roundFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    RoundApi.prototype.roundFindById = function (params, options) {
        return RoundApiFp.roundFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    RoundApi.prototype.roundFindOne = function (params, options) {
        return RoundApiFp.roundFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RoundApi.prototype.roundPatchOrCreate = function (params, options) {
        return RoundApiFp.roundPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts students of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    RoundApi.prototype.roundPrototypeCountStudents = function (params, options) {
        return RoundApiFp.roundPrototypeCountStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts teachers of Round.
     * @param id Round id
     * @param where Criteria to match model instances
     */
    RoundApi.prototype.roundPrototypeCountTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeCountTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id Round id
     * @param data
     */
    RoundApi.prototype.roundPrototypeCreateExam = function (params, options) {
        return RoundApiFp.roundPrototypeCreateExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in students of this model.
     * @param id Round id
     * @param data
     */
    RoundApi.prototype.roundPrototypeCreateStudents = function (params, options) {
        return RoundApiFp.roundPrototypeCreateStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in teachers of this model.
     * @param id Round id
     * @param data
     */
    RoundApi.prototype.roundPrototypeCreateTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeCreateTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all students of this model.
     * @param id Round id
     */
    RoundApi.prototype.roundPrototypeDeleteStudents = function (params, options) {
        return RoundApiFp.roundPrototypeDeleteStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all teachers of this model.
     * @param id Round id
     */
    RoundApi.prototype.roundPrototypeDeleteTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeDeleteTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    RoundApi.prototype.roundPrototypeDestroyByIdStudents = function (params, options) {
        return RoundApiFp.roundPrototypeDestroyByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    RoundApi.prototype.roundPrototypeDestroyByIdTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeDestroyByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes exam of this model.
     * @param id Round id
     */
    RoundApi.prototype.roundPrototypeDestroyExam = function (params, options) {
        return RoundApiFp.roundPrototypeDestroyExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    RoundApi.prototype.roundPrototypeExistsStudents = function (params, options) {
        return RoundApiFp.roundPrototypeExistsStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    RoundApi.prototype.roundPrototypeExistsTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeExistsTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     */
    RoundApi.prototype.roundPrototypeFindByIdStudents = function (params, options) {
        return RoundApiFp.roundPrototypeFindByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    RoundApi.prototype.roundPrototypeFindByIdTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeFindByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Round id
     * @param refresh
     */
    RoundApi.prototype.roundPrototypeGetAccount = function (params, options) {
        return RoundApiFp.roundPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id Round id
     * @param refresh
     */
    RoundApi.prototype.roundPrototypeGetContest = function (params, options) {
        return RoundApiFp.roundPrototypeGetContest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id Round id
     * @param refresh
     */
    RoundApi.prototype.roundPrototypeGetExam = function (params, options) {
        return RoundApiFp.roundPrototypeGetExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries students of Round.
     * @param id Round id
     * @param filter
     */
    RoundApi.prototype.roundPrototypeGetStudents = function (params, options) {
        return RoundApiFp.roundPrototypeGetStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries teachers of Round.
     * @param id Round id
     * @param filter
     */
    RoundApi.prototype.roundPrototypeGetTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeGetTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    RoundApi.prototype.roundPrototypeLinkStudents = function (params, options) {
        return RoundApiFp.roundPrototypeLinkStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    RoundApi.prototype.roundPrototypeLinkTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeLinkTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Round id
     * @param data An object of model property name/value pairs
     */
    RoundApi.prototype.roundPrototypePatchAttributes = function (params, options) {
        return RoundApiFp.roundPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the students relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for students
     */
    RoundApi.prototype.roundPrototypeUnlinkStudents = function (params, options) {
        return RoundApiFp.roundPrototypeUnlinkStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the teachers relation to an item by id.
     * @param id Round id
     * @param fk Foreign key for teachers
     */
    RoundApi.prototype.roundPrototypeUnlinkTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeUnlinkTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for students.
     * @param id Round id
     * @param fk Foreign key for students
     * @param data
     */
    RoundApi.prototype.roundPrototypeUpdateByIdStudents = function (params, options) {
        return RoundApiFp.roundPrototypeUpdateByIdStudents(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for teachers.
     * @param id Round id
     * @param fk Foreign key for teachers
     * @param data
     */
    RoundApi.prototype.roundPrototypeUpdateByIdTeachers = function (params, options) {
        return RoundApiFp.roundPrototypeUpdateByIdTeachers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update exam of this model.
     * @param id Round id
     * @param data
     */
    RoundApi.prototype.roundPrototypeUpdateExam = function (params, options) {
        return RoundApiFp.roundPrototypeUpdateExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    RoundApi.prototype.roundReplaceByIdPostRoundsidReplace = function (params, options) {
        return RoundApiFp.roundReplaceByIdPostRoundsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    RoundApi.prototype.roundReplaceByIdPutRoundsid = function (params, options) {
        return RoundApiFp.roundReplaceByIdPutRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RoundApi.prototype.roundReplaceOrCreatePostRoundsReplaceOrCreate = function (params, options) {
        return RoundApiFp.roundReplaceOrCreatePostRoundsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    RoundApi.prototype.roundReplaceOrCreatePutRounds = function (params, options) {
        return RoundApiFp.roundReplaceOrCreatePutRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    RoundApi.prototype.roundUpdateAll = function (params, options) {
        return RoundApiFp.roundUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    RoundApi.prototype.roundUpsertWithWhere = function (params, options) {
        return RoundApiFp.roundUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return RoundApi;
}(BaseAPI));
export { RoundApi };
/**
 * RoundApi - factory interface
 */
export var RoundApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        roundCount: function (params, options) {
            return RoundApiFp.roundCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        roundCreate: function (params, options) {
            return RoundApiFp.roundCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        roundCreateChangeStreamGetRoundsChangeStream: function (params, options) {
            return RoundApiFp.roundCreateChangeStreamGetRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        roundCreateChangeStreamPostRoundsChangeStream: function (params, options) {
            return RoundApiFp.roundCreateChangeStreamPostRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        roundDeleteById: function (params, options) {
            return RoundApiFp.roundDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        roundExistsGetRoundsidExists: function (params, options) {
            return RoundApiFp.roundExistsGetRoundsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        roundExistsHeadRoundsid: function (params, options) {
            return RoundApiFp.roundExistsHeadRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        roundFind: function (params, options) {
            return RoundApiFp.roundFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        roundFindById: function (params, options) {
            return RoundApiFp.roundFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        roundFindOne: function (params, options) {
            return RoundApiFp.roundFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        roundPatchOrCreate: function (params, options) {
            return RoundApiFp.roundPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts students of Round.
         * @param id Round id
         * @param where Criteria to match model instances
         */
        roundPrototypeCountStudents: function (params, options) {
            return RoundApiFp.roundPrototypeCountStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts teachers of Round.
         * @param id Round id
         * @param where Criteria to match model instances
         */
        roundPrototypeCountTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeCountTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in exam of this model.
         * @param id Round id
         * @param data
         */
        roundPrototypeCreateExam: function (params, options) {
            return RoundApiFp.roundPrototypeCreateExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in students of this model.
         * @param id Round id
         * @param data
         */
        roundPrototypeCreateStudents: function (params, options) {
            return RoundApiFp.roundPrototypeCreateStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in teachers of this model.
         * @param id Round id
         * @param data
         */
        roundPrototypeCreateTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeCreateTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all students of this model.
         * @param id Round id
         */
        roundPrototypeDeleteStudents: function (params, options) {
            return RoundApiFp.roundPrototypeDeleteStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all teachers of this model.
         * @param id Round id
         */
        roundPrototypeDeleteTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeDeleteTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for students.
         * @param id Round id
         * @param fk Foreign key for students
         */
        roundPrototypeDestroyByIdStudents: function (params, options) {
            return RoundApiFp.roundPrototypeDestroyByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for teachers.
         * @param id Round id
         * @param fk Foreign key for teachers
         */
        roundPrototypeDestroyByIdTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeDestroyByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes exam of this model.
         * @param id Round id
         */
        roundPrototypeDestroyExam: function (params, options) {
            return RoundApiFp.roundPrototypeDestroyExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of students relation to an item by id.
         * @param id Round id
         * @param fk Foreign key for students
         */
        roundPrototypeExistsStudents: function (params, options) {
            return RoundApiFp.roundPrototypeExistsStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of teachers relation to an item by id.
         * @param id Round id
         * @param fk Foreign key for teachers
         */
        roundPrototypeExistsTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeExistsTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for students.
         * @param id Round id
         * @param fk Foreign key for students
         */
        roundPrototypeFindByIdStudents: function (params, options) {
            return RoundApiFp.roundPrototypeFindByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for teachers.
         * @param id Round id
         * @param fk Foreign key for teachers
         */
        roundPrototypeFindByIdTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeFindByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Round id
         * @param refresh
         */
        roundPrototypeGetAccount: function (params, options) {
            return RoundApiFp.roundPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation contest.
         * @param id Round id
         * @param refresh
         */
        roundPrototypeGetContest: function (params, options) {
            return RoundApiFp.roundPrototypeGetContest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches hasOne relation exam.
         * @param id Round id
         * @param refresh
         */
        roundPrototypeGetExam: function (params, options) {
            return RoundApiFp.roundPrototypeGetExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries students of Round.
         * @param id Round id
         * @param filter
         */
        roundPrototypeGetStudents: function (params, options) {
            return RoundApiFp.roundPrototypeGetStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries teachers of Round.
         * @param id Round id
         * @param filter
         */
        roundPrototypeGetTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeGetTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for students.
         * @param id Round id
         * @param fk Foreign key for students
         * @param data
         */
        roundPrototypeLinkStudents: function (params, options) {
            return RoundApiFp.roundPrototypeLinkStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for teachers.
         * @param id Round id
         * @param fk Foreign key for teachers
         * @param data
         */
        roundPrototypeLinkTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeLinkTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Round id
         * @param data An object of model property name/value pairs
         */
        roundPrototypePatchAttributes: function (params, options) {
            return RoundApiFp.roundPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the students relation to an item by id.
         * @param id Round id
         * @param fk Foreign key for students
         */
        roundPrototypeUnlinkStudents: function (params, options) {
            return RoundApiFp.roundPrototypeUnlinkStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the teachers relation to an item by id.
         * @param id Round id
         * @param fk Foreign key for teachers
         */
        roundPrototypeUnlinkTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeUnlinkTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for students.
         * @param id Round id
         * @param fk Foreign key for students
         * @param data
         */
        roundPrototypeUpdateByIdStudents: function (params, options) {
            return RoundApiFp.roundPrototypeUpdateByIdStudents(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for teachers.
         * @param id Round id
         * @param fk Foreign key for teachers
         * @param data
         */
        roundPrototypeUpdateByIdTeachers: function (params, options) {
            return RoundApiFp.roundPrototypeUpdateByIdTeachers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update exam of this model.
         * @param id Round id
         * @param data
         */
        roundPrototypeUpdateExam: function (params, options) {
            return RoundApiFp.roundPrototypeUpdateExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        roundReplaceByIdPostRoundsidReplace: function (params, options) {
            return RoundApiFp.roundReplaceByIdPostRoundsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        roundReplaceByIdPutRoundsid: function (params, options) {
            return RoundApiFp.roundReplaceByIdPutRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        roundReplaceOrCreatePostRoundsReplaceOrCreate: function (params, options) {
            return RoundApiFp.roundReplaceOrCreatePostRoundsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        roundReplaceOrCreatePutRounds: function (params, options) {
            return RoundApiFp.roundReplaceOrCreatePutRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        roundUpdateAll: function (params, options) {
            return RoundApiFp.roundUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        roundUpsertWithWhere: function (params, options) {
            return RoundApiFp.roundUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * SchoolApi - fetch parameter creator
 */
export var SchoolApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    schoolCount: function (params, options) {
        var baseUrl = "/Schools/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    schoolCreate: function (params, options) {
        var baseUrl = "/Schools";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    schoolCreateChangeStreamGetSchoolsChangeStream: function (params, options) {
        var baseUrl = "/Schools/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    schoolCreateChangeStreamPostSchoolsChangeStream: function (params, options) {
        var baseUrl = "/Schools/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    schoolDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolDeleteById");
        }
        var baseUrl = "/Schools/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    schoolExistsGetSchoolsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolExistsGetSchoolsidExists");
        }
        var baseUrl = "/Schools/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    schoolExistsHeadSchoolsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolExistsHeadSchoolsid");
        }
        var baseUrl = "/Schools/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    schoolFind: function (params, options) {
        var baseUrl = "/Schools";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    schoolFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolFindById");
        }
        var baseUrl = "/Schools/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    schoolFindOne: function (params, options) {
        var baseUrl = "/Schools/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolPatchOrCreate: function (params, options) {
        var baseUrl = "/Schools";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id School id
     * @param refresh
     */
    schoolPrototypeGetCity: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolPrototypeGetCity");
        }
        var baseUrl = "/Schools/{id}/city".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id School id
     * @param refresh
     */
    schoolPrototypeGetDistrict: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolPrototypeGetDistrict");
        }
        var baseUrl = "/Schools/{id}/district".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id School id
     * @param data An object of model property name/value pairs
     */
    schoolPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolPrototypePatchAttributes");
        }
        var baseUrl = "/Schools/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    schoolReplaceByIdPostSchoolsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolReplaceByIdPostSchoolsidReplace");
        }
        var baseUrl = "/Schools/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    schoolReplaceByIdPutSchoolsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling schoolReplaceByIdPutSchoolsid");
        }
        var baseUrl = "/Schools/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolReplaceOrCreatePostSchoolsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Schools/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolReplaceOrCreatePutSchools: function (params, options) {
        var baseUrl = "/Schools";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    schoolUpdateAll: function (params, options) {
        var baseUrl = "/Schools/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    schoolUpsertWithWhere: function (params, options) {
        var baseUrl = "/Schools/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * SchoolApi - functional programming interface
 */
export var SchoolApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    schoolCount: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    schoolCreate: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    schoolCreateChangeStreamGetSchoolsChangeStream: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolCreateChangeStreamGetSchoolsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    schoolCreateChangeStreamPostSchoolsChangeStream: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolCreateChangeStreamPostSchoolsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    schoolDeleteById: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    schoolExistsGetSchoolsidExists: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolExistsGetSchoolsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    schoolExistsHeadSchoolsid: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolExistsHeadSchoolsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    schoolFind: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    schoolFindById: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    schoolFindOne: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolPatchOrCreate: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id School id
     * @param refresh
     */
    schoolPrototypeGetCity: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolPrototypeGetCity(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id School id
     * @param refresh
     */
    schoolPrototypeGetDistrict: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolPrototypeGetDistrict(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id School id
     * @param data An object of model property name/value pairs
     */
    schoolPrototypePatchAttributes: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    schoolReplaceByIdPostSchoolsidReplace: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolReplaceByIdPostSchoolsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    schoolReplaceByIdPutSchoolsid: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolReplaceByIdPutSchoolsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolReplaceOrCreatePostSchoolsReplaceOrCreate: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolReplaceOrCreatePostSchoolsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    schoolReplaceOrCreatePutSchools: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolReplaceOrCreatePutSchools(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    schoolUpdateAll: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    schoolUpsertWithWhere: function (params, options) {
        var fetchArgs = SchoolApiFetchParamCreator.schoolUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * SchoolApi - object-oriented interface
 */
var SchoolApi = /** @class */ (function (_super) {
    __extends(SchoolApi, _super);
    function SchoolApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    SchoolApi.prototype.schoolCount = function (params, options) {
        return SchoolApiFp.schoolCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolCreate = function (params, options) {
        return SchoolApiFp.schoolCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    SchoolApi.prototype.schoolCreateChangeStreamGetSchoolsChangeStream = function (params, options) {
        return SchoolApiFp.schoolCreateChangeStreamGetSchoolsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    SchoolApi.prototype.schoolCreateChangeStreamPostSchoolsChangeStream = function (params, options) {
        return SchoolApiFp.schoolCreateChangeStreamPostSchoolsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    SchoolApi.prototype.schoolDeleteById = function (params, options) {
        return SchoolApiFp.schoolDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    SchoolApi.prototype.schoolExistsGetSchoolsidExists = function (params, options) {
        return SchoolApiFp.schoolExistsGetSchoolsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    SchoolApi.prototype.schoolExistsHeadSchoolsid = function (params, options) {
        return SchoolApiFp.schoolExistsHeadSchoolsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    SchoolApi.prototype.schoolFind = function (params, options) {
        return SchoolApiFp.schoolFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    SchoolApi.prototype.schoolFindById = function (params, options) {
        return SchoolApiFp.schoolFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    SchoolApi.prototype.schoolFindOne = function (params, options) {
        return SchoolApiFp.schoolFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolPatchOrCreate = function (params, options) {
        return SchoolApiFp.schoolPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation city.
     * @param id School id
     * @param refresh
     */
    SchoolApi.prototype.schoolPrototypeGetCity = function (params, options) {
        return SchoolApiFp.schoolPrototypeGetCity(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation district.
     * @param id School id
     * @param refresh
     */
    SchoolApi.prototype.schoolPrototypeGetDistrict = function (params, options) {
        return SchoolApiFp.schoolPrototypeGetDistrict(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id School id
     * @param data An object of model property name/value pairs
     */
    SchoolApi.prototype.schoolPrototypePatchAttributes = function (params, options) {
        return SchoolApiFp.schoolPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolReplaceByIdPostSchoolsidReplace = function (params, options) {
        return SchoolApiFp.schoolReplaceByIdPostSchoolsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolReplaceByIdPutSchoolsid = function (params, options) {
        return SchoolApiFp.schoolReplaceByIdPutSchoolsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolReplaceOrCreatePostSchoolsReplaceOrCreate = function (params, options) {
        return SchoolApiFp.schoolReplaceOrCreatePostSchoolsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SchoolApi.prototype.schoolReplaceOrCreatePutSchools = function (params, options) {
        return SchoolApiFp.schoolReplaceOrCreatePutSchools(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    SchoolApi.prototype.schoolUpdateAll = function (params, options) {
        return SchoolApiFp.schoolUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    SchoolApi.prototype.schoolUpsertWithWhere = function (params, options) {
        return SchoolApiFp.schoolUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return SchoolApi;
}(BaseAPI));
export { SchoolApi };
/**
 * SchoolApi - factory interface
 */
export var SchoolApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        schoolCount: function (params, options) {
            return SchoolApiFp.schoolCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        schoolCreate: function (params, options) {
            return SchoolApiFp.schoolCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        schoolCreateChangeStreamGetSchoolsChangeStream: function (params, options) {
            return SchoolApiFp.schoolCreateChangeStreamGetSchoolsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        schoolCreateChangeStreamPostSchoolsChangeStream: function (params, options) {
            return SchoolApiFp.schoolCreateChangeStreamPostSchoolsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        schoolDeleteById: function (params, options) {
            return SchoolApiFp.schoolDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        schoolExistsGetSchoolsidExists: function (params, options) {
            return SchoolApiFp.schoolExistsGetSchoolsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        schoolExistsHeadSchoolsid: function (params, options) {
            return SchoolApiFp.schoolExistsHeadSchoolsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        schoolFind: function (params, options) {
            return SchoolApiFp.schoolFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        schoolFindById: function (params, options) {
            return SchoolApiFp.schoolFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        schoolFindOne: function (params, options) {
            return SchoolApiFp.schoolFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        schoolPatchOrCreate: function (params, options) {
            return SchoolApiFp.schoolPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation city.
         * @param id School id
         * @param refresh
         */
        schoolPrototypeGetCity: function (params, options) {
            return SchoolApiFp.schoolPrototypeGetCity(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation district.
         * @param id School id
         * @param refresh
         */
        schoolPrototypeGetDistrict: function (params, options) {
            return SchoolApiFp.schoolPrototypeGetDistrict(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id School id
         * @param data An object of model property name/value pairs
         */
        schoolPrototypePatchAttributes: function (params, options) {
            return SchoolApiFp.schoolPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        schoolReplaceByIdPostSchoolsidReplace: function (params, options) {
            return SchoolApiFp.schoolReplaceByIdPostSchoolsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        schoolReplaceByIdPutSchoolsid: function (params, options) {
            return SchoolApiFp.schoolReplaceByIdPutSchoolsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        schoolReplaceOrCreatePostSchoolsReplaceOrCreate: function (params, options) {
            return SchoolApiFp.schoolReplaceOrCreatePostSchoolsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        schoolReplaceOrCreatePutSchools: function (params, options) {
            return SchoolApiFp.schoolReplaceOrCreatePutSchools(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        schoolUpdateAll: function (params, options) {
            return SchoolApiFp.schoolUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        schoolUpsertWithWhere: function (params, options) {
            return SchoolApiFp.schoolUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * StudentContestApi - fetch parameter creator
 */
export var StudentContestApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentContestCount: function (params, options) {
        var baseUrl = "/StudentContests/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentContestCreate: function (params, options) {
        var baseUrl = "/StudentContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentContestCreateChangeStreamGetStudentContestsChangeStream: function (params, options) {
        var baseUrl = "/StudentContests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentContestCreateChangeStreamPostStudentContestsChangeStream: function (params, options) {
        var baseUrl = "/StudentContests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentContestDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestDeleteById");
        }
        var baseUrl = "/StudentContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentContestExistsGetStudentContestsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestExistsGetStudentContestsidExists");
        }
        var baseUrl = "/StudentContests/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentContestExistsHeadStudentContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestExistsHeadStudentContestsid");
        }
        var baseUrl = "/StudentContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentContestFind: function (params, options) {
        var baseUrl = "/StudentContests";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentContestFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestFindById");
        }
        var baseUrl = "/StudentContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentContestFindOne: function (params, options) {
        var baseUrl = "/StudentContests/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestPatchOrCreate: function (params, options) {
        var baseUrl = "/StudentContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id StudentContest id
     * @param refresh
     */
    studentContestPrototypeGetContest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestPrototypeGetContest");
        }
        var baseUrl = "/StudentContests/{id}/contest".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id StudentContest id
     * @param refresh
     */
    studentContestPrototypeGetStudent: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestPrototypeGetStudent");
        }
        var baseUrl = "/StudentContests/{id}/student".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentContest id
     * @param data An object of model property name/value pairs
     */
    studentContestPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestPrototypePatchAttributes");
        }
        var baseUrl = "/StudentContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentContestReplaceByIdPostStudentContestsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestReplaceByIdPostStudentContestsidReplace");
        }
        var baseUrl = "/StudentContests/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentContestReplaceByIdPutStudentContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentContestReplaceByIdPutStudentContestsid");
        }
        var baseUrl = "/StudentContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate: function (params, options) {
        var baseUrl = "/StudentContests/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestReplaceOrCreatePutStudentContests: function (params, options) {
        var baseUrl = "/StudentContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentContestUpdateAll: function (params, options) {
        var baseUrl = "/StudentContests/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentContestUpsertWithWhere: function (params, options) {
        var baseUrl = "/StudentContests/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * StudentContestApi - functional programming interface
 */
export var StudentContestApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentContestCount: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentContestCreate: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentContestCreateChangeStreamGetStudentContestsChangeStream: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestCreateChangeStreamGetStudentContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentContestCreateChangeStreamPostStudentContestsChangeStream: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestCreateChangeStreamPostStudentContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentContestDeleteById: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentContestExistsGetStudentContestsidExists: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestExistsGetStudentContestsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentContestExistsHeadStudentContestsid: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestExistsHeadStudentContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentContestFind: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentContestFindById: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentContestFindOne: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestPatchOrCreate: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id StudentContest id
     * @param refresh
     */
    studentContestPrototypeGetContest: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestPrototypeGetContest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id StudentContest id
     * @param refresh
     */
    studentContestPrototypeGetStudent: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestPrototypeGetStudent(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentContest id
     * @param data An object of model property name/value pairs
     */
    studentContestPrototypePatchAttributes: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentContestReplaceByIdPostStudentContestsidReplace: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestReplaceByIdPostStudentContestsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentContestReplaceByIdPutStudentContestsid: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestReplaceByIdPutStudentContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentContestReplaceOrCreatePutStudentContests: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestReplaceOrCreatePutStudentContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentContestUpdateAll: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentContestUpsertWithWhere: function (params, options) {
        var fetchArgs = StudentContestApiFetchParamCreator.studentContestUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * StudentContestApi - object-oriented interface
 */
var StudentContestApi = /** @class */ (function (_super) {
    __extends(StudentContestApi, _super);
    function StudentContestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    StudentContestApi.prototype.studentContestCount = function (params, options) {
        return StudentContestApiFp.studentContestCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestCreate = function (params, options) {
        return StudentContestApiFp.studentContestCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentContestApi.prototype.studentContestCreateChangeStreamGetStudentContestsChangeStream = function (params, options) {
        return StudentContestApiFp.studentContestCreateChangeStreamGetStudentContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentContestApi.prototype.studentContestCreateChangeStreamPostStudentContestsChangeStream = function (params, options) {
        return StudentContestApiFp.studentContestCreateChangeStreamPostStudentContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    StudentContestApi.prototype.studentContestDeleteById = function (params, options) {
        return StudentContestApiFp.studentContestDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentContestApi.prototype.studentContestExistsGetStudentContestsidExists = function (params, options) {
        return StudentContestApiFp.studentContestExistsGetStudentContestsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentContestApi.prototype.studentContestExistsHeadStudentContestsid = function (params, options) {
        return StudentContestApiFp.studentContestExistsHeadStudentContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentContestApi.prototype.studentContestFind = function (params, options) {
        return StudentContestApiFp.studentContestFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    StudentContestApi.prototype.studentContestFindById = function (params, options) {
        return StudentContestApiFp.studentContestFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentContestApi.prototype.studentContestFindOne = function (params, options) {
        return StudentContestApiFp.studentContestFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestPatchOrCreate = function (params, options) {
        return StudentContestApiFp.studentContestPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id StudentContest id
     * @param refresh
     */
    StudentContestApi.prototype.studentContestPrototypeGetContest = function (params, options) {
        return StudentContestApiFp.studentContestPrototypeGetContest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id StudentContest id
     * @param refresh
     */
    StudentContestApi.prototype.studentContestPrototypeGetStudent = function (params, options) {
        return StudentContestApiFp.studentContestPrototypeGetStudent(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentContest id
     * @param data An object of model property name/value pairs
     */
    StudentContestApi.prototype.studentContestPrototypePatchAttributes = function (params, options) {
        return StudentContestApiFp.studentContestPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestReplaceByIdPostStudentContestsidReplace = function (params, options) {
        return StudentContestApiFp.studentContestReplaceByIdPostStudentContestsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestReplaceByIdPutStudentContestsid = function (params, options) {
        return StudentContestApiFp.studentContestReplaceByIdPutStudentContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate = function (params, options) {
        return StudentContestApiFp.studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentContestApi.prototype.studentContestReplaceOrCreatePutStudentContests = function (params, options) {
        return StudentContestApiFp.studentContestReplaceOrCreatePutStudentContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentContestApi.prototype.studentContestUpdateAll = function (params, options) {
        return StudentContestApiFp.studentContestUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentContestApi.prototype.studentContestUpsertWithWhere = function (params, options) {
        return StudentContestApiFp.studentContestUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return StudentContestApi;
}(BaseAPI));
export { StudentContestApi };
/**
 * StudentContestApi - factory interface
 */
export var StudentContestApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        studentContestCount: function (params, options) {
            return StudentContestApiFp.studentContestCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        studentContestCreate: function (params, options) {
            return StudentContestApiFp.studentContestCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentContestCreateChangeStreamGetStudentContestsChangeStream: function (params, options) {
            return StudentContestApiFp.studentContestCreateChangeStreamGetStudentContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentContestCreateChangeStreamPostStudentContestsChangeStream: function (params, options) {
            return StudentContestApiFp.studentContestCreateChangeStreamPostStudentContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        studentContestDeleteById: function (params, options) {
            return StudentContestApiFp.studentContestDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentContestExistsGetStudentContestsidExists: function (params, options) {
            return StudentContestApiFp.studentContestExistsGetStudentContestsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentContestExistsHeadStudentContestsid: function (params, options) {
            return StudentContestApiFp.studentContestExistsHeadStudentContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentContestFind: function (params, options) {
            return StudentContestApiFp.studentContestFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        studentContestFindById: function (params, options) {
            return StudentContestApiFp.studentContestFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentContestFindOne: function (params, options) {
            return StudentContestApiFp.studentContestFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentContestPatchOrCreate: function (params, options) {
            return StudentContestApiFp.studentContestPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation contest.
         * @param id StudentContest id
         * @param refresh
         */
        studentContestPrototypeGetContest: function (params, options) {
            return StudentContestApiFp.studentContestPrototypeGetContest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation student.
         * @param id StudentContest id
         * @param refresh
         */
        studentContestPrototypeGetStudent: function (params, options) {
            return StudentContestApiFp.studentContestPrototypeGetStudent(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id StudentContest id
         * @param data An object of model property name/value pairs
         */
        studentContestPrototypePatchAttributes: function (params, options) {
            return StudentContestApiFp.studentContestPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentContestReplaceByIdPostStudentContestsidReplace: function (params, options) {
            return StudentContestApiFp.studentContestReplaceByIdPostStudentContestsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentContestReplaceByIdPutStudentContestsid: function (params, options) {
            return StudentContestApiFp.studentContestReplaceByIdPutStudentContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate: function (params, options) {
            return StudentContestApiFp.studentContestReplaceOrCreatePostStudentContestsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentContestReplaceOrCreatePutStudentContests: function (params, options) {
            return StudentContestApiFp.studentContestReplaceOrCreatePutStudentContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentContestUpdateAll: function (params, options) {
            return StudentContestApiFp.studentContestUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentContestUpsertWithWhere: function (params, options) {
            return StudentContestApiFp.studentContestUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * StudentInfoApi - fetch parameter creator
 */
export var StudentInfoApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentInfoCount: function (params, options) {
        var baseUrl = "/StudentInfos/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentInfoCreate: function (params, options) {
        var baseUrl = "/StudentInfos";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentInfoCreateChangeStreamGetStudentInfosChangeStream: function (params, options) {
        var baseUrl = "/StudentInfos/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentInfoCreateChangeStreamPostStudentInfosChangeStream: function (params, options) {
        var baseUrl = "/StudentInfos/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentInfoDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoDeleteById");
        }
        var baseUrl = "/StudentInfos/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentInfoExistsGetStudentInfosidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoExistsGetStudentInfosidExists");
        }
        var baseUrl = "/StudentInfos/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentInfoExistsHeadStudentInfosid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoExistsHeadStudentInfosid");
        }
        var baseUrl = "/StudentInfos/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentInfoFind: function (params, options) {
        var baseUrl = "/StudentInfos";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentInfoFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoFindById");
        }
        var baseUrl = "/StudentInfos/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentInfoFindOne: function (params, options) {
        var baseUrl = "/StudentInfos/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoPatchOrCreate: function (params, options) {
        var baseUrl = "/StudentInfos";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    studentInfoPrototypeCreateExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypeCreateExam");
        }
        var baseUrl = "/StudentInfos/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes exam of this model.
     * @param id StudentInfo id
     */
    studentInfoPrototypeDestroyExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypeDestroyExam");
        }
        var baseUrl = "/StudentInfos/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id StudentInfo id
     * @param refresh
     */
    studentInfoPrototypeGetExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypeGetExam");
        }
        var baseUrl = "/StudentInfos/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id StudentInfo id
     * @param refresh
     */
    studentInfoPrototypeGetTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypeGetTest");
        }
        var baseUrl = "/StudentInfos/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentInfo id
     * @param data An object of model property name/value pairs
     */
    studentInfoPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypePatchAttributes");
        }
        var baseUrl = "/StudentInfos/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    studentInfoPrototypeUpdateExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoPrototypeUpdateExam");
        }
        var baseUrl = "/StudentInfos/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentInfoReplaceByIdPostStudentInfosidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoReplaceByIdPostStudentInfosidReplace");
        }
        var baseUrl = "/StudentInfos/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentInfoReplaceByIdPutStudentInfosid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentInfoReplaceByIdPutStudentInfosid");
        }
        var baseUrl = "/StudentInfos/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate: function (params, options) {
        var baseUrl = "/StudentInfos/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoReplaceOrCreatePutStudentInfos: function (params, options) {
        var baseUrl = "/StudentInfos";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentInfoUpdateAll: function (params, options) {
        var baseUrl = "/StudentInfos/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentInfoUpsertWithWhere: function (params, options) {
        var baseUrl = "/StudentInfos/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * StudentInfoApi - functional programming interface
 */
export var StudentInfoApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentInfoCount: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentInfoCreate: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentInfoCreateChangeStreamGetStudentInfosChangeStream: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoCreateChangeStreamGetStudentInfosChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentInfoCreateChangeStreamPostStudentInfosChangeStream: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoCreateChangeStreamPostStudentInfosChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentInfoDeleteById: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentInfoExistsGetStudentInfosidExists: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoExistsGetStudentInfosidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentInfoExistsHeadStudentInfosid: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoExistsHeadStudentInfosid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentInfoFind: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentInfoFindById: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentInfoFindOne: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoPatchOrCreate: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    studentInfoPrototypeCreateExam: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypeCreateExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes exam of this model.
     * @param id StudentInfo id
     */
    studentInfoPrototypeDestroyExam: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypeDestroyExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id StudentInfo id
     * @param refresh
     */
    studentInfoPrototypeGetExam: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypeGetExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id StudentInfo id
     * @param refresh
     */
    studentInfoPrototypeGetTest: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypeGetTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentInfo id
     * @param data An object of model property name/value pairs
     */
    studentInfoPrototypePatchAttributes: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    studentInfoPrototypeUpdateExam: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoPrototypeUpdateExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentInfoReplaceByIdPostStudentInfosidReplace: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoReplaceByIdPostStudentInfosidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentInfoReplaceByIdPutStudentInfosid: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoReplaceByIdPutStudentInfosid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentInfoReplaceOrCreatePutStudentInfos: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoReplaceOrCreatePutStudentInfos(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentInfoUpdateAll: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentInfoUpsertWithWhere: function (params, options) {
        var fetchArgs = StudentInfoApiFetchParamCreator.studentInfoUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * StudentInfoApi - object-oriented interface
 */
var StudentInfoApi = /** @class */ (function (_super) {
    __extends(StudentInfoApi, _super);
    function StudentInfoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    StudentInfoApi.prototype.studentInfoCount = function (params, options) {
        return StudentInfoApiFp.studentInfoCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoCreate = function (params, options) {
        return StudentInfoApiFp.studentInfoCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentInfoApi.prototype.studentInfoCreateChangeStreamGetStudentInfosChangeStream = function (params, options) {
        return StudentInfoApiFp.studentInfoCreateChangeStreamGetStudentInfosChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentInfoApi.prototype.studentInfoCreateChangeStreamPostStudentInfosChangeStream = function (params, options) {
        return StudentInfoApiFp.studentInfoCreateChangeStreamPostStudentInfosChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    StudentInfoApi.prototype.studentInfoDeleteById = function (params, options) {
        return StudentInfoApiFp.studentInfoDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentInfoApi.prototype.studentInfoExistsGetStudentInfosidExists = function (params, options) {
        return StudentInfoApiFp.studentInfoExistsGetStudentInfosidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentInfoApi.prototype.studentInfoExistsHeadStudentInfosid = function (params, options) {
        return StudentInfoApiFp.studentInfoExistsHeadStudentInfosid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentInfoApi.prototype.studentInfoFind = function (params, options) {
        return StudentInfoApiFp.studentInfoFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    StudentInfoApi.prototype.studentInfoFindById = function (params, options) {
        return StudentInfoApiFp.studentInfoFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentInfoApi.prototype.studentInfoFindOne = function (params, options) {
        return StudentInfoApiFp.studentInfoFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoPatchOrCreate = function (params, options) {
        return StudentInfoApiFp.studentInfoPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    StudentInfoApi.prototype.studentInfoPrototypeCreateExam = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypeCreateExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes exam of this model.
     * @param id StudentInfo id
     */
    StudentInfoApi.prototype.studentInfoPrototypeDestroyExam = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypeDestroyExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches hasOne relation exam.
     * @param id StudentInfo id
     * @param refresh
     */
    StudentInfoApi.prototype.studentInfoPrototypeGetExam = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypeGetExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id StudentInfo id
     * @param refresh
     */
    StudentInfoApi.prototype.studentInfoPrototypeGetTest = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypeGetTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentInfo id
     * @param data An object of model property name/value pairs
     */
    StudentInfoApi.prototype.studentInfoPrototypePatchAttributes = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update exam of this model.
     * @param id StudentInfo id
     * @param data
     */
    StudentInfoApi.prototype.studentInfoPrototypeUpdateExam = function (params, options) {
        return StudentInfoApiFp.studentInfoPrototypeUpdateExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoReplaceByIdPostStudentInfosidReplace = function (params, options) {
        return StudentInfoApiFp.studentInfoReplaceByIdPostStudentInfosidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoReplaceByIdPutStudentInfosid = function (params, options) {
        return StudentInfoApiFp.studentInfoReplaceByIdPutStudentInfosid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate = function (params, options) {
        return StudentInfoApiFp.studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentInfoApi.prototype.studentInfoReplaceOrCreatePutStudentInfos = function (params, options) {
        return StudentInfoApiFp.studentInfoReplaceOrCreatePutStudentInfos(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentInfoApi.prototype.studentInfoUpdateAll = function (params, options) {
        return StudentInfoApiFp.studentInfoUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentInfoApi.prototype.studentInfoUpsertWithWhere = function (params, options) {
        return StudentInfoApiFp.studentInfoUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return StudentInfoApi;
}(BaseAPI));
export { StudentInfoApi };
/**
 * StudentInfoApi - factory interface
 */
export var StudentInfoApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        studentInfoCount: function (params, options) {
            return StudentInfoApiFp.studentInfoCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        studentInfoCreate: function (params, options) {
            return StudentInfoApiFp.studentInfoCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentInfoCreateChangeStreamGetStudentInfosChangeStream: function (params, options) {
            return StudentInfoApiFp.studentInfoCreateChangeStreamGetStudentInfosChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentInfoCreateChangeStreamPostStudentInfosChangeStream: function (params, options) {
            return StudentInfoApiFp.studentInfoCreateChangeStreamPostStudentInfosChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        studentInfoDeleteById: function (params, options) {
            return StudentInfoApiFp.studentInfoDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentInfoExistsGetStudentInfosidExists: function (params, options) {
            return StudentInfoApiFp.studentInfoExistsGetStudentInfosidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentInfoExistsHeadStudentInfosid: function (params, options) {
            return StudentInfoApiFp.studentInfoExistsHeadStudentInfosid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentInfoFind: function (params, options) {
            return StudentInfoApiFp.studentInfoFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        studentInfoFindById: function (params, options) {
            return StudentInfoApiFp.studentInfoFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentInfoFindOne: function (params, options) {
            return StudentInfoApiFp.studentInfoFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentInfoPatchOrCreate: function (params, options) {
            return StudentInfoApiFp.studentInfoPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in exam of this model.
         * @param id StudentInfo id
         * @param data
         */
        studentInfoPrototypeCreateExam: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypeCreateExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes exam of this model.
         * @param id StudentInfo id
         */
        studentInfoPrototypeDestroyExam: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypeDestroyExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches hasOne relation exam.
         * @param id StudentInfo id
         * @param refresh
         */
        studentInfoPrototypeGetExam: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypeGetExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation test.
         * @param id StudentInfo id
         * @param refresh
         */
        studentInfoPrototypeGetTest: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypeGetTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id StudentInfo id
         * @param data An object of model property name/value pairs
         */
        studentInfoPrototypePatchAttributes: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update exam of this model.
         * @param id StudentInfo id
         * @param data
         */
        studentInfoPrototypeUpdateExam: function (params, options) {
            return StudentInfoApiFp.studentInfoPrototypeUpdateExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentInfoReplaceByIdPostStudentInfosidReplace: function (params, options) {
            return StudentInfoApiFp.studentInfoReplaceByIdPostStudentInfosidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentInfoReplaceByIdPutStudentInfosid: function (params, options) {
            return StudentInfoApiFp.studentInfoReplaceByIdPutStudentInfosid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate: function (params, options) {
            return StudentInfoApiFp.studentInfoReplaceOrCreatePostStudentInfosReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentInfoReplaceOrCreatePutStudentInfos: function (params, options) {
            return StudentInfoApiFp.studentInfoReplaceOrCreatePutStudentInfos(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentInfoUpdateAll: function (params, options) {
            return StudentInfoApiFp.studentInfoUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentInfoUpsertWithWhere: function (params, options) {
            return StudentInfoApiFp.studentInfoUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * StudentRoundApi - fetch parameter creator
 */
export var StudentRoundApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentRoundCount: function (params, options) {
        var baseUrl = "/StudentRounds/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentRoundCreate: function (params, options) {
        var baseUrl = "/StudentRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentRoundCreateChangeStreamGetStudentRoundsChangeStream: function (params, options) {
        var baseUrl = "/StudentRounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentRoundCreateChangeStreamPostStudentRoundsChangeStream: function (params, options) {
        var baseUrl = "/StudentRounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentRoundDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundDeleteById");
        }
        var baseUrl = "/StudentRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentRoundExistsGetStudentRoundsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundExistsGetStudentRoundsidExists");
        }
        var baseUrl = "/StudentRounds/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentRoundExistsHeadStudentRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundExistsHeadStudentRoundsid");
        }
        var baseUrl = "/StudentRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentRoundFind: function (params, options) {
        var baseUrl = "/StudentRounds";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentRoundFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundFindById");
        }
        var baseUrl = "/StudentRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentRoundFindOne: function (params, options) {
        var baseUrl = "/StudentRounds/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundPatchOrCreate: function (params, options) {
        var baseUrl = "/StudentRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id StudentRound id
     * @param refresh
     */
    studentRoundPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundPrototypeGetAccount");
        }
        var baseUrl = "/StudentRounds/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id StudentRound id
     * @param refresh
     */
    studentRoundPrototypeGetRound: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundPrototypeGetRound");
        }
        var baseUrl = "/StudentRounds/{id}/round".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentRound id
     * @param data An object of model property name/value pairs
     */
    studentRoundPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundPrototypePatchAttributes");
        }
        var baseUrl = "/StudentRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentRoundReplaceByIdPostStudentRoundsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundReplaceByIdPostStudentRoundsidReplace");
        }
        var baseUrl = "/StudentRounds/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentRoundReplaceByIdPutStudentRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling studentRoundReplaceByIdPutStudentRoundsid");
        }
        var baseUrl = "/StudentRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate: function (params, options) {
        var baseUrl = "/StudentRounds/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundReplaceOrCreatePutStudentRounds: function (params, options) {
        var baseUrl = "/StudentRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentRoundUpdateAll: function (params, options) {
        var baseUrl = "/StudentRounds/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentRoundUpsertWithWhere: function (params, options) {
        var baseUrl = "/StudentRounds/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * StudentRoundApi - functional programming interface
 */
export var StudentRoundApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    studentRoundCount: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    studentRoundCreate: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentRoundCreateChangeStreamGetStudentRoundsChangeStream: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundCreateChangeStreamGetStudentRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    studentRoundCreateChangeStreamPostStudentRoundsChangeStream: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundCreateChangeStreamPostStudentRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    studentRoundDeleteById: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentRoundExistsGetStudentRoundsidExists: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundExistsGetStudentRoundsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    studentRoundExistsHeadStudentRoundsid: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundExistsHeadStudentRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentRoundFind: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    studentRoundFindById: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    studentRoundFindOne: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundPatchOrCreate: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id StudentRound id
     * @param refresh
     */
    studentRoundPrototypeGetAccount: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id StudentRound id
     * @param refresh
     */
    studentRoundPrototypeGetRound: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundPrototypeGetRound(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentRound id
     * @param data An object of model property name/value pairs
     */
    studentRoundPrototypePatchAttributes: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentRoundReplaceByIdPostStudentRoundsidReplace: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundReplaceByIdPostStudentRoundsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    studentRoundReplaceByIdPutStudentRoundsid: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundReplaceByIdPutStudentRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    studentRoundReplaceOrCreatePutStudentRounds: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundReplaceOrCreatePutStudentRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentRoundUpdateAll: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    studentRoundUpsertWithWhere: function (params, options) {
        var fetchArgs = StudentRoundApiFetchParamCreator.studentRoundUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * StudentRoundApi - object-oriented interface
 */
var StudentRoundApi = /** @class */ (function (_super) {
    __extends(StudentRoundApi, _super);
    function StudentRoundApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    StudentRoundApi.prototype.studentRoundCount = function (params, options) {
        return StudentRoundApiFp.studentRoundCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundCreate = function (params, options) {
        return StudentRoundApiFp.studentRoundCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentRoundApi.prototype.studentRoundCreateChangeStreamGetStudentRoundsChangeStream = function (params, options) {
        return StudentRoundApiFp.studentRoundCreateChangeStreamGetStudentRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    StudentRoundApi.prototype.studentRoundCreateChangeStreamPostStudentRoundsChangeStream = function (params, options) {
        return StudentRoundApiFp.studentRoundCreateChangeStreamPostStudentRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    StudentRoundApi.prototype.studentRoundDeleteById = function (params, options) {
        return StudentRoundApiFp.studentRoundDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentRoundApi.prototype.studentRoundExistsGetStudentRoundsidExists = function (params, options) {
        return StudentRoundApiFp.studentRoundExistsGetStudentRoundsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    StudentRoundApi.prototype.studentRoundExistsHeadStudentRoundsid = function (params, options) {
        return StudentRoundApiFp.studentRoundExistsHeadStudentRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentRoundApi.prototype.studentRoundFind = function (params, options) {
        return StudentRoundApiFp.studentRoundFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    StudentRoundApi.prototype.studentRoundFindById = function (params, options) {
        return StudentRoundApiFp.studentRoundFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    StudentRoundApi.prototype.studentRoundFindOne = function (params, options) {
        return StudentRoundApiFp.studentRoundFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundPatchOrCreate = function (params, options) {
        return StudentRoundApiFp.studentRoundPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id StudentRound id
     * @param refresh
     */
    StudentRoundApi.prototype.studentRoundPrototypeGetAccount = function (params, options) {
        return StudentRoundApiFp.studentRoundPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id StudentRound id
     * @param refresh
     */
    StudentRoundApi.prototype.studentRoundPrototypeGetRound = function (params, options) {
        return StudentRoundApiFp.studentRoundPrototypeGetRound(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id StudentRound id
     * @param data An object of model property name/value pairs
     */
    StudentRoundApi.prototype.studentRoundPrototypePatchAttributes = function (params, options) {
        return StudentRoundApiFp.studentRoundPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundReplaceByIdPostStudentRoundsidReplace = function (params, options) {
        return StudentRoundApiFp.studentRoundReplaceByIdPostStudentRoundsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundReplaceByIdPutStudentRoundsid = function (params, options) {
        return StudentRoundApiFp.studentRoundReplaceByIdPutStudentRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate = function (params, options) {
        return StudentRoundApiFp.studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    StudentRoundApi.prototype.studentRoundReplaceOrCreatePutStudentRounds = function (params, options) {
        return StudentRoundApiFp.studentRoundReplaceOrCreatePutStudentRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentRoundApi.prototype.studentRoundUpdateAll = function (params, options) {
        return StudentRoundApiFp.studentRoundUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    StudentRoundApi.prototype.studentRoundUpsertWithWhere = function (params, options) {
        return StudentRoundApiFp.studentRoundUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return StudentRoundApi;
}(BaseAPI));
export { StudentRoundApi };
/**
 * StudentRoundApi - factory interface
 */
export var StudentRoundApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        studentRoundCount: function (params, options) {
            return StudentRoundApiFp.studentRoundCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        studentRoundCreate: function (params, options) {
            return StudentRoundApiFp.studentRoundCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentRoundCreateChangeStreamGetStudentRoundsChangeStream: function (params, options) {
            return StudentRoundApiFp.studentRoundCreateChangeStreamGetStudentRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        studentRoundCreateChangeStreamPostStudentRoundsChangeStream: function (params, options) {
            return StudentRoundApiFp.studentRoundCreateChangeStreamPostStudentRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        studentRoundDeleteById: function (params, options) {
            return StudentRoundApiFp.studentRoundDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentRoundExistsGetStudentRoundsidExists: function (params, options) {
            return StudentRoundApiFp.studentRoundExistsGetStudentRoundsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        studentRoundExistsHeadStudentRoundsid: function (params, options) {
            return StudentRoundApiFp.studentRoundExistsHeadStudentRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentRoundFind: function (params, options) {
            return StudentRoundApiFp.studentRoundFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        studentRoundFindById: function (params, options) {
            return StudentRoundApiFp.studentRoundFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        studentRoundFindOne: function (params, options) {
            return StudentRoundApiFp.studentRoundFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentRoundPatchOrCreate: function (params, options) {
            return StudentRoundApiFp.studentRoundPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id StudentRound id
         * @param refresh
         */
        studentRoundPrototypeGetAccount: function (params, options) {
            return StudentRoundApiFp.studentRoundPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation round.
         * @param id StudentRound id
         * @param refresh
         */
        studentRoundPrototypeGetRound: function (params, options) {
            return StudentRoundApiFp.studentRoundPrototypeGetRound(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id StudentRound id
         * @param data An object of model property name/value pairs
         */
        studentRoundPrototypePatchAttributes: function (params, options) {
            return StudentRoundApiFp.studentRoundPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentRoundReplaceByIdPostStudentRoundsidReplace: function (params, options) {
            return StudentRoundApiFp.studentRoundReplaceByIdPostStudentRoundsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        studentRoundReplaceByIdPutStudentRoundsid: function (params, options) {
            return StudentRoundApiFp.studentRoundReplaceByIdPutStudentRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate: function (params, options) {
            return StudentRoundApiFp.studentRoundReplaceOrCreatePostStudentRoundsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        studentRoundReplaceOrCreatePutStudentRounds: function (params, options) {
            return StudentRoundApiFp.studentRoundReplaceOrCreatePutStudentRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentRoundUpdateAll: function (params, options) {
            return StudentRoundApiFp.studentRoundUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        studentRoundUpsertWithWhere: function (params, options) {
            return StudentRoundApiFp.studentRoundUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * SubmitExamApi - fetch parameter creator
 */
export var SubmitExamApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    submitExamCount: function (params, options) {
        var baseUrl = "/SubmitExams/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    submitExamCreate: function (params, options) {
        var baseUrl = "/SubmitExams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    submitExamCreateChangeStreamGetSubmitExamsChangeStream: function (params, options) {
        var baseUrl = "/SubmitExams/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    submitExamCreateChangeStreamPostSubmitExamsChangeStream: function (params, options) {
        var baseUrl = "/SubmitExams/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    submitExamDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamDeleteById");
        }
        var baseUrl = "/SubmitExams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    submitExamExistsGetSubmitExamsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamExistsGetSubmitExamsidExists");
        }
        var baseUrl = "/SubmitExams/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    submitExamExistsHeadSubmitExamsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamExistsHeadSubmitExamsid");
        }
        var baseUrl = "/SubmitExams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    submitExamFind: function (params, options) {
        var baseUrl = "/SubmitExams";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    submitExamFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamFindById");
        }
        var baseUrl = "/SubmitExams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    submitExamFindOne: function (params, options) {
        var baseUrl = "/SubmitExams/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamPatchOrCreate: function (params, options) {
        var baseUrl = "/SubmitExams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation exam.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamPrototypeGetExam");
        }
        var baseUrl = "/SubmitExams/{id}/exam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetStudent: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamPrototypeGetStudent");
        }
        var baseUrl = "/SubmitExams/{id}/student".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetTest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamPrototypeGetTest");
        }
        var baseUrl = "/SubmitExams/{id}/test".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id SubmitExam id
     * @param data An object of model property name/value pairs
     */
    submitExamPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamPrototypePatchAttributes");
        }
        var baseUrl = "/SubmitExams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    submitExamReplaceByIdPostSubmitExamsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamReplaceByIdPostSubmitExamsidReplace");
        }
        var baseUrl = "/SubmitExams/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    submitExamReplaceByIdPutSubmitExamsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling submitExamReplaceByIdPutSubmitExamsid");
        }
        var baseUrl = "/SubmitExams/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate: function (params, options) {
        var baseUrl = "/SubmitExams/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamReplaceOrCreatePutSubmitExams: function (params, options) {
        var baseUrl = "/SubmitExams";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    submitExamUpdateAll: function (params, options) {
        var baseUrl = "/SubmitExams/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    submitExamUpsertWithWhere: function (params, options) {
        var baseUrl = "/SubmitExams/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * SubmitExamApi - functional programming interface
 */
export var SubmitExamApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    submitExamCount: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    submitExamCreate: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    submitExamCreateChangeStreamGetSubmitExamsChangeStream: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamCreateChangeStreamGetSubmitExamsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    submitExamCreateChangeStreamPostSubmitExamsChangeStream: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamCreateChangeStreamPostSubmitExamsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    submitExamDeleteById: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    submitExamExistsGetSubmitExamsidExists: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamExistsGetSubmitExamsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    submitExamExistsHeadSubmitExamsid: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamExistsHeadSubmitExamsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    submitExamFind: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    submitExamFindById: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    submitExamFindOne: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamPatchOrCreate: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation exam.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetExam: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamPrototypeGetExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetStudent: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamPrototypeGetStudent(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id SubmitExam id
     * @param refresh
     */
    submitExamPrototypeGetTest: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamPrototypeGetTest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id SubmitExam id
     * @param data An object of model property name/value pairs
     */
    submitExamPrototypePatchAttributes: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    submitExamReplaceByIdPostSubmitExamsidReplace: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamReplaceByIdPostSubmitExamsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    submitExamReplaceByIdPutSubmitExamsid: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamReplaceByIdPutSubmitExamsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    submitExamReplaceOrCreatePutSubmitExams: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamReplaceOrCreatePutSubmitExams(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    submitExamUpdateAll: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    submitExamUpsertWithWhere: function (params, options) {
        var fetchArgs = SubmitExamApiFetchParamCreator.submitExamUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * SubmitExamApi - object-oriented interface
 */
var SubmitExamApi = /** @class */ (function (_super) {
    __extends(SubmitExamApi, _super);
    function SubmitExamApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    SubmitExamApi.prototype.submitExamCount = function (params, options) {
        return SubmitExamApiFp.submitExamCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamCreate = function (params, options) {
        return SubmitExamApiFp.submitExamCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    SubmitExamApi.prototype.submitExamCreateChangeStreamGetSubmitExamsChangeStream = function (params, options) {
        return SubmitExamApiFp.submitExamCreateChangeStreamGetSubmitExamsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    SubmitExamApi.prototype.submitExamCreateChangeStreamPostSubmitExamsChangeStream = function (params, options) {
        return SubmitExamApiFp.submitExamCreateChangeStreamPostSubmitExamsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    SubmitExamApi.prototype.submitExamDeleteById = function (params, options) {
        return SubmitExamApiFp.submitExamDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    SubmitExamApi.prototype.submitExamExistsGetSubmitExamsidExists = function (params, options) {
        return SubmitExamApiFp.submitExamExistsGetSubmitExamsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    SubmitExamApi.prototype.submitExamExistsHeadSubmitExamsid = function (params, options) {
        return SubmitExamApiFp.submitExamExistsHeadSubmitExamsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    SubmitExamApi.prototype.submitExamFind = function (params, options) {
        return SubmitExamApiFp.submitExamFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    SubmitExamApi.prototype.submitExamFindById = function (params, options) {
        return SubmitExamApiFp.submitExamFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    SubmitExamApi.prototype.submitExamFindOne = function (params, options) {
        return SubmitExamApiFp.submitExamFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamPatchOrCreate = function (params, options) {
        return SubmitExamApiFp.submitExamPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation exam.
     * @param id SubmitExam id
     * @param refresh
     */
    SubmitExamApi.prototype.submitExamPrototypeGetExam = function (params, options) {
        return SubmitExamApiFp.submitExamPrototypeGetExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation student.
     * @param id SubmitExam id
     * @param refresh
     */
    SubmitExamApi.prototype.submitExamPrototypeGetStudent = function (params, options) {
        return SubmitExamApiFp.submitExamPrototypeGetStudent(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation test.
     * @param id SubmitExam id
     * @param refresh
     */
    SubmitExamApi.prototype.submitExamPrototypeGetTest = function (params, options) {
        return SubmitExamApiFp.submitExamPrototypeGetTest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id SubmitExam id
     * @param data An object of model property name/value pairs
     */
    SubmitExamApi.prototype.submitExamPrototypePatchAttributes = function (params, options) {
        return SubmitExamApiFp.submitExamPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamReplaceByIdPostSubmitExamsidReplace = function (params, options) {
        return SubmitExamApiFp.submitExamReplaceByIdPostSubmitExamsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamReplaceByIdPutSubmitExamsid = function (params, options) {
        return SubmitExamApiFp.submitExamReplaceByIdPutSubmitExamsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate = function (params, options) {
        return SubmitExamApiFp.submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    SubmitExamApi.prototype.submitExamReplaceOrCreatePutSubmitExams = function (params, options) {
        return SubmitExamApiFp.submitExamReplaceOrCreatePutSubmitExams(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    SubmitExamApi.prototype.submitExamUpdateAll = function (params, options) {
        return SubmitExamApiFp.submitExamUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    SubmitExamApi.prototype.submitExamUpsertWithWhere = function (params, options) {
        return SubmitExamApiFp.submitExamUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return SubmitExamApi;
}(BaseAPI));
export { SubmitExamApi };
/**
 * SubmitExamApi - factory interface
 */
export var SubmitExamApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        submitExamCount: function (params, options) {
            return SubmitExamApiFp.submitExamCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        submitExamCreate: function (params, options) {
            return SubmitExamApiFp.submitExamCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        submitExamCreateChangeStreamGetSubmitExamsChangeStream: function (params, options) {
            return SubmitExamApiFp.submitExamCreateChangeStreamGetSubmitExamsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        submitExamCreateChangeStreamPostSubmitExamsChangeStream: function (params, options) {
            return SubmitExamApiFp.submitExamCreateChangeStreamPostSubmitExamsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        submitExamDeleteById: function (params, options) {
            return SubmitExamApiFp.submitExamDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        submitExamExistsGetSubmitExamsidExists: function (params, options) {
            return SubmitExamApiFp.submitExamExistsGetSubmitExamsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        submitExamExistsHeadSubmitExamsid: function (params, options) {
            return SubmitExamApiFp.submitExamExistsHeadSubmitExamsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        submitExamFind: function (params, options) {
            return SubmitExamApiFp.submitExamFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        submitExamFindById: function (params, options) {
            return SubmitExamApiFp.submitExamFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        submitExamFindOne: function (params, options) {
            return SubmitExamApiFp.submitExamFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        submitExamPatchOrCreate: function (params, options) {
            return SubmitExamApiFp.submitExamPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation exam.
         * @param id SubmitExam id
         * @param refresh
         */
        submitExamPrototypeGetExam: function (params, options) {
            return SubmitExamApiFp.submitExamPrototypeGetExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation student.
         * @param id SubmitExam id
         * @param refresh
         */
        submitExamPrototypeGetStudent: function (params, options) {
            return SubmitExamApiFp.submitExamPrototypeGetStudent(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation test.
         * @param id SubmitExam id
         * @param refresh
         */
        submitExamPrototypeGetTest: function (params, options) {
            return SubmitExamApiFp.submitExamPrototypeGetTest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id SubmitExam id
         * @param data An object of model property name/value pairs
         */
        submitExamPrototypePatchAttributes: function (params, options) {
            return SubmitExamApiFp.submitExamPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        submitExamReplaceByIdPostSubmitExamsidReplace: function (params, options) {
            return SubmitExamApiFp.submitExamReplaceByIdPostSubmitExamsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        submitExamReplaceByIdPutSubmitExamsid: function (params, options) {
            return SubmitExamApiFp.submitExamReplaceByIdPutSubmitExamsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate: function (params, options) {
            return SubmitExamApiFp.submitExamReplaceOrCreatePostSubmitExamsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        submitExamReplaceOrCreatePutSubmitExams: function (params, options) {
            return SubmitExamApiFp.submitExamReplaceOrCreatePutSubmitExams(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        submitExamUpdateAll: function (params, options) {
            return SubmitExamApiFp.submitExamUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        submitExamUpsertWithWhere: function (params, options) {
            return SubmitExamApiFp.submitExamUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * TeacherContestApi - fetch parameter creator
 */
export var TeacherContestApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    teacherContestCount: function (params, options) {
        var baseUrl = "/TeacherContests/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    teacherContestCreate: function (params, options) {
        var baseUrl = "/TeacherContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherContestCreateChangeStreamGetTeacherContestsChangeStream: function (params, options) {
        var baseUrl = "/TeacherContests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherContestCreateChangeStreamPostTeacherContestsChangeStream: function (params, options) {
        var baseUrl = "/TeacherContests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    teacherContestDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestDeleteById");
        }
        var baseUrl = "/TeacherContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherContestExistsGetTeacherContestsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestExistsGetTeacherContestsidExists");
        }
        var baseUrl = "/TeacherContests/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherContestExistsHeadTeacherContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestExistsHeadTeacherContestsid");
        }
        var baseUrl = "/TeacherContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherContestFind: function (params, options) {
        var baseUrl = "/TeacherContests";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    teacherContestFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestFindById");
        }
        var baseUrl = "/TeacherContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherContestFindOne: function (params, options) {
        var baseUrl = "/TeacherContests/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestPatchOrCreate: function (params, options) {
        var baseUrl = "/TeacherContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id TeacherContest id
     * @param refresh
     */
    teacherContestPrototypeGetContest: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestPrototypeGetContest");
        }
        var baseUrl = "/TeacherContests/{id}/contest".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherContest id
     * @param refresh
     */
    teacherContestPrototypeGetTeacher: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestPrototypeGetTeacher");
        }
        var baseUrl = "/TeacherContests/{id}/teacher".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherContest id
     * @param data An object of model property name/value pairs
     */
    teacherContestPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestPrototypePatchAttributes");
        }
        var baseUrl = "/TeacherContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherContestReplaceByIdPostTeacherContestsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestReplaceByIdPostTeacherContestsidReplace");
        }
        var baseUrl = "/TeacherContests/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherContestReplaceByIdPutTeacherContestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherContestReplaceByIdPutTeacherContestsid");
        }
        var baseUrl = "/TeacherContests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate: function (params, options) {
        var baseUrl = "/TeacherContests/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestReplaceOrCreatePutTeacherContests: function (params, options) {
        var baseUrl = "/TeacherContests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherContestUpdateAll: function (params, options) {
        var baseUrl = "/TeacherContests/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherContestUpsertWithWhere: function (params, options) {
        var baseUrl = "/TeacherContests/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * TeacherContestApi - functional programming interface
 */
export var TeacherContestApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    teacherContestCount: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    teacherContestCreate: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherContestCreateChangeStreamGetTeacherContestsChangeStream: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestCreateChangeStreamGetTeacherContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherContestCreateChangeStreamPostTeacherContestsChangeStream: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestCreateChangeStreamPostTeacherContestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    teacherContestDeleteById: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherContestExistsGetTeacherContestsidExists: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestExistsGetTeacherContestsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherContestExistsHeadTeacherContestsid: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestExistsHeadTeacherContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherContestFind: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    teacherContestFindById: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherContestFindOne: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestPatchOrCreate: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id TeacherContest id
     * @param refresh
     */
    teacherContestPrototypeGetContest: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestPrototypeGetContest(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherContest id
     * @param refresh
     */
    teacherContestPrototypeGetTeacher: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestPrototypeGetTeacher(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherContest id
     * @param data An object of model property name/value pairs
     */
    teacherContestPrototypePatchAttributes: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherContestReplaceByIdPostTeacherContestsidReplace: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestReplaceByIdPostTeacherContestsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherContestReplaceByIdPutTeacherContestsid: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestReplaceByIdPutTeacherContestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherContestReplaceOrCreatePutTeacherContests: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestReplaceOrCreatePutTeacherContests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherContestUpdateAll: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherContestUpsertWithWhere: function (params, options) {
        var fetchArgs = TeacherContestApiFetchParamCreator.teacherContestUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * TeacherContestApi - object-oriented interface
 */
var TeacherContestApi = /** @class */ (function (_super) {
    __extends(TeacherContestApi, _super);
    function TeacherContestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    TeacherContestApi.prototype.teacherContestCount = function (params, options) {
        return TeacherContestApiFp.teacherContestCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestCreate = function (params, options) {
        return TeacherContestApiFp.teacherContestCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TeacherContestApi.prototype.teacherContestCreateChangeStreamGetTeacherContestsChangeStream = function (params, options) {
        return TeacherContestApiFp.teacherContestCreateChangeStreamGetTeacherContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TeacherContestApi.prototype.teacherContestCreateChangeStreamPostTeacherContestsChangeStream = function (params, options) {
        return TeacherContestApiFp.teacherContestCreateChangeStreamPostTeacherContestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    TeacherContestApi.prototype.teacherContestDeleteById = function (params, options) {
        return TeacherContestApiFp.teacherContestDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TeacherContestApi.prototype.teacherContestExistsGetTeacherContestsidExists = function (params, options) {
        return TeacherContestApiFp.teacherContestExistsGetTeacherContestsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TeacherContestApi.prototype.teacherContestExistsHeadTeacherContestsid = function (params, options) {
        return TeacherContestApiFp.teacherContestExistsHeadTeacherContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TeacherContestApi.prototype.teacherContestFind = function (params, options) {
        return TeacherContestApiFp.teacherContestFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    TeacherContestApi.prototype.teacherContestFindById = function (params, options) {
        return TeacherContestApiFp.teacherContestFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TeacherContestApi.prototype.teacherContestFindOne = function (params, options) {
        return TeacherContestApiFp.teacherContestFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestPatchOrCreate = function (params, options) {
        return TeacherContestApiFp.teacherContestPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation contest.
     * @param id TeacherContest id
     * @param refresh
     */
    TeacherContestApi.prototype.teacherContestPrototypeGetContest = function (params, options) {
        return TeacherContestApiFp.teacherContestPrototypeGetContest(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherContest id
     * @param refresh
     */
    TeacherContestApi.prototype.teacherContestPrototypeGetTeacher = function (params, options) {
        return TeacherContestApiFp.teacherContestPrototypeGetTeacher(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherContest id
     * @param data An object of model property name/value pairs
     */
    TeacherContestApi.prototype.teacherContestPrototypePatchAttributes = function (params, options) {
        return TeacherContestApiFp.teacherContestPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestReplaceByIdPostTeacherContestsidReplace = function (params, options) {
        return TeacherContestApiFp.teacherContestReplaceByIdPostTeacherContestsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestReplaceByIdPutTeacherContestsid = function (params, options) {
        return TeacherContestApiFp.teacherContestReplaceByIdPutTeacherContestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate = function (params, options) {
        return TeacherContestApiFp.teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherContestApi.prototype.teacherContestReplaceOrCreatePutTeacherContests = function (params, options) {
        return TeacherContestApiFp.teacherContestReplaceOrCreatePutTeacherContests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TeacherContestApi.prototype.teacherContestUpdateAll = function (params, options) {
        return TeacherContestApiFp.teacherContestUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TeacherContestApi.prototype.teacherContestUpsertWithWhere = function (params, options) {
        return TeacherContestApiFp.teacherContestUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return TeacherContestApi;
}(BaseAPI));
export { TeacherContestApi };
/**
 * TeacherContestApi - factory interface
 */
export var TeacherContestApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        teacherContestCount: function (params, options) {
            return TeacherContestApiFp.teacherContestCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        teacherContestCreate: function (params, options) {
            return TeacherContestApiFp.teacherContestCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        teacherContestCreateChangeStreamGetTeacherContestsChangeStream: function (params, options) {
            return TeacherContestApiFp.teacherContestCreateChangeStreamGetTeacherContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        teacherContestCreateChangeStreamPostTeacherContestsChangeStream: function (params, options) {
            return TeacherContestApiFp.teacherContestCreateChangeStreamPostTeacherContestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        teacherContestDeleteById: function (params, options) {
            return TeacherContestApiFp.teacherContestDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        teacherContestExistsGetTeacherContestsidExists: function (params, options) {
            return TeacherContestApiFp.teacherContestExistsGetTeacherContestsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        teacherContestExistsHeadTeacherContestsid: function (params, options) {
            return TeacherContestApiFp.teacherContestExistsHeadTeacherContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        teacherContestFind: function (params, options) {
            return TeacherContestApiFp.teacherContestFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        teacherContestFindById: function (params, options) {
            return TeacherContestApiFp.teacherContestFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        teacherContestFindOne: function (params, options) {
            return TeacherContestApiFp.teacherContestFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherContestPatchOrCreate: function (params, options) {
            return TeacherContestApiFp.teacherContestPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation contest.
         * @param id TeacherContest id
         * @param refresh
         */
        teacherContestPrototypeGetContest: function (params, options) {
            return TeacherContestApiFp.teacherContestPrototypeGetContest(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation teacher.
         * @param id TeacherContest id
         * @param refresh
         */
        teacherContestPrototypeGetTeacher: function (params, options) {
            return TeacherContestApiFp.teacherContestPrototypeGetTeacher(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id TeacherContest id
         * @param data An object of model property name/value pairs
         */
        teacherContestPrototypePatchAttributes: function (params, options) {
            return TeacherContestApiFp.teacherContestPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        teacherContestReplaceByIdPostTeacherContestsidReplace: function (params, options) {
            return TeacherContestApiFp.teacherContestReplaceByIdPostTeacherContestsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        teacherContestReplaceByIdPutTeacherContestsid: function (params, options) {
            return TeacherContestApiFp.teacherContestReplaceByIdPutTeacherContestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate: function (params, options) {
            return TeacherContestApiFp.teacherContestReplaceOrCreatePostTeacherContestsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherContestReplaceOrCreatePutTeacherContests: function (params, options) {
            return TeacherContestApiFp.teacherContestReplaceOrCreatePutTeacherContests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        teacherContestUpdateAll: function (params, options) {
            return TeacherContestApiFp.teacherContestUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        teacherContestUpsertWithWhere: function (params, options) {
            return TeacherContestApiFp.teacherContestUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * TeacherRoundApi - fetch parameter creator
 */
export var TeacherRoundApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    teacherRoundCount: function (params, options) {
        var baseUrl = "/TeacherRounds/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    teacherRoundCreate: function (params, options) {
        var baseUrl = "/TeacherRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream: function (params, options) {
        var baseUrl = "/TeacherRounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream: function (params, options) {
        var baseUrl = "/TeacherRounds/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    teacherRoundDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundDeleteById");
        }
        var baseUrl = "/TeacherRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherRoundExistsGetTeacherRoundsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundExistsGetTeacherRoundsidExists");
        }
        var baseUrl = "/TeacherRounds/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherRoundExistsHeadTeacherRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundExistsHeadTeacherRoundsid");
        }
        var baseUrl = "/TeacherRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherRoundFind: function (params, options) {
        var baseUrl = "/TeacherRounds";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    teacherRoundFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundFindById");
        }
        var baseUrl = "/TeacherRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherRoundFindOne: function (params, options) {
        var baseUrl = "/TeacherRounds/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundPatchOrCreate: function (params, options) {
        var baseUrl = "/TeacherRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id TeacherRound id
     * @param refresh
     */
    teacherRoundPrototypeGetRound: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundPrototypeGetRound");
        }
        var baseUrl = "/TeacherRounds/{id}/round".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherRound id
     * @param refresh
     */
    teacherRoundPrototypeGetTeacher: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundPrototypeGetTeacher");
        }
        var baseUrl = "/TeacherRounds/{id}/teacher".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherRound id
     * @param data An object of model property name/value pairs
     */
    teacherRoundPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundPrototypePatchAttributes");
        }
        var baseUrl = "/TeacherRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherRoundReplaceByIdPostTeacherRoundsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundReplaceByIdPostTeacherRoundsidReplace");
        }
        var baseUrl = "/TeacherRounds/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherRoundReplaceByIdPutTeacherRoundsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling teacherRoundReplaceByIdPutTeacherRoundsid");
        }
        var baseUrl = "/TeacherRounds/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate: function (params, options) {
        var baseUrl = "/TeacherRounds/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundReplaceOrCreatePutTeacherRounds: function (params, options) {
        var baseUrl = "/TeacherRounds";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherRoundUpdateAll: function (params, options) {
        var baseUrl = "/TeacherRounds/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherRoundUpsertWithWhere: function (params, options) {
        var baseUrl = "/TeacherRounds/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * TeacherRoundApi - functional programming interface
 */
export var TeacherRoundApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    teacherRoundCount: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    teacherRoundCreate: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    teacherRoundDeleteById: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherRoundExistsGetTeacherRoundsidExists: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundExistsGetTeacherRoundsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    teacherRoundExistsHeadTeacherRoundsid: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundExistsHeadTeacherRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherRoundFind: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    teacherRoundFindById: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    teacherRoundFindOne: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundPatchOrCreate: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id TeacherRound id
     * @param refresh
     */
    teacherRoundPrototypeGetRound: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundPrototypeGetRound(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherRound id
     * @param refresh
     */
    teacherRoundPrototypeGetTeacher: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundPrototypeGetTeacher(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherRound id
     * @param data An object of model property name/value pairs
     */
    teacherRoundPrototypePatchAttributes: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherRoundReplaceByIdPostTeacherRoundsidReplace: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundReplaceByIdPostTeacherRoundsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    teacherRoundReplaceByIdPutTeacherRoundsid: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundReplaceByIdPutTeacherRoundsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    teacherRoundReplaceOrCreatePutTeacherRounds: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundReplaceOrCreatePutTeacherRounds(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherRoundUpdateAll: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    teacherRoundUpsertWithWhere: function (params, options) {
        var fetchArgs = TeacherRoundApiFetchParamCreator.teacherRoundUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * TeacherRoundApi - object-oriented interface
 */
var TeacherRoundApi = /** @class */ (function (_super) {
    __extends(TeacherRoundApi, _super);
    function TeacherRoundApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    TeacherRoundApi.prototype.teacherRoundCount = function (params, options) {
        return TeacherRoundApiFp.teacherRoundCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundCreate = function (params, options) {
        return TeacherRoundApiFp.teacherRoundCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TeacherRoundApi.prototype.teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream = function (params, options) {
        return TeacherRoundApiFp.teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TeacherRoundApi.prototype.teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream = function (params, options) {
        return TeacherRoundApiFp.teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    TeacherRoundApi.prototype.teacherRoundDeleteById = function (params, options) {
        return TeacherRoundApiFp.teacherRoundDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TeacherRoundApi.prototype.teacherRoundExistsGetTeacherRoundsidExists = function (params, options) {
        return TeacherRoundApiFp.teacherRoundExistsGetTeacherRoundsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TeacherRoundApi.prototype.teacherRoundExistsHeadTeacherRoundsid = function (params, options) {
        return TeacherRoundApiFp.teacherRoundExistsHeadTeacherRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TeacherRoundApi.prototype.teacherRoundFind = function (params, options) {
        return TeacherRoundApiFp.teacherRoundFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    TeacherRoundApi.prototype.teacherRoundFindById = function (params, options) {
        return TeacherRoundApiFp.teacherRoundFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TeacherRoundApi.prototype.teacherRoundFindOne = function (params, options) {
        return TeacherRoundApiFp.teacherRoundFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundPatchOrCreate = function (params, options) {
        return TeacherRoundApiFp.teacherRoundPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation round.
     * @param id TeacherRound id
     * @param refresh
     */
    TeacherRoundApi.prototype.teacherRoundPrototypeGetRound = function (params, options) {
        return TeacherRoundApiFp.teacherRoundPrototypeGetRound(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation teacher.
     * @param id TeacherRound id
     * @param refresh
     */
    TeacherRoundApi.prototype.teacherRoundPrototypeGetTeacher = function (params, options) {
        return TeacherRoundApiFp.teacherRoundPrototypeGetTeacher(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id TeacherRound id
     * @param data An object of model property name/value pairs
     */
    TeacherRoundApi.prototype.teacherRoundPrototypePatchAttributes = function (params, options) {
        return TeacherRoundApiFp.teacherRoundPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundReplaceByIdPostTeacherRoundsidReplace = function (params, options) {
        return TeacherRoundApiFp.teacherRoundReplaceByIdPostTeacherRoundsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundReplaceByIdPutTeacherRoundsid = function (params, options) {
        return TeacherRoundApiFp.teacherRoundReplaceByIdPutTeacherRoundsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate = function (params, options) {
        return TeacherRoundApiFp.teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TeacherRoundApi.prototype.teacherRoundReplaceOrCreatePutTeacherRounds = function (params, options) {
        return TeacherRoundApiFp.teacherRoundReplaceOrCreatePutTeacherRounds(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TeacherRoundApi.prototype.teacherRoundUpdateAll = function (params, options) {
        return TeacherRoundApiFp.teacherRoundUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TeacherRoundApi.prototype.teacherRoundUpsertWithWhere = function (params, options) {
        return TeacherRoundApiFp.teacherRoundUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return TeacherRoundApi;
}(BaseAPI));
export { TeacherRoundApi };
/**
 * TeacherRoundApi - factory interface
 */
export var TeacherRoundApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        teacherRoundCount: function (params, options) {
            return TeacherRoundApiFp.teacherRoundCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        teacherRoundCreate: function (params, options) {
            return TeacherRoundApiFp.teacherRoundCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream: function (params, options) {
            return TeacherRoundApiFp.teacherRoundCreateChangeStreamGetTeacherRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream: function (params, options) {
            return TeacherRoundApiFp.teacherRoundCreateChangeStreamPostTeacherRoundsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        teacherRoundDeleteById: function (params, options) {
            return TeacherRoundApiFp.teacherRoundDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        teacherRoundExistsGetTeacherRoundsidExists: function (params, options) {
            return TeacherRoundApiFp.teacherRoundExistsGetTeacherRoundsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        teacherRoundExistsHeadTeacherRoundsid: function (params, options) {
            return TeacherRoundApiFp.teacherRoundExistsHeadTeacherRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        teacherRoundFind: function (params, options) {
            return TeacherRoundApiFp.teacherRoundFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        teacherRoundFindById: function (params, options) {
            return TeacherRoundApiFp.teacherRoundFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        teacherRoundFindOne: function (params, options) {
            return TeacherRoundApiFp.teacherRoundFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherRoundPatchOrCreate: function (params, options) {
            return TeacherRoundApiFp.teacherRoundPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation round.
         * @param id TeacherRound id
         * @param refresh
         */
        teacherRoundPrototypeGetRound: function (params, options) {
            return TeacherRoundApiFp.teacherRoundPrototypeGetRound(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation teacher.
         * @param id TeacherRound id
         * @param refresh
         */
        teacherRoundPrototypeGetTeacher: function (params, options) {
            return TeacherRoundApiFp.teacherRoundPrototypeGetTeacher(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id TeacherRound id
         * @param data An object of model property name/value pairs
         */
        teacherRoundPrototypePatchAttributes: function (params, options) {
            return TeacherRoundApiFp.teacherRoundPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        teacherRoundReplaceByIdPostTeacherRoundsidReplace: function (params, options) {
            return TeacherRoundApiFp.teacherRoundReplaceByIdPostTeacherRoundsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        teacherRoundReplaceByIdPutTeacherRoundsid: function (params, options) {
            return TeacherRoundApiFp.teacherRoundReplaceByIdPutTeacherRoundsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate: function (params, options) {
            return TeacherRoundApiFp.teacherRoundReplaceOrCreatePostTeacherRoundsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        teacherRoundReplaceOrCreatePutTeacherRounds: function (params, options) {
            return TeacherRoundApiFp.teacherRoundReplaceOrCreatePutTeacherRounds(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        teacherRoundUpdateAll: function (params, options) {
            return TeacherRoundApiFp.teacherRoundUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        teacherRoundUpsertWithWhere: function (params, options) {
            return TeacherRoundApiFp.teacherRoundUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * TestApi - fetch parameter creator
 */
export var TestApiFetchParamCreator = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    testCount: function (params, options) {
        var baseUrl = "/Tests/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    testCreate: function (params, options) {
        var baseUrl = "/Tests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    testCreateChangeStreamGetTestsChangeStream: function (params, options) {
        var baseUrl = "/Tests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    testCreateChangeStreamPostTestsChangeStream: function (params, options) {
        var baseUrl = "/Tests/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    testDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testDeleteById");
        }
        var baseUrl = "/Tests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    testExistsGetTestsidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testExistsGetTestsidExists");
        }
        var baseUrl = "/Tests/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    testExistsHeadTestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testExistsHeadTestsid");
        }
        var baseUrl = "/Tests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    testFind: function (params, options) {
        var baseUrl = "/Tests";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    testFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testFindById");
        }
        var baseUrl = "/Tests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    testFindOne: function (params, options) {
        var baseUrl = "/Tests/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testPatchOrCreate: function (params, options) {
        var baseUrl = "/Tests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts questions of Test.
     * @param id Test id
     * @param where Criteria to match model instances
     */
    testPrototypeCountQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeCountQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in questions of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeCreateQuestions");
        }
        var baseUrl = "/Tests/{id}/questions".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeCreateStudentInfo");
        }
        var baseUrl = "/Tests/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExam of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateSubmitExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeCreateSubmitExam");
        }
        var baseUrl = "/Tests/{id}/submitExam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all questions of this model.
     * @param id Test id
     */
    testPrototypeDeleteQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeDeleteQuestions");
        }
        var baseUrl = "/Tests/{id}/questions".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeDestroyByIdQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeDestroyByIdQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeDestroyByIdQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes studentInfo of this model.
     * @param id Test id
     */
    testPrototypeDestroyStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeDestroyStudentInfo");
        }
        var baseUrl = "/Tests/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes submitExam of this model.
     * @param id Test id
     */
    testPrototypeDestroySubmitExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeDestroySubmitExam");
        }
        var baseUrl = "/Tests/{id}/submitExam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check the existence of questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeExistsQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeExistsQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeExistsQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeFindByIdQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeFindByIdQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeFindByIdQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetAccount: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeGetAccount");
        }
        var baseUrl = "/Tests/{id}/account".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries questions of Test.
     * @param id Test id
     * @param filter
     */
    testPrototypeGetQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeGetQuestions");
        }
        var baseUrl = "/Tests/{id}/questions".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches hasOne relation studentInfo.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeGetStudentInfo");
        }
        var baseUrl = "/Tests/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Fetches hasOne relation submitExam.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetSubmitExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeGetSubmitExam");
        }
        var baseUrl = "/Tests/{id}/submitExam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            refresh: params["refresh"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Add a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    testPrototypeLinkQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeLinkQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeLinkQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Test id
     * @param data An object of model property name/value pairs
     */
    testPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypePatchAttributes");
        }
        var baseUrl = "/Tests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Remove the questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeUnlinkQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeUnlinkQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeUnlinkQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/rel/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    testPrototypeUpdateByIdQuestions: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeUpdateByIdQuestions");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling testPrototypeUpdateByIdQuestions");
        }
        var baseUrl = "/Tests/{id}/questions/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update studentInfo of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeUpdateStudentInfo: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeUpdateStudentInfo");
        }
        var baseUrl = "/Tests/{id}/studentInfo".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update submitExam of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeUpdateSubmitExam: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testPrototypeUpdateSubmitExam");
        }
        var baseUrl = "/Tests/{id}/submitExam".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    testReplaceByIdPostTestsidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testReplaceByIdPostTestsidReplace");
        }
        var baseUrl = "/Tests/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    testReplaceByIdPutTestsid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling testReplaceByIdPutTestsid");
        }
        var baseUrl = "/Tests/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testReplaceOrCreatePostTestsReplaceOrCreate: function (params, options) {
        var baseUrl = "/Tests/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testReplaceOrCreatePutTests: function (params, options) {
        var baseUrl = "/Tests";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    testUpdateAll: function (params, options) {
        var baseUrl = "/Tests/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    testUpsertWithWhere: function (params, options) {
        var baseUrl = "/Tests/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * TestApi - functional programming interface
 */
export var TestApiFp = {
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    testCount: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    testCreate: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    testCreateChangeStreamGetTestsChangeStream: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testCreateChangeStreamGetTestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    testCreateChangeStreamPostTestsChangeStream: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testCreateChangeStreamPostTestsChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    testDeleteById: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    testExistsGetTestsidExists: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testExistsGetTestsidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    testExistsHeadTestsid: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testExistsHeadTestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    testFind: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    testFindById: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    testFindOne: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testPatchOrCreate: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts questions of Test.
     * @param id Test id
     * @param where Criteria to match model instances
     */
    testPrototypeCountQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeCountQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in questions of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeCreateQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateStudentInfo: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeCreateStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in submitExam of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeCreateSubmitExam: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeCreateSubmitExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all questions of this model.
     * @param id Test id
     */
    testPrototypeDeleteQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeDeleteQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeDestroyByIdQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeDestroyByIdQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes studentInfo of this model.
     * @param id Test id
     */
    testPrototypeDestroyStudentInfo: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeDestroyStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes submitExam of this model.
     * @param id Test id
     */
    testPrototypeDestroySubmitExam: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeDestroySubmitExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check the existence of questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeExistsQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeExistsQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeFindByIdQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeFindByIdQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetAccount: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeGetAccount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries questions of Test.
     * @param id Test id
     * @param filter
     */
    testPrototypeGetQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeGetQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches hasOne relation studentInfo.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetStudentInfo: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeGetStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Fetches hasOne relation submitExam.
     * @param id Test id
     * @param refresh
     */
    testPrototypeGetSubmitExam: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeGetSubmitExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Add a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    testPrototypeLinkQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeLinkQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Test id
     * @param data An object of model property name/value pairs
     */
    testPrototypePatchAttributes: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Remove the questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    testPrototypeUnlinkQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeUnlinkQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    testPrototypeUpdateByIdQuestions: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeUpdateByIdQuestions(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update studentInfo of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeUpdateStudentInfo: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeUpdateStudentInfo(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update submitExam of this model.
     * @param id Test id
     * @param data
     */
    testPrototypeUpdateSubmitExam: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testPrototypeUpdateSubmitExam(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    testReplaceByIdPostTestsidReplace: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testReplaceByIdPostTestsidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    testReplaceByIdPutTestsid: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testReplaceByIdPutTestsid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testReplaceOrCreatePostTestsReplaceOrCreate: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testReplaceOrCreatePostTestsReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    testReplaceOrCreatePutTests: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testReplaceOrCreatePutTests(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    testUpdateAll: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    testUpsertWithWhere: function (params, options) {
        var fetchArgs = TestApiFetchParamCreator.testUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * TestApi - object-oriented interface
 */
var TestApi = /** @class */ (function (_super) {
    __extends(TestApi, _super);
    function TestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    TestApi.prototype.testCount = function (params, options) {
        return TestApiFp.testCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    TestApi.prototype.testCreate = function (params, options) {
        return TestApiFp.testCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TestApi.prototype.testCreateChangeStreamGetTestsChangeStream = function (params, options) {
        return TestApiFp.testCreateChangeStreamGetTestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    TestApi.prototype.testCreateChangeStreamPostTestsChangeStream = function (params, options) {
        return TestApiFp.testCreateChangeStreamPostTestsChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    TestApi.prototype.testDeleteById = function (params, options) {
        return TestApiFp.testDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TestApi.prototype.testExistsGetTestsidExists = function (params, options) {
        return TestApiFp.testExistsGetTestsidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    TestApi.prototype.testExistsHeadTestsid = function (params, options) {
        return TestApiFp.testExistsHeadTestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TestApi.prototype.testFind = function (params, options) {
        return TestApiFp.testFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    TestApi.prototype.testFindById = function (params, options) {
        return TestApiFp.testFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    TestApi.prototype.testFindOne = function (params, options) {
        return TestApiFp.testFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TestApi.prototype.testPatchOrCreate = function (params, options) {
        return TestApiFp.testPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts questions of Test.
     * @param id Test id
     * @param where Criteria to match model instances
     */
    TestApi.prototype.testPrototypeCountQuestions = function (params, options) {
        return TestApiFp.testPrototypeCountQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in questions of this model.
     * @param id Test id
     * @param data
     */
    TestApi.prototype.testPrototypeCreateQuestions = function (params, options) {
        return TestApiFp.testPrototypeCreateQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in studentInfo of this model.
     * @param id Test id
     * @param data
     */
    TestApi.prototype.testPrototypeCreateStudentInfo = function (params, options) {
        return TestApiFp.testPrototypeCreateStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in submitExam of this model.
     * @param id Test id
     * @param data
     */
    TestApi.prototype.testPrototypeCreateSubmitExam = function (params, options) {
        return TestApiFp.testPrototypeCreateSubmitExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all questions of this model.
     * @param id Test id
     */
    TestApi.prototype.testPrototypeDeleteQuestions = function (params, options) {
        return TestApiFp.testPrototypeDeleteQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    TestApi.prototype.testPrototypeDestroyByIdQuestions = function (params, options) {
        return TestApiFp.testPrototypeDestroyByIdQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes studentInfo of this model.
     * @param id Test id
     */
    TestApi.prototype.testPrototypeDestroyStudentInfo = function (params, options) {
        return TestApiFp.testPrototypeDestroyStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes submitExam of this model.
     * @param id Test id
     */
    TestApi.prototype.testPrototypeDestroySubmitExam = function (params, options) {
        return TestApiFp.testPrototypeDestroySubmitExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check the existence of questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    TestApi.prototype.testPrototypeExistsQuestions = function (params, options) {
        return TestApiFp.testPrototypeExistsQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    TestApi.prototype.testPrototypeFindByIdQuestions = function (params, options) {
        return TestApiFp.testPrototypeFindByIdQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches belongsTo relation account.
     * @param id Test id
     * @param refresh
     */
    TestApi.prototype.testPrototypeGetAccount = function (params, options) {
        return TestApiFp.testPrototypeGetAccount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries questions of Test.
     * @param id Test id
     * @param filter
     */
    TestApi.prototype.testPrototypeGetQuestions = function (params, options) {
        return TestApiFp.testPrototypeGetQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches hasOne relation studentInfo.
     * @param id Test id
     * @param refresh
     */
    TestApi.prototype.testPrototypeGetStudentInfo = function (params, options) {
        return TestApiFp.testPrototypeGetStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Fetches hasOne relation submitExam.
     * @param id Test id
     * @param refresh
     */
    TestApi.prototype.testPrototypeGetSubmitExam = function (params, options) {
        return TestApiFp.testPrototypeGetSubmitExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Add a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    TestApi.prototype.testPrototypeLinkQuestions = function (params, options) {
        return TestApiFp.testPrototypeLinkQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id Test id
     * @param data An object of model property name/value pairs
     */
    TestApi.prototype.testPrototypePatchAttributes = function (params, options) {
        return TestApiFp.testPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Remove the questions relation to an item by id.
     * @param id Test id
     * @param fk Foreign key for questions
     */
    TestApi.prototype.testPrototypeUnlinkQuestions = function (params, options) {
        return TestApiFp.testPrototypeUnlinkQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for questions.
     * @param id Test id
     * @param fk Foreign key for questions
     * @param data
     */
    TestApi.prototype.testPrototypeUpdateByIdQuestions = function (params, options) {
        return TestApiFp.testPrototypeUpdateByIdQuestions(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update studentInfo of this model.
     * @param id Test id
     * @param data
     */
    TestApi.prototype.testPrototypeUpdateStudentInfo = function (params, options) {
        return TestApiFp.testPrototypeUpdateStudentInfo(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update submitExam of this model.
     * @param id Test id
     * @param data
     */
    TestApi.prototype.testPrototypeUpdateSubmitExam = function (params, options) {
        return TestApiFp.testPrototypeUpdateSubmitExam(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TestApi.prototype.testReplaceByIdPostTestsidReplace = function (params, options) {
        return TestApiFp.testReplaceByIdPostTestsidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    TestApi.prototype.testReplaceByIdPutTestsid = function (params, options) {
        return TestApiFp.testReplaceByIdPutTestsid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TestApi.prototype.testReplaceOrCreatePostTestsReplaceOrCreate = function (params, options) {
        return TestApiFp.testReplaceOrCreatePostTestsReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    TestApi.prototype.testReplaceOrCreatePutTests = function (params, options) {
        return TestApiFp.testReplaceOrCreatePutTests(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TestApi.prototype.testUpdateAll = function (params, options) {
        return TestApiFp.testUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    TestApi.prototype.testUpsertWithWhere = function (params, options) {
        return TestApiFp.testUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return TestApi;
}(BaseAPI));
export { TestApi };
/**
 * TestApi - factory interface
 */
export var TestApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        testCount: function (params, options) {
            return TestApiFp.testCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        testCreate: function (params, options) {
            return TestApiFp.testCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        testCreateChangeStreamGetTestsChangeStream: function (params, options) {
            return TestApiFp.testCreateChangeStreamGetTestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        testCreateChangeStreamPostTestsChangeStream: function (params, options) {
            return TestApiFp.testCreateChangeStreamPostTestsChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        testDeleteById: function (params, options) {
            return TestApiFp.testDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        testExistsGetTestsidExists: function (params, options) {
            return TestApiFp.testExistsGetTestsidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        testExistsHeadTestsid: function (params, options) {
            return TestApiFp.testExistsHeadTestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        testFind: function (params, options) {
            return TestApiFp.testFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        testFindById: function (params, options) {
            return TestApiFp.testFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        testFindOne: function (params, options) {
            return TestApiFp.testFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        testPatchOrCreate: function (params, options) {
            return TestApiFp.testPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts questions of Test.
         * @param id Test id
         * @param where Criteria to match model instances
         */
        testPrototypeCountQuestions: function (params, options) {
            return TestApiFp.testPrototypeCountQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in questions of this model.
         * @param id Test id
         * @param data
         */
        testPrototypeCreateQuestions: function (params, options) {
            return TestApiFp.testPrototypeCreateQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in studentInfo of this model.
         * @param id Test id
         * @param data
         */
        testPrototypeCreateStudentInfo: function (params, options) {
            return TestApiFp.testPrototypeCreateStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in submitExam of this model.
         * @param id Test id
         * @param data
         */
        testPrototypeCreateSubmitExam: function (params, options) {
            return TestApiFp.testPrototypeCreateSubmitExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all questions of this model.
         * @param id Test id
         */
        testPrototypeDeleteQuestions: function (params, options) {
            return TestApiFp.testPrototypeDeleteQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for questions.
         * @param id Test id
         * @param fk Foreign key for questions
         */
        testPrototypeDestroyByIdQuestions: function (params, options) {
            return TestApiFp.testPrototypeDestroyByIdQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes studentInfo of this model.
         * @param id Test id
         */
        testPrototypeDestroyStudentInfo: function (params, options) {
            return TestApiFp.testPrototypeDestroyStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes submitExam of this model.
         * @param id Test id
         */
        testPrototypeDestroySubmitExam: function (params, options) {
            return TestApiFp.testPrototypeDestroySubmitExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check the existence of questions relation to an item by id.
         * @param id Test id
         * @param fk Foreign key for questions
         */
        testPrototypeExistsQuestions: function (params, options) {
            return TestApiFp.testPrototypeExistsQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for questions.
         * @param id Test id
         * @param fk Foreign key for questions
         */
        testPrototypeFindByIdQuestions: function (params, options) {
            return TestApiFp.testPrototypeFindByIdQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches belongsTo relation account.
         * @param id Test id
         * @param refresh
         */
        testPrototypeGetAccount: function (params, options) {
            return TestApiFp.testPrototypeGetAccount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries questions of Test.
         * @param id Test id
         * @param filter
         */
        testPrototypeGetQuestions: function (params, options) {
            return TestApiFp.testPrototypeGetQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches hasOne relation studentInfo.
         * @param id Test id
         * @param refresh
         */
        testPrototypeGetStudentInfo: function (params, options) {
            return TestApiFp.testPrototypeGetStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Fetches hasOne relation submitExam.
         * @param id Test id
         * @param refresh
         */
        testPrototypeGetSubmitExam: function (params, options) {
            return TestApiFp.testPrototypeGetSubmitExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Add a related item by id for questions.
         * @param id Test id
         * @param fk Foreign key for questions
         * @param data
         */
        testPrototypeLinkQuestions: function (params, options) {
            return TestApiFp.testPrototypeLinkQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id Test id
         * @param data An object of model property name/value pairs
         */
        testPrototypePatchAttributes: function (params, options) {
            return TestApiFp.testPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Remove the questions relation to an item by id.
         * @param id Test id
         * @param fk Foreign key for questions
         */
        testPrototypeUnlinkQuestions: function (params, options) {
            return TestApiFp.testPrototypeUnlinkQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for questions.
         * @param id Test id
         * @param fk Foreign key for questions
         * @param data
         */
        testPrototypeUpdateByIdQuestions: function (params, options) {
            return TestApiFp.testPrototypeUpdateByIdQuestions(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update studentInfo of this model.
         * @param id Test id
         * @param data
         */
        testPrototypeUpdateStudentInfo: function (params, options) {
            return TestApiFp.testPrototypeUpdateStudentInfo(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update submitExam of this model.
         * @param id Test id
         * @param data
         */
        testPrototypeUpdateSubmitExam: function (params, options) {
            return TestApiFp.testPrototypeUpdateSubmitExam(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        testReplaceByIdPostTestsidReplace: function (params, options) {
            return TestApiFp.testReplaceByIdPostTestsidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        testReplaceByIdPutTestsid: function (params, options) {
            return TestApiFp.testReplaceByIdPutTestsid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        testReplaceOrCreatePostTestsReplaceOrCreate: function (params, options) {
            return TestApiFp.testReplaceOrCreatePostTestsReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        testReplaceOrCreatePutTests: function (params, options) {
            return TestApiFp.testReplaceOrCreatePutTests(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        testUpdateAll: function (params, options) {
            return TestApiFp.testUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        testUpsertWithWhere: function (params, options) {
            return TestApiFp.testUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
/**
 * UserApi - fetch parameter creator
 */
export var UserApiFetchParamCreator = {
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    userChangePassword: function (params, options) {
        // verify required parameter "oldPassword" is set
        if (params["oldPassword"] == null) {
            throw new Error("Missing required parameter oldPassword when calling userChangePassword");
        }
        // verify required parameter "newPassword" is set
        if (params["newPassword"] == null) {
            throw new Error("Missing required parameter newPassword when calling userChangePassword");
        }
        var baseUrl = "/Users/change-password";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            oldPassword: params["oldPassword"],
            newPassword: params["newPassword"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    userConfirm: function (params, options) {
        // verify required parameter "uid" is set
        if (params["uid"] == null) {
            throw new Error("Missing required parameter uid when calling userConfirm");
        }
        // verify required parameter "token" is set
        if (params["token"] == null) {
            throw new Error("Missing required parameter token when calling userConfirm");
        }
        var baseUrl = "/Users/confirm";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            uid: params["uid"],
            token: params["token"],
            redirect: params["redirect"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    userCount: function (params, options) {
        var baseUrl = "/Users/count";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    userCreate: function (params, options) {
        var baseUrl = "/Users";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    userCreateChangeStreamGetUsersChangeStream: function (params, options) {
        var baseUrl = "/Users/change-stream";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            options: params["options"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    userCreateChangeStreamPostUsersChangeStream: function (params, options) {
        var baseUrl = "/Users/change-stream";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            options: params["options"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    userDeleteById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userDeleteById");
        }
        var baseUrl = "/Users/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    userExistsGetUsersidExists: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userExistsGetUsersidExists");
        }
        var baseUrl = "/Users/{id}/exists".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    userExistsHeadUsersid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userExistsHeadUsersid");
        }
        var baseUrl = "/Users/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "HEAD" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    userFind: function (params, options) {
        var baseUrl = "/Users";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    userFindById: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userFindById");
        }
        var baseUrl = "/Users/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    userFindOne: function (params, options) {
        var baseUrl = "/Users/findOne";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    userLogin: function (params, options) {
        // verify required parameter "credentials" is set
        if (params["credentials"] == null) {
            throw new Error("Missing required parameter credentials when calling userLogin");
        }
        var baseUrl = "/Users/login";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            include: params["include"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["credentials"]) {
            fetchOptions.body = JSON.stringify(params["credentials"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Logout a user with access token.
     */
    userLogout: function (options) {
        var baseUrl = "/Users/logout";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userPatchOrCreate: function (params, options) {
        var baseUrl = "/Users";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Counts accessTokens of User.
     * @param id User id
     * @param where Criteria to match model instances
     */
    userPrototypeCountAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeCountAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens/count".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id User id
     * @param data
     */
    userPrototypeCreateAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeCreateAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id User id
     */
    userPrototypeDeleteAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeDeleteAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    userPrototypeDestroyByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeDestroyByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling userPrototypeDestroyByIdAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "DELETE" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    userPrototypeFindByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeFindByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling userPrototypeFindByIdAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Queries accessTokens of User.
     * @param id User id
     * @param filter
     */
    userPrototypeGetAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeGetAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            filter: params["filter"],
        });
        var fetchOptions = assign({}, { method: "GET" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id User id
     * @param data An object of model property name/value pairs
     */
    userPrototypePatchAttributes: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypePatchAttributes");
        }
        var baseUrl = "/Users/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PATCH" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    userPrototypeUpdateByIdAccessTokens: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeUpdateByIdAccessTokens");
        }
        // verify required parameter "fk" is set
        if (params["fk"] == null) {
            throw new Error("Missing required parameter fk when calling userPrototypeUpdateByIdAccessTokens");
        }
        var baseUrl = "/Users/{id}/accessTokens/{fk}"
            .replace("{" + "id" + "}", "" + params["id"])
            .replace("{" + "fk" + "}", "" + params["fk"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id User id
     */
    userPrototypeVerify: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userPrototypeVerify");
        }
        var baseUrl = "/Users/{id}/verify".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    userReplaceByIdPostUsersidReplace: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userReplaceByIdPostUsersidReplace");
        }
        var baseUrl = "/Users/{id}/replace".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    userReplaceByIdPutUsersid: function (params, options) {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling userReplaceByIdPutUsersid");
        }
        var baseUrl = "/Users/{id}".replace("{" + "id" + "}", "" + params["id"]);
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userReplaceOrCreatePostUsersReplaceOrCreate: function (params, options) {
        var baseUrl = "/Users/replaceOrCreate";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userReplaceOrCreatePutUsers: function (params, options) {
        var baseUrl = "/Users";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "PUT" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    userResetPassword: function (params, options) {
        // verify required parameter "options" is set
        if (params["options"] == null) {
            throw new Error("Missing required parameter options when calling userResetPassword");
        }
        var baseUrl = "/Users/reset";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["options"]) {
            fetchOptions.body = JSON.stringify(params["options"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    userSetPassword: function (params, options) {
        // verify required parameter "newPassword" is set
        if (params["newPassword"] == null) {
            throw new Error("Missing required parameter newPassword when calling userSetPassword");
        }
        var baseUrl = "/Users/reset-password";
        var urlObj = url.parse(baseUrl, true);
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        fetchOptions.body = querystring.stringify({
            newPassword: params["newPassword"],
        });
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    userUpdateAll: function (params, options) {
        var baseUrl = "/Users/update";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    userUpsertWithWhere: function (params, options) {
        var baseUrl = "/Users/upsertWithWhere";
        var urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            where: params["where"],
        });
        var fetchOptions = assign({}, { method: "POST" }, options);
        var contentTypeHeader = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["data"]) {
            fetchOptions.body = JSON.stringify(params["data"] || {});
        }
        if (contentTypeHeader) {
            fetchOptions.headers = assign({}, contentTypeHeader, fetchOptions.headers);
        }
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};
/**
 * UserApi - functional programming interface
 */
export var UserApiFp = {
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    userChangePassword: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userChangePassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    userConfirm: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userConfirm(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    userCount: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userCount(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    userCreate: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    userCreateChangeStreamGetUsersChangeStream: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userCreateChangeStreamGetUsersChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    userCreateChangeStreamPostUsersChangeStream: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userCreateChangeStreamPostUsersChangeStream(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    userDeleteById: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userDeleteById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    userExistsGetUsersidExists: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userExistsGetUsersidExists(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    userExistsHeadUsersid: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userExistsHeadUsersid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    userFind: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userFind(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    userFindById: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userFindById(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    userFindOne: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userFindOne(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    userLogin: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userLogin(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Logout a user with access token.
     */
    userLogout: function (options) {
        var fetchArgs = UserApiFetchParamCreator.userLogout(options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userPatchOrCreate: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPatchOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Counts accessTokens of User.
     * @param id User id
     * @param where Criteria to match model instances
     */
    userPrototypeCountAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeCountAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id User id
     * @param data
     */
    userPrototypeCreateAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeCreateAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id User id
     */
    userPrototypeDeleteAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeDeleteAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    userPrototypeDestroyByIdAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeDestroyByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    userPrototypeFindByIdAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeFindByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Queries accessTokens of User.
     * @param id User id
     * @param filter
     */
    userPrototypeGetAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeGetAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id User id
     * @param data An object of model property name/value pairs
     */
    userPrototypePatchAttributes: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypePatchAttributes(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    userPrototypeUpdateByIdAccessTokens: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeUpdateByIdAccessTokens(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id User id
     */
    userPrototypeVerify: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userPrototypeVerify(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    userReplaceByIdPostUsersidReplace: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userReplaceByIdPostUsersidReplace(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    userReplaceByIdPutUsersid: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userReplaceByIdPutUsersid(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userReplaceOrCreatePostUsersReplaceOrCreate: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userReplaceOrCreatePostUsersReplaceOrCreate(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    userReplaceOrCreatePutUsers: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userReplaceOrCreatePutUsers(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    userResetPassword: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userResetPassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    userSetPassword: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userSetPassword(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    userUpdateAll: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userUpdateAll(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    userUpsertWithWhere: function (params, options) {
        var fetchArgs = UserApiFetchParamCreator.userUpsertWithWhere(params, options);
        return function (fetch, basePath) {
            if (fetch === void 0) { fetch = isomorphicFetch; }
            if (basePath === void 0) { basePath = BASE_PATH; }
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function (response) {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    throw response;
                }
            });
        };
    },
};
/**
 * UserApi - object-oriented interface
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Change a user's password.
     * @param oldPassword
     * @param newPassword
     */
    UserApi.prototype.userChangePassword = function (params, options) {
        return UserApiFp.userChangePassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Confirm a user registration with identity verification token.
     * @param uid
     * @param token
     * @param redirect
     */
    UserApi.prototype.userConfirm = function (params, options) {
        return UserApiFp.userConfirm(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Count instances of the model matched by where from the data source.
     * @param where Criteria to match model instances
     */
    UserApi.prototype.userCount = function (params, options) {
        return UserApiFp.userCount(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a new instance of the model and persist it into the data source.
     * @param data Model instance data
     */
    UserApi.prototype.userCreate = function (params, options) {
        return UserApiFp.userCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    UserApi.prototype.userCreateChangeStreamGetUsersChangeStream = function (params, options) {
        return UserApiFp.userCreateChangeStreamGetUsersChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Create a change stream.
     * @param options
     */
    UserApi.prototype.userCreateChangeStreamPostUsersChangeStream = function (params, options) {
        return UserApiFp.userCreateChangeStreamPostUsersChangeStream(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a model instance by {{id}} from the data source.
     * @param id Model id
     */
    UserApi.prototype.userDeleteById = function (params, options) {
        return UserApiFp.userDeleteById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    UserApi.prototype.userExistsGetUsersidExists = function (params, options) {
        return UserApiFp.userExistsGetUsersidExists(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Check whether a model instance exists in the data source.
     * @param id Model id
     */
    UserApi.prototype.userExistsHeadUsersid = function (params, options) {
        return UserApiFp.userExistsHeadUsersid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find all instances of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    UserApi.prototype.userFind = function (params, options) {
        return UserApiFp.userFind(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a model instance by {{id}} from the data source.
     * @param id Model id
     * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
     */
    UserApi.prototype.userFindById = function (params, options) {
        return UserApiFp.userFindById(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find first instance of the model matched by filter from the data source.
     * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
     */
    UserApi.prototype.userFindOne = function (params, options) {
        return UserApiFp.userFindOne(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Login a user with username/email and password.
     * @param credentials
     * @param include Related objects to include in the response. See the description of return value for more details.
     */
    UserApi.prototype.userLogin = function (params, options) {
        return UserApiFp.userLogin(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Logout a user with access token.
     */
    UserApi.prototype.userLogout = function (options) {
        return UserApiFp.userLogout(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    UserApi.prototype.userPatchOrCreate = function (params, options) {
        return UserApiFp.userPatchOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Counts accessTokens of User.
     * @param id User id
     * @param where Criteria to match model instances
     */
    UserApi.prototype.userPrototypeCountAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeCountAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Creates a new instance in accessTokens of this model.
     * @param id User id
     * @param data
     */
    UserApi.prototype.userPrototypeCreateAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeCreateAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Deletes all accessTokens of this model.
     * @param id User id
     */
    UserApi.prototype.userPrototypeDeleteAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeDeleteAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Delete a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    UserApi.prototype.userPrototypeDestroyByIdAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeDestroyByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Find a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     */
    UserApi.prototype.userPrototypeFindByIdAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeFindByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Queries accessTokens of User.
     * @param id User id
     * @param filter
     */
    UserApi.prototype.userPrototypeGetAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeGetAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Patch attributes for a model instance and persist it into the data source.
     * @param id User id
     * @param data An object of model property name/value pairs
     */
    UserApi.prototype.userPrototypePatchAttributes = function (params, options) {
        return UserApiFp.userPrototypePatchAttributes(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update a related item by id for accessTokens.
     * @param id User id
     * @param fk Foreign key for accessTokens
     * @param data
     */
    UserApi.prototype.userPrototypeUpdateByIdAccessTokens = function (params, options) {
        return UserApiFp.userPrototypeUpdateByIdAccessTokens(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Trigger user's identity verification with configured verifyOptions
     * @param id User id
     */
    UserApi.prototype.userPrototypeVerify = function (params, options) {
        return UserApiFp.userPrototypeVerify(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    UserApi.prototype.userReplaceByIdPostUsersidReplace = function (params, options) {
        return UserApiFp.userReplaceByIdPostUsersidReplace(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace attributes for a model instance and persist it into the data source.
     * @param id Model id
     * @param data Model instance data
     */
    UserApi.prototype.userReplaceByIdPutUsersid = function (params, options) {
        return UserApiFp.userReplaceByIdPutUsersid(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    UserApi.prototype.userReplaceOrCreatePostUsersReplaceOrCreate = function (params, options) {
        return UserApiFp.userReplaceOrCreatePostUsersReplaceOrCreate(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Replace an existing model instance or insert a new one into the data source.
     * @param data Model instance data
     */
    UserApi.prototype.userReplaceOrCreatePutUsers = function (params, options) {
        return UserApiFp.userReplaceOrCreatePutUsers(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Reset password for a user with email.
     * @param options
     */
    UserApi.prototype.userResetPassword = function (params, options) {
        return UserApiFp.userResetPassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Reset user's password via a password-reset token.
     * @param newPassword
     */
    UserApi.prototype.userSetPassword = function (params, options) {
        return UserApiFp.userSetPassword(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update instances of the model matched by {{where}} from the data source.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    UserApi.prototype.userUpdateAll = function (params, options) {
        return UserApiFp.userUpdateAll(params, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
     * @param where Criteria to match model instances
     * @param data An object of model property name/value pairs
     */
    UserApi.prototype.userUpsertWithWhere = function (params, options) {
        return UserApiFp.userUpsertWithWhere(params, options)(this.fetch, this.basePath);
    };
    return UserApi;
}(BaseAPI));
export { UserApi };
/**
 * UserApi - factory interface
 */
export var UserApiFactory = function (fetch, basePath) {
    return {
        /**
         *
         * @summary Change a user's password.
         * @param oldPassword
         * @param newPassword
         */
        userChangePassword: function (params, options) {
            return UserApiFp.userChangePassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Confirm a user registration with identity verification token.
         * @param uid
         * @param token
         * @param redirect
         */
        userConfirm: function (params, options) {
            return UserApiFp.userConfirm(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Count instances of the model matched by where from the data source.
         * @param where Criteria to match model instances
         */
        userCount: function (params, options) {
            return UserApiFp.userCount(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new instance of the model and persist it into the data source.
         * @param data Model instance data
         */
        userCreate: function (params, options) {
            return UserApiFp.userCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        userCreateChangeStreamGetUsersChangeStream: function (params, options) {
            return UserApiFp.userCreateChangeStreamGetUsersChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a change stream.
         * @param options
         */
        userCreateChangeStreamPostUsersChangeStream: function (params, options) {
            return UserApiFp.userCreateChangeStreamPostUsersChangeStream(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a model instance by {{id}} from the data source.
         * @param id Model id
         */
        userDeleteById: function (params, options) {
            return UserApiFp.userDeleteById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        userExistsGetUsersidExists: function (params, options) {
            return UserApiFp.userExistsGetUsersidExists(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check whether a model instance exists in the data source.
         * @param id Model id
         */
        userExistsHeadUsersid: function (params, options) {
            return UserApiFp.userExistsHeadUsersid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find all instances of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        userFind: function (params, options) {
            return UserApiFp.userFind(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a model instance by {{id}} from the data source.
         * @param id Model id
         * @param filter Filter defining fields and include - must be a JSON-encoded string ({\&quot;something\&quot;:\&quot;value\&quot;})
         */
        userFindById: function (params, options) {
            return UserApiFp.userFindById(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find first instance of the model matched by filter from the data source.
         * @param filter Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (&#x60;{\&quot;where\&quot;:{\&quot;something\&quot;:\&quot;value\&quot;}}&#x60;).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
         */
        userFindOne: function (params, options) {
            return UserApiFp.userFindOne(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Login a user with username/email and password.
         * @param credentials
         * @param include Related objects to include in the response. See the description of return value for more details.
         */
        userLogin: function (params, options) {
            return UserApiFp.userLogin(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Logout a user with access token.
         */
        userLogout: function (options) {
            return UserApiFp.userLogout(options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        userPatchOrCreate: function (params, options) {
            return UserApiFp.userPatchOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Counts accessTokens of User.
         * @param id User id
         * @param where Criteria to match model instances
         */
        userPrototypeCountAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeCountAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates a new instance in accessTokens of this model.
         * @param id User id
         * @param data
         */
        userPrototypeCreateAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeCreateAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes all accessTokens of this model.
         * @param id User id
         */
        userPrototypeDeleteAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeDeleteAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete a related item by id for accessTokens.
         * @param id User id
         * @param fk Foreign key for accessTokens
         */
        userPrototypeDestroyByIdAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeDestroyByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Find a related item by id for accessTokens.
         * @param id User id
         * @param fk Foreign key for accessTokens
         */
        userPrototypeFindByIdAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeFindByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Queries accessTokens of User.
         * @param id User id
         * @param filter
         */
        userPrototypeGetAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeGetAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch attributes for a model instance and persist it into the data source.
         * @param id User id
         * @param data An object of model property name/value pairs
         */
        userPrototypePatchAttributes: function (params, options) {
            return UserApiFp.userPrototypePatchAttributes(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update a related item by id for accessTokens.
         * @param id User id
         * @param fk Foreign key for accessTokens
         * @param data
         */
        userPrototypeUpdateByIdAccessTokens: function (params, options) {
            return UserApiFp.userPrototypeUpdateByIdAccessTokens(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Trigger user's identity verification with configured verifyOptions
         * @param id User id
         */
        userPrototypeVerify: function (params, options) {
            return UserApiFp.userPrototypeVerify(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        userReplaceByIdPostUsersidReplace: function (params, options) {
            return UserApiFp.userReplaceByIdPostUsersidReplace(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace attributes for a model instance and persist it into the data source.
         * @param id Model id
         * @param data Model instance data
         */
        userReplaceByIdPutUsersid: function (params, options) {
            return UserApiFp.userReplaceByIdPutUsersid(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        userReplaceOrCreatePostUsersReplaceOrCreate: function (params, options) {
            return UserApiFp.userReplaceOrCreatePostUsersReplaceOrCreate(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace an existing model instance or insert a new one into the data source.
         * @param data Model instance data
         */
        userReplaceOrCreatePutUsers: function (params, options) {
            return UserApiFp.userReplaceOrCreatePutUsers(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reset password for a user with email.
         * @param options
         */
        userResetPassword: function (params, options) {
            return UserApiFp.userResetPassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reset user's password via a password-reset token.
         * @param newPassword
         */
        userSetPassword: function (params, options) {
            return UserApiFp.userSetPassword(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update instances of the model matched by {{where}} from the data source.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        userUpdateAll: function (params, options) {
            return UserApiFp.userUpdateAll(params, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update an existing model instance or insert a new one into the data source based on the where criteria.
         * @param where Criteria to match model instances
         * @param data An object of model property name/value pairs
         */
        userUpsertWithWhere: function (params, options) {
            return UserApiFp.userUpsertWithWhere(params, options)(fetch, basePath);
        },
    };
};
